import React from "react";
import request from "arcdynamic-request";
import { dateUStoISO, dateISOtoUS, dateToUsString, stringUStoISO, dateToTimestamp } from "../../date-converter";
import { browserHistory } from "react-router";
import SellerDrawer from "../SellerDrawer/SellerDrawer";
import BuyerDrawer from "../BuyerDrawer/BuyerDrawer";
import FirmDrawer from "../FirmDrawer/FirmDrawer";
import AgentDrawer from "../AgentDrawer/AgentDrawer";
import ReminderPropertyDialog from "./ReminderPropertyDialog";
import Drawer from "../Drawer";
import { viewDateTimeFormat, compareDates, getCurrentTrancheOnGrossAmount, removeDuplicateObjects, removeKeysFromObject, percent, addCommasToNumber, getAgentContribution, isPeakTeamMember1, normalizePeakEmail, reorderLoanQuotes, withLoanOptionLabels, isLoanOption } from "../../utils";
import { mergePropertySingletonRows } from '../../utils/mergePropertySingletonRows';
import { matchLenderByName } from '../../utils/matchLenderByName';
import { geocodeAddress, hasValidCoords } from "../../utils/geocode";
import {
    GET_ALL_TENANTS,
    PROPERTY_UNDERWRITING_TENANTS,
    ESCROW_TRACKING,
    PROPERTY_DATA,
    GET_PROPERTY_HISTORY,
    GET_AGENT_GROSS_CUMULATIVE,
    HSC_AGENT_CUMULATIVE,
    GET_PAYMENT_PROPERTIES,
    PROPERTIES_ADDRESS,
    HOTLIST_PROPERTIES_BY_EMAIL,
    GET_PROPERTY_ACCOUNT_NUMBER,
    GET_PROPERTY_CONTRACT_INFO,
    GET_PROPERTY_OWNERSHIPS,
    GET_OWNERSHIP_INVESTORS,
    UNDERWRITING_TENANT_LIST
} from "../../consts/queries";
import {
    AGENT_COMMISSION_PAID,
    AGENT_COMMISSION_PROCURED
} from '../../consts/queries';

import {
    AGENTS,
    LENDERS,
    PROPERTIES,
    SUMMIT_ESCROW_TRACKING,
    SELLERS,
    HSC_TRACKING,
    PROPERTY_HISTORY,
    HSC_LOAN_QUOTES,
    PROPERTY_PAYMENT_TEAM,
    PROPERTY_LOAN_NOTES,
    PROPERTY_NOTES,
    PROPOSAL,
    HOT_LIST,
    NEW_DEVELOPMENT,
    NEW_DEVELOPMENT_HISTORY,
    NEED_OWNER,
    REFERRING_OUTSIDE_AGENT,
    LEAD_LINKS,
    PROPERTY_ACCOUNT_NUMBERS,
    PROPERTY_CONTRACT_INFO,
    FEATURED_ACTIVATED_LOG,
    TERRITORY_CITIES_V2,
    MARKETS,
    PROPERTY_OWNERSHIP,
    PROPERTY_OWNERSHIP_INVESTORS,
    UNDERWRITING_SINGLE_TENANT,
    UNDERWRITING_MULTI_TENANT,
    UNDERWRITING_RENT_SCHEDULE,
    UNDERWRITING_PARCELS,
    UNDERWRITING_EXPENSES_CAMS,
    UNDERWRITING_TENANT_TYPES,
    PRICING_ANALYSIS,
    TEAM
} from "../../consts/tables";
import { pickPropertyForEmailNotifications, syncPropertyEmailNotifications } from "../../requests/emailRequests";
import { url, summitFirmId } from "../../consts/env";
import PropertyInfo from "./components/PropertyInfo";
import PropertyNotesModal from "./components/PropertyNotesModal";
import OwnershipInfo from "./components/OwnershipInfo";
import PendingOwnerNotice from "./components/PendingOwnerNotice";
import RepresentationAgreement from "./components/RepresentationAgreement";
import PropertyFinancials from "./components/PropertyFinancials";
import InNegotiationUnderContract from "./components/InNegotiationUnderContract";
import Financials from "../Financials";
import Website from "./components/Website";
import SaleInformation from "./components/SaleInformation";
import CRUD from "../CRUD";
import { executeQuery } from "../../requests/executeQuery";
import { executeBackendQuery } from "../../requests/executeBackendQuery";
import { getData, manageData } from "../../requests/CRUD";
import { mapApi } from "../../requests/api";
import { clearParcelHandoff, readParcelHandoff } from "../../utils/parcelHandoff";
import ListingAgent from "./components/ListingAgent";
import BuysideAgent from "./components/BuysideAgent";
import Dropdown from "../Dropdown/Dropdown";
import Loan from "./components/Loan";
import { pmtFunction } from "../UnderwritingSingleTenant/single-tenant-tables/constants";
import LenderDrawer from "../LenderDrawer/LenderDrawer";
import PropertyHistory from "./components/PropertyHistory";
import { CurrentHistoryModel, PropertyHistoryModel } from "../../models";
import PropertyPayments from "./components/PropertyPayments";
import { historyWeights, maxHscMembers, maxSummitMembers } from "../../consts/consts";
import LoanQuotes from "./components/LoanQuotes";
import Modal from "../Modal";
import { getHSCCumulativeAgentPercent, getHSCCumulativeThreshold, getPaymentPercentage, getPaymentThreshold, insertCurrentDataToSortedArray, formatAddress } from "../../utils";
import shallowEqual from "shallowequal";
import filter from "../../filter";
import dollars from "../../dollar-format";

const zipCodeCache = {};
const zipLookupCity = (city) => (/^mc\s*kinney$/i.test(String(city || '').trim()) ? 'McKinney' : city);
import hscTeamMembers from "../../hsc-team-members";
import Proposal from "./components/Proposal";
import { Button, Dialog, DialogActions, DialogTitle } from "@material-ui/core";
import moment from "moment";
import axios from "axios";
import { propertyResearchedApi } from "../../requests/api";
import { PROPERTY_COLUMNS, PROPOSAL_COLUMNS } from "./components/Columns";
import PopupDialog from "../PopupDialog/PopupDialog";
import { getCurrentAccess, can } from "../../access";
import { getPropertyEditLocks, isFieldLocked, isValueBlocked, changedSoftLockedFields, isAgentOnProperty, editsEverySummitRecord, editsOwnSummitDealsOnly, PRICE_DERIVED_FIELDS } from "../../access-levels";

let cloneDeep = require("lodash.clonedeep");
let find = require("lodash.find");

const defaultVisibleTenants = 5;
const loanQuotesColumnsNumber = 6;
const minStriveMembers = 7;
const minReferralMembers = 3;
const HISTORY_FINANCIALS_NOTE_PREFIX = "__FINANCIAL_HISTORY_SNAPSHOT__";
const HISTORY_FINANCIALS_NOTE_CHUNK_SIZE = 1000;

const hscAgentsKeys = [
    'HSC_TEAM_MEMBER_1',
    'HSC_TEAM_MEMBER_2'
]

const lqPriceProps = [
    "PURCHASE_PRICE",
    "DOWN_PAYMENT",
    "LOAN_AMOUNT",
    "LOAN_PAYMENT_MONTHLY",
    "LOAN_PAYMENT_ANNUALLY",
    "NOI",
    "NOI_MULTIPLIED",
    "CASH_FLOW_MONTHLY",
    "CASH_FLOW_ANNUALLY"
];

/** Anything not listed keeps two. Down payment carries four so a round dollar
 *  figure survives the round trip through the percentage. */
const lqPercentDecimals = {
    INTEREST_RATE: 3,
    DOWN_PAYMENT_PERCENT: 4,
};

const lqPercentProps = [
    "DOWN_PAYMENT_PERCENT",
    "CAP_RATE",
    "INTEREST_RATE",
    "CASH_ON_CASH",
    "DEBT_YIELD",
    "TOTAL_ORIGNATION_FEE"
];

const lqcheckboxProps = [
    "IS_PRINTABLE"
]

/** What a loan quote column starts with once its checkbox is ticked. */
const loanQuoteDefaults = {
    DOWN_PAYMENT_PERCENT: '40',
    LOAN_TERM: '5',
    MATURITY: '5',
    AMORTIZATION: '25',
    PREPAYMENT_PENALTY: 'Step Down (Soft)',
    RECOURSE: 'Yes',
    TOTAL_ORIGINATION_FEE: '1.5',
};

/** The keys that identify a loan quote row rather than describe the quote. */
const lqIdentityKeys = [
    "ARCIMEDES_ROW_ID",
    "ARCIMEDES_CREATED",
    "ARCIMEDES_CREATED_BY",
    "ARCIMEDES_MODIFIED",
    "ARCIMEDES_MODIFIED_BY",
    "PROPERTY_ID",
    "LOAN_QUOTES_ORDER",
    "PRINT_PAGE_NUMBER",
    "IS_PRINTABLE",
    "AUTOPOPULATE",
    "DELETED",
    "LOAN_QUOTES_MODIFIED",
];

/** Every quote row a user types into; the derived rows follow from these. */
const lqInputKeys = [
    "PURCHASE_PRICE",
    "DOWN_PAYMENT_PERCENT",
    "LOAN_AMOUNT",
    "INTEREST_RATE",
    "AMORTIZATION",
    "NOI",
    "NOI_PERCENTAGE",
];

const priceProps = [
    "SQFT",
    "LIST_PRICE",
    "SOLD_PRICE",
    "NET_OPERATING_INCOME",
    "DOWN_PAYMENT",
    "TOTAL_FEE",
    "PRICE_PER_SQFT",
    "RENT_PER_SQFT",
    "CLOSE_PRICE_PER_SQFT",
    "CLOSE_NOI",
    "NEGOTIATION_PRICE",
    "POTENTIAL_FEE",
    "NEGOTIATION_PRICE_PER_SQFT",
    "BASE_RENT",
    "LIST_FEE",
    "BUYSIDE_FEE",
    "REFERRAL_FEE",
    "HSC_PRICE",
    "HSC_TOTAL_FEE",
    "HSC_LIST_FEE",
    "LOAN_AMOUNT",
    "ANNUAL_LOAN_PAYMENT",
    "CASH_FLOW",
    "CREDITS_AT_CLOSING",
    "REFERRAL",
    "BANK_BONUS",
    "PROFORMA_NOI",
    "PROFORMA_BASE_RENT",
    "ASSESSED_VALUE",
    "TRANS_PRICE"
];

const percentProps = [
    "VACANCY",
    "CAPITALIZATION_RATE",
    "SELLER_FEE_PERCENTAGE",
    "CLOSE_CAP_RATE",
    "NEGOTIATION_CAP_RATE",
    "LTV",
    "INTEREST_RATE",
    "CASH_ON_CASH",
    "DSCR",
    "REFERRAL_PERCENT",
    "BANK_BONUS_PERCENT",
    "HSC_FEE_PERCENTAGE",
    "NOI_PERCENT",
    "PROFORMA_CAP_RATE"
];

const dateProps = [
    "LISTED_DATE",
    "EXPIRATION_DATE",
    "LEASE_COMMENCEMENT_DATE",
    "LEASE_EXPIRATION_DATE",
    "CLOSE_OF_ESCROW",
    "LOAN_CLOSING_DATE",
    "DATE_REMOVED",
    "DATE_CREATED",
    "LAST_MODIFIED_DATE",
    "PROPOSAL_DATE",
    "MATURITY_DATE",
    "HSC_LISTED_DATE",
    "HSC_EXPIRATION_DATE",
    "TRANS_DATE",
];

const checkboxProps = [
    "HIDE_FINANCIALS",
    "IS_PROFORMA_PRICING",
    "FEATURED",
    "VISIBLE",
    "HSC_FINANCING",
    "HSC_APPROVED",
    "OTHER_FINANCING",
    "HOT_LIST",
    "CORE_PROPERTY",
    "NEED_INFO",
    "NEW_DEVELOPMENT",
];

const agentKeyPercents = [
    "LISTING_AGENT_1_PERCENT",
    "LISTING_AGENT_2_PERCENT",
    "LISTING_AGENT_3_PERCENT",
    "LISTING_AGENT_4_PERCENT",
    "BUYER_AGENT_1_PERCENT",
    "BUYER_AGENT_2_PERCENT",
    "BUYER_AGENT_3_PERCENT",
    "BUYER_AGENT_4_PERCENT",
];

const sellerKeys = [
    "FIRST_NAME",
    "LAST_NAME",
    "PHONE",
    "EMAIL",
    "PROFILE",
    "NOTES",
    "COMPANY_NAME",
    "COMPANY_ADDRESS",
    "COMPANY_CITY",
    "COMPANY_STATE",
    "COMPANY_ZIP",
];

const excludedKeys = [
    'LISTING_AGENT_1_FIRST_NAME',
    'LISTING_AGENT_1_LAST_NAME',
    'LISTING_AGENT_2_FIRST_NAME',
    'LISTING_AGENT_2_LAST_NAME',
    'LISTING_AGENT_3_FIRST_NAME',
    'LISTING_AGENT_3_LAST_NAME',
    'LISTING_AGENT_4_FIRST_NAME',
    'LISTING_AGENT_4_LAST_NAME',
    'LISTING_AGENT_FIRM_NAME',
    'BUYER_FIRST_NAME',
    'BUYER_LAST_NAME',
    'SALE_LEASE_BACK',
    'ORIGINAL_LEASE_TERM'
];

const paymentsPercentProps = [
    'STRIVE_TEAM_MEMBER_PERCENT',
    'STRIVE_TEAM_MEMBER_NET_PERCENT',
];

const paymentsPriceProps = [
    'STRIVE_TEAM_MEMBER_NET_FEE',
    'STRIVE_TEAM_MEMBER_GROSS_FEE',
];
const buyer_agent4_firmvalue = summitFirmId;

export function pricePerFoot(priceStr, sqftStr, doller = false) {
    const price = priceToNumber(priceStr);
    const sqft = priceToNumber(sqftStr);
    if (price && sqft) {
        let value = (Math.round((price / sqft) * 100) / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        return doller ? value ? `$${value}` : '' : value;
    } else {
        return "";
    }
}

function rentPerFoot(priceStr, sqftStr, occupancyStr) {
    if (priceStr && sqftStr && occupancyStr) {
        const price = priceToNumber(priceStr);
        const sqft = priceToNumber(sqftStr);
        const occupancy = percentToNumber(occupancyStr);

        if (price && sqft && occupancy) {
            return (Math.round((price / (sqft * (occupancy / 100))) * 100) / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        }
    }

    return "";
}

function percentToNumber(str) {
    if (typeof str === "string") {
        str = str.trim().replace(/,/g, "").replace(/%$/, "");
        const num = Number(str);
        if (str && num === num) {
            // !isNaN
            return num;
        }
    }
    return false;
}

function percentToString(str) {
    if (typeof str === "string") {
        str = str.trim().replace(/,/g, "").replace(/%$/, "");
        return str;
    }
    return false;
}

export function priceToNumber(str) {
    if (typeof str === "string") {
        str = str.trim().replace(/\$|,/g, "");
        const num = Number(str);
        if (str && num === num) {
            // !isNaN
            return num;
        }
    }
    return false;
}

export function priceToString(str) {
    if (typeof str === "string") {
        str = str.trim().replace(/\$|,/g, "");
        return str;
    }
    return false;
}

/** A loan quote figure as a number, whether it arrives formatted or raw. */
function quoteFigure(value) {
    if (value === null || value === undefined || value === "") {
        return null;
    }
    const num = typeof value === "string"
        ? Number(value.trim().replace(/\$|,/g, "").replace(/%$/, ""))
        : Number(value);

    return num === num ? num : null;
}

/**
 * Down Payment ($) is Purchase Price * Down Payment (%), and Loan Amount is what
 * the price leaves once that is out.
 *
 * Every place that answers this question calls here. Values reach them either as
 * numbers or as comma-formatted strings, so both are parsed rather than
 * multiplied straight — "4,700,000" * 36 is NaN.
 *
 * A figure that cannot be derived is left exactly as it is: a quote with no
 * percentage keeps the down payment somebody entered, and nothing else can put
 * that back now the field is read-only.
 */
function deriveLoanQuoteFigures(quote) {
    const price = quoteFigure(quote.PURCHASE_PRICE);
    const percent = quoteFigure(quote.DOWN_PAYMENT_PERCENT);

    if (!price) {
        return;
    }

    if (percent !== null) {
        quote.DOWN_PAYMENT = Math.round(price * percent / 100);
    }

    const downPayment = quoteFigure(quote.DOWN_PAYMENT);

    if (downPayment !== null) {
        quote.LOAN_AMOUNT = price - downPayment;
    }
}

/**
 * The reverse of deriveLoanQuoteFigures: a Loan Amount somebody typed fixes
 * Down Payment ($) as what the price leaves, and the percentage follows from
 * that. Four decimals so the percentage lands back on the same dollar figure.
 */
function deriveDownPaymentFromLoanAmount(quote) {
    const price = quoteFigure(quote.PURCHASE_PRICE);
    const loanAmount = quoteFigure(quote.LOAN_AMOUNT);

    if (!price || loanAmount === null) {
        return;
    }

    quote.DOWN_PAYMENT = price - loanAmount;
    quote.DOWN_PAYMENT_PERCENT = Number((quote.DOWN_PAYMENT / price * 100).toFixed(4));
}

/** A Down Payment ($) somebody typed: the percentage and the loan follow it. */
function deriveFromDownPayment(quote) {
    const price = quoteFigure(quote.PURCHASE_PRICE);
    const downPayment = quoteFigure(quote.DOWN_PAYMENT);

    if (!price || downPayment === null) {
        return;
    }

    quote.DOWN_PAYMENT_PERCENT = Number((downPayment / price * 100).toFixed(4));
    quote.LOAN_AMOUNT = price - downPayment;
}

function isBlankQuoteValue(value) {
    return value === null || value === undefined || value === '';
}

function isInterestOnly(amortization) {
    return /^interest\s*on/i.test(String(amortization || '').trim());
}

/**
 * The property figure a quote's price row starts from. A purchase quotes the
 * negotiated price (Summit) or the financing price (Peak). A Refi or a
 * Construction loan has no purchase: the row is the estimated appraised value,
 * which the property carries as its financing price.
 */
function loanQuotePriceFromProperty(propData) {
    const isRefi = ['Refi', 'Construction'].includes(propData.LOAN_TYPE);
    const [primary, fallback] = isRefi || propData.SOURCE === 'HSC'
        ? [propData.HSC_PRICE, propData.NEGOTIATION_PRICE]
        : [propData.NEGOTIATION_PRICE, propData.HSC_PRICE];

    return !isBlankQuoteValue(primary) ? primary : (!isBlankQuoteValue(fallback) ? fallback : null);
}

function loanQuoteNoiFromProperty(propData) {
    return propData.IS_PROFORMA_PRICING ? propData.PROFORMA_NOI : propData.NET_OPERATING_INCOME;
}

/** The property's NOI % is a DECIMAL ("90.0000"); the quote row is a whole number. */
function loanQuoteNoiPercentFromProperty(propData) {
    return quoteFigure(propData.NOI_PERCENT);
}

/**
 * Ticking a column's checkbox fills it in: price, NOI and NOI % from the
 * property, the usual starting terms, and the rest derived. Nothing already in
 * the column is overwritten.
 */
function fillLoanQuoteFromProperty(quote, propData) {
    const fillIfEmpty = (key, value) => {
        if (isBlankQuoteValue(quote[key]) && !isBlankQuoteValue(value)) {
            quote[key] = value;
        }
    };

    fillIfEmpty('PURCHASE_PRICE', loanQuotePriceFromProperty(propData));
    fillIfEmpty('NOI', loanQuoteNoiFromProperty(propData));
    fillIfEmpty('NOI_PERCENTAGE', loanQuoteNoiPercentFromProperty(propData));
    Object.keys(loanQuoteDefaults).forEach((key) => fillIfEmpty(key, loanQuoteDefaults[key]));

    recalculateLoanQuote(quote, lqInputKeys);
}

/**
 * A column that follows the property's figures: one ticked to print, or one
 * that already holds a quote. A blank column stays blank until it is ticked.
 */
function isLiveLoanQuote(quote) {
    return !!quote && (!!quote.IS_PRINTABLE || isLoanOption(quote));
}

/**
 * The Loan Info payment rows an approved quote pins: the quote's own figures,
 * formatted the way Loan Info shows them.
 */
function approvedQuotePaymentFigures(quote) {
    const fmt = (value, decimals) => {
        const n = typeof value === 'number' ? value : priceToNumber(value);
        return n === false || n == null ? '' : Number(n).toLocaleString(undefined, { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
    };

    return {
        ANNUAL_LOAN_PAYMENT: fmt(quote.LOAN_PAYMENT_ANNUALLY, 0),
        CASH_FLOW: fmt(quote.CASH_FLOW_ANNUALLY, 0),
        CASH_ON_CASH: fmt(quote.CASH_ON_CASH, 2),
        DSCR: fmt(quote.DSCR, 2),
    };
}

/**
 * Recompute the derived rows of a quote after the rows in `changedKeys` moved.
 * Only what follows from a changed row is touched, so a figure somebody typed
 * over a derived row (an annual payment a lender quoted, say) survives edits
 * elsewhere in the column.
 */
function recalculateLoanQuote(quote, changedKeys) {
    const changed = new Set(changedKeys);
    const figure = (value) => (typeof value === 'string' ? priceToNumber(value) : value);
    let downPaymentChanged = false, loanAmountChanged = false, annualLoanPaymentChanged = false, annualCashFlowChanged = false;

    if (changed.has('PURCHASE_PRICE') || changed.has('DOWN_PAYMENT_PERCENT')) {
        deriveLoanQuoteFigures(quote);
        downPaymentChanged = true;
        loanAmountChanged = true;
    }

    if (changed.has('LOAN_AMOUNT')) {
        deriveDownPaymentFromLoanAmount(quote);
        downPaymentChanged = true;
    }

    if (changed.has('DOWN_PAYMENT')) {
        deriveFromDownPayment(quote);
        downPaymentChanged = true;
        loanAmountChanged = true;
    }

    if (changed.has('INTEREST_RATE') || changed.has('AMORTIZATION') || changed.has('LOAN_AMOUNT') || loanAmountChanged) {
        const interestRate = percentToNumber(quote.INTEREST_RATE);
        const amortization = isNaN(Number(quote.AMORTIZATION)) ? 0 : Number(quote.AMORTIZATION);
        const loanAmount = figure(quote.LOAN_AMOUNT);
        const interestOnly = amortization == 0 && interestRate && loanAmount;
        quote.LOAN_PAYMENT_ANNUALLY = interestRate && amortization && loanAmount ? Math.round(-pmtFunction(interestRate / 100 / 12, amortization * 11.8, loanAmount) * 12) : interestOnly ? Math.round(loanAmount * (interestRate / 100)) : null;
        annualLoanPaymentChanged = true;
    }

    if (changed.has('LOAN_PAYMENT_ANNUALLY') || annualLoanPaymentChanged) {
        const annualLoanPayment = figure(quote.LOAN_PAYMENT_ANNUALLY);
        quote.LOAN_PAYMENT_MONTHLY = annualLoanPayment ? Math.round(annualLoanPayment / 12) : null;
    }

    if (changed.has('PURCHASE_PRICE') || changed.has('NOI')) {
        const purchasePrice = priceToNumber(quote.PURCHASE_PRICE);
        const NOI = priceToNumber(quote.NOI);
        quote.CAP_RATE = purchasePrice && NOI ? (NOI / purchasePrice * 100).toFixed(2) : null;
    }

    if (changed.has('NOI') || changed.has('LOAN_PAYMENT_ANNUALLY') || annualLoanPaymentChanged) {
        const NOI = priceToNumber(quote.NOI);
        const annualLoanPayment = figure(quote.LOAN_PAYMENT_ANNUALLY);
        quote.CASH_FLOW_ANNUALLY = NOI && annualLoanPayment ? Math.round(NOI - annualLoanPayment) : null;
        annualCashFlowChanged = true;
    }

    if (changed.has('CASH_FLOW_ANNUALLY') || annualCashFlowChanged) {
        const cashFlowAnnually = figure(quote.CASH_FLOW_ANNUALLY);
        quote.CASH_FLOW_MONTHLY = cashFlowAnnually ? Math.round(cashFlowAnnually / 12) : null;
    }

    if (downPaymentChanged || changed.has('CASH_FLOW_ANNUALLY') || annualCashFlowChanged) {
        const cashFlow = figure(quote.CASH_FLOW_ANNUALLY);
        const downPayment = figure(quote.DOWN_PAYMENT);
        quote.CASH_ON_CASH = cashFlow && downPayment ? (cashFlow / Math.round(downPayment) * 100).toFixed(2) : null;
    }

    if (changed.has('NOI') || changed.has('NOI_PERCENTAGE')) {
        const NOI = priceToNumber(quote.NOI);
        const NOIPercentage = Number(quote.NOI_PERCENTAGE).toFixed(2);
        quote.NOI_MULTIPLIED = NOI && NOIPercentage ? NOI * NOIPercentage / 100 : null;
    }

    if (changed.has('NOI_MULTIPLIED') || changed.has('LOAN_AMOUNT') || loanAmountChanged || changed.has('NOI') || changed.has('NOI_PERCENTAGE')) {
        const NOI_MULTIPLIED = figure(quote.NOI_MULTIPLIED);
        const loanAmount = figure(quote.LOAN_AMOUNT);
        quote.DEBT_YIELD = NOI_MULTIPLIED && loanAmount ? NOI_MULTIPLIED / loanAmount * 100 : null;
    }

    if (changed.has('NOI') || changed.has('LOAN_PAYMENT_ANNUALLY') || annualLoanPaymentChanged || changed.has('NOI_PERCENTAGE')) {
        const NOI = priceToNumber(quote.NOI);
        const NOIPercentage = Number(quote.NOI_PERCENTAGE).toFixed(2);
        const annualLoanPayment = figure(quote.LOAN_PAYMENT_ANNUALLY);
        quote.DSCR = NOI && annualLoanPayment ? ((NOI * NOIPercentage / 100) / annualLoanPayment).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : null;
    }
}

function convertDataToForm(dbData, withSeller) {
    const data = { ...dbData };
    const seller = {};

    priceProps
        .filter((key) => data[key])
        .forEach((key) => {
            const num = Number(data[key]);
            if (num === num) {
                // !isNaN
                if (["TOTAL_FEE", "POTENTIAL_FEE", "LIST_FEE", "BUYSIDE_FEE"].includes(key)) {
                    data[key] = num.toLocaleString(undefined, { minimumFractionDigits: 2 });
                } else {
                    data[key] = num.toLocaleString();
                }
            }
        });

    const price = data.SOURCE === 'HSC' ? data.HSC_PRICE : data.LIST_PRICE;
    const rentPrice = data.TYPE === 'MT' ? data.BASE_RENT : data.NET_OPERATING_INCOME;
    const occupancy = data.TYPE === 'MT' ? data.VACANCY : '100';
    data.PRICE_PER_SQFT = pricePerFoot(price, data.SQFT);
    data.RENT_PER_SQFT = rentPerFoot(rentPrice, data.SQFT, occupancy);
    data.CLOSE_PRICE_PER_SQFT = pricePerFoot(data.SOLD_PRICE, data.SQFT);
    data.NEGOTIATION_PRICE_PER_SQFT = pricePerFoot(data.NEGOTIATION_PRICE, data.SQFT);
    data.CREDITS_AT_CLOSING = !data.CREDITS_AT_CLOSING ? '0' : data.CREDITS_AT_CLOSING;
    if (!data.NOI_PERCENT)
        data.NOI_PERCENT = 90;

    dateProps
        .filter((key) => data[key])
        .forEach((key) => {
            if (key !== 'CLOSE_OF_ESCROW') {
                const str = dateISOtoUS(data[key]);
                if (str !== false) {
                    data[key] = str;
                }
            }
        });

    checkboxProps
        .filter(key => data[key])
        .forEach(key => {
            data[key] = data[key] === 'y' || data[key] === true
        });

    agentKeyPercents
        .filter((key) => data[key])
        .forEach((key) => {
            if (!parseFloat(data[key])) {
                data[key] = "";
            }
        });

    // Initialize lead_links as empty array
    if (!data.lead_links || !Array.isArray(data.lead_links)) {
        data.lead_links = [];
    }

    if (withSeller) {
        sellerKeys.forEach(key => {
            const sellerKey = `SELLER_${key}`;
            if (data.hasOwnProperty(sellerKey)) {
                seller[key] = data[sellerKey];
                delete data[sellerKey];
            }
        });

        return { data, seller };
    }
    return data;
}

function convertFormToData(formData) {
    const data = { ...formData };

    // Extract lead_links to save separately - it's stored in a separate table
    const leadLinks = data.lead_links;
    delete data.lead_links;

    // Convert money and locale number formatting to STRING
    priceProps.forEach((key) => {
        const num = priceToString(data[key]);
        if (num !== false) {
            data[key] = num;
        }
    });

    percentProps.forEach((key) => {
        const num = percentToString(data[key]);
        if (num !== false) {
            data[key] = num;
        }
    });

    dateProps
        .filter((key) => data[key])
        .forEach((key) => {
            const str = dateUStoISO(data[key]);
            if (str !== false) {
                data[key] = str;
            }
        });

    checkboxProps.forEach(key => {
        data[key] = data[key] ? 'y' : null
    });

    agentKeyPercents.forEach((key) => {
        const num = percentToString(data[key]);
        if (num !== false) {
            if (!parseFloat(data[key])) {
                data[key] = "0.000000000000000";
            } else {
                data[key] = num;
            }
        }
    });

    if (data.NET_OPERATING_INCOME && data.STATUS === "Closed" && !data.CLOSE_NOI) {
        data.CLOSE_NOI = data.NET_OPERATING_INCOME;
    }

    if (data.SOLD_PRICE && data.CLOSE_NOI && !data.SOURCE === "External") {
        data.CLOSE_CAP_RATE = Math.round((data.CLOSE_NOI / data.SOLD_PRICE) * 10000) / 100;
    }

    // Normalize
    Object.keys(data).forEach((key) => {
        // Trim whitespace
        if (typeof data[key] === "string") {
            data[key] = data[key].trim();
        }

        // Replace empty with null for consistency
        if (data[key] === "") {
            data[key] = null;
        }
    });

    return data;
}

function convertPaymentsDataToForm(dbData, propertyId, transactionType) {
    let data = dbData && cloneDeep(dbData);
    data = data.filter((el) => el.DELETED !== '1')
    const minMembers = transactionType === 'Refferal' ? minReferralMembers : minStriveMembers;
    while (data.length < minMembers) {
        data.push({
            PROPERTY_ID: propertyId
        });
    }

    data.map((row) => {
        paymentsPriceProps.forEach((key) => {
            const num = Number(data[key]);
            if (num === num) {
                row[key] = num.toLocaleString();
            }
        });
    });

    return data;
}

function convertPaymentsFormToData(formData) {
    const data = cloneDeep(formData);

    data.map((elem) => {
        paymentsPriceProps.forEach((key) => {
            const num = priceToString(elem[key]);
            if (num !== false) {
                elem[key] = num;
            }
        });

        paymentsPercentProps.forEach((key) => {
            const num = percentToString(elem[key]);
            if (num !== false) {
                elem[key] = Number(num).toFixed(2);
            }
        });

        // Normalize
        Object.keys(elem).forEach((key) => {
            // Trim whitespace
            if (typeof elem[key] === "string") {
                elem[key] = elem[key].trim();
            }

            // Replace empty with null for consistency
            if (elem[key] === "") {
                elem[key] = null;
            }
        });
    });

    return data;
}

function convertLoanQuotesDataToForm(lqData, propertyData) {
    // A soft-deleted quote still comes back in the save response — the row keeps
    // its values and gains a DELETED stamp — so drop it here rather than letting
    // it reappear as a column.
    const data = cloneDeep(lqData).filter((row) => !(row && row.DELETED));
    const propData = { ...propertyData };
    while (data.length < loanQuotesColumnsNumber) {
        data.push({
            PROPERTY_ID: propData.ARCIMEDES_ROW_ID
        });
    }
    data.map((loanOption, index) => {
        if (loanOption.AMORTIZATION === 'Interest On') {
            loanOption.AMORTIZATION = 'Interest Only'
        }
        if (loanOption.LOAN_QUOTES_ORDER === undefined || loanOption.LOAN_QUOTES_ORDER === null || loanOption.LOAN_QUOTES_ORDER === '') {
            // Order 0 is a valid first-position value — must not be treated as "unset" here,
            // or the row holding it gets its order silently reassigned/collided on re-sort.
            loanOption.LOAN_QUOTES_ORDER = index;
        } else if (typeof loanOption.LOAN_QUOTES_ORDER === 'string' && !isNaN(loanOption.LOAN_QUOTES_ORDER)) {
            loanOption.LOAN_QUOTES_ORDER = parseInt(loanOption.LOAN_QUOTES_ORDER, 10);
        }
        // Every dollar column on a quote is DECIMAL(15,2), so the API hands the
        // cents straight back — "1574467.66", and "2000000.00" for a figure
        // nobody ever typed cents into. Loan quotes are quoted in whole dollars,
        // so the cents come off here, as the row is read into the form: the tab
        // and the printout then carry the same rounded figure.
        //
        // This read `data[key]` before, and `data` is the array of quotes — the
        // lookup was undefined every time and the block never did anything.
        lqPriceProps
            .filter((key) => loanOption[key])
            .forEach((key) => {
                const num = quoteFigure(loanOption[key]);
                if (num !== null) {
                    loanOption[key] = Math.round(num).toLocaleString();
                }
            });

        lqcheckboxProps
            .forEach(key => {
                loanOption[key] = loanOption.IS_PRINTABLE === "1" || loanOption.IS_PRINTABLE === true || loanOption.IS_PRINTABLE === 1
            });

        // A column stays blank until its checkbox is ticked; only a column
        // that holds a quote, or is ticked, is topped up from the property.
        if (isLiveLoanQuote(loanOption)) {
            if (!loanOption.PURCHASE_PRICE || loanOption.PURCHASE_PRICE === '') {
                loanOption.PURCHASE_PRICE = loanQuotePriceFromProperty(propData);

                deriveLoanQuoteFigures(loanOption);
            }

            if (!loanOption.CAP_RATE)
                loanOption.CAP_RATE = propData.SOURCE === 'SUMMIT' ? propData.NEGOTIATION_CAP_RATE : (propData.SOURCE === 'HSC' ? propData.CAPITALIZATION_RATE : null);

            if (!loanOption.NOI_PERCENTAGE && propData.NOI_PERCENT) {
                loanOption.NOI_PERCENTAGE = loanQuoteNoiPercentFromProperty(propData);
            }

            if (!loanOption.TOTAL_ORIGINATION_FEE && propData.TOTAL_ORIGINATION_FEE) {
                loanOption.TOTAL_ORIGINATION_FEE = propData.TOTAL_ORIGINATION_FEE;
            }

            if (!loanOption.NOI && propData.NET_OPERATING_INCOME) {
                loanOption.NOI = propData.NET_OPERATING_INCOME;
                if (loanOption.NOI_PERCENTAGE) {
                    const NOI = typeof loanOption.NOI !== 'number' ? priceToNumber(loanOption.NOI) : loanOption.NOI;
                    const NOIPercentage = Number(loanOption.NOI_PERCENTAGE).toFixed(2);
                    loanOption.NOI_MULTIPLIED = NOI * NOIPercentage / 100;
                }

                if (loanOption.LOAN_PAYMENT_ANNUALLY) {
                    loanOption.CASH_FLOW_ANNUALLY = Math.round(priceToNumber(loanOption.NOI) - priceToNumber(loanOption.LOAN_PAYMENT_ANNUALLY));
                    loanOption.CASH_FLOW_MONTHLY = Math.round(loanOption.CASH_FLOW_ANNUALLY / 12);
                }
            }
        }

        ["LOAN_TERM", "MATURITY"].forEach((key) => {
            if (loanOption[key] && typeof loanOption[key] === "string") {
                const num = parseFloat(loanOption[key]);
                loanOption[key] = num % 1 === 0 ? num.toFixed(0) : num.toString();
            }
        });

    });
    data.sort((a, b) => a.LOAN_QUOTES_ORDER - b.LOAN_QUOTES_ORDER);
    return data;
}

function convertLoanQuotesFormToData(formData) {
    // The Loan Structure row names the quote after the option it is, so store
    // that rather than the Maturity / Amortization text the row used to hold.
    const data = withLoanOptionLabels(cloneDeep(formData));

    data.map((elem) => {

        lqPriceProps.forEach((key) => {
            const num = priceToString(elem[key]);
            if (num !== false) {
                elem[key] = num;
            }
        });

        lqcheckboxProps.forEach(key => {
            elem[key] = elem[key] ? true : false
        });

        lqPercentProps.forEach((key) => {
            const num = percentToString(elem[key]);
            if (num !== false) {
                elem[key] = Number(num).toFixed(lqPercentDecimals[key] || 2);
            }
        });

        // Normalize
        Object.keys(elem).forEach((key) => {
            // Trim whitespace
            if (typeof elem[key] === "string") {
                elem[key] = elem[key].trim();
            }

            // Replace empty with null for consistency
            if (elem[key] === "") {
                elem[key] = null;
            }
        });
        if (elem.AMORTIZATION === 'Interest On') {
            elem.AMORTIZATION = 'Interest Only'
        }
    });

    return data;
}

function calculateExpirationDate({ noMonths, listedDate }) {
    if (!noMonths || !listedDate) {
        return "";
    }
    const date = new Date(listedDate);
    const months = parseInt(noMonths);
    if (date) {
        date.setMonth(date.getMonth() + months);
    }
    return date ? dateToUsString(date) : "";
}

function setListingAgentsPercent(data, p1, p2, p3, p4) {
    data.LISTING_AGENT_1_PERCENT = p1;
    data.LISTING_AGENT_2_PERCENT = p2;
    data.LISTING_AGENT_3_PERCENT = p3;
    data.REFERRING_LISTING_AGENT_PERCENT = p4;
}

function setBuyingAgentsPercent(data, p1, p2, p3, p4) {
    data.BUYER_AGENT_1_PERCENT = p1;
    data.BUYER_AGENT_2_PERCENT = p2;
    data.BUYER_AGENT_3_PERCENT = p3;
    data.REFERRING_BUYER_AGENT_PERCENT = p4;
}
/**
 * `total` split evenly across the filled agent slots, in cents, the cents the
 * rounding leaves over going one each to the first slots — 100 across three is
 * 33.34 / 33.33 / 33.33, so the side adds up exactly (3632). Empty slots are null.
 */
function splitAgentsPercent(agents, total) {
    const filled = agents.filter(Boolean).length;
    const cents = Math.round(total * 100);
    const share = filled ? Math.floor(cents / filled) : 0;
    let remainder = cents - share * filled;

    return agents.map(agent => {
        if (!agent) return null;
        const agentCents = share + (remainder > 0 ? 1 : 0);
        remainder--;
        return (agentCents / 100).toFixed(2);
    });
}

function changeListingAgentsPercent(oldData) {
    const data = { ...oldData };
    if (['Active', 'Under Contract', 'Closed'].includes(data.STATUS)) {
        return data
    }
    const hasSplit = data.BUYER_AGENT_1 || data.BUYER_AGENT_2 || data.BUYER_AGENT_3 || data.BUYER_AGENT_4 || data.REFERRING_BUYER_AGENT;

    const [p1, p2, p3, p4] = splitAgentsPercent([
        data.LISTING_AGENT_1,
        data.LISTING_AGENT_2,
        data.LISTING_AGENT_3,
        data.REFERRING_LISTING_AGENT,
    ], hasSplit ? 50 : 100);

    setListingAgentsPercent(data, p1 || "0.00", p2 || "0.00", p3 || "0.00", p4 || "");

    data.LISTING_AGENT_4_PERCENT = data.LISTING_AGENT_4_PERCENT && data.LISTING_AGENT_4_PERCENT != "0.00" ? data.LISTING_AGENT_4_PERCENT : data.LISTING_AGENT_4
        ? (hasSplit ? "50.00" : "100.00")
        : "0.00";

    return data;
}
function changeBuyingAgentsPercent(oldData) {
    let data = { ...oldData };
    if (['Active', 'Under Contract', 'Closed'].includes(data.STATUS)) {
        return data
    }
    const [p1, p2, p3, p4] = splitAgentsPercent([
        data.BUYER_AGENT_1,
        data.BUYER_AGENT_2,
        data.BUYER_AGENT_3,
        data.REFERRING_BUYER_AGENT,
    ], 50);

    setBuyingAgentsPercent(data, p1 || "0.00", p2 || "0.00", p3 || "0.00", p4 || "");

    data.BUYER_AGENT_4_PERCENT = data.BUYER_AGENT_4_PERCENT && data.BUYER_AGENT_4_PERCENT != "0.00" ? data.BUYER_AGENT_4_PERCENT : data.BUYER_AGENT_4 ? "50.00" : "0.00";

    data = changeListingAgentsPercent(data);

    return data;
}


export default class CRUDProperty extends React.Component {
    currentPageRef;
    drawerComponentRef;

    constructor(props) {
        super(props);

        this.state = {
            account: {
                value: "",
                id: ""
            },
            openReminderDialog: false,
            openEscrowDialog: false,
            data: {},
            agentList: [],
            proposalData: {
                STRENGTHS: '',
                CHALLENGES: '',
                BUYER_POOL: '',
                QUALIFICATIONS: '',
                RECOMMENDATIONS: '',
            },
            proposalDataOriginal: {
                STRENGTHS: '',
                CHALLENGES: '',
                BUYER_POOL: '',
                QUALIFICATIONS: '',
                RECOMMENDATIONS: '',
            },
            standardTextConfig: null,
            currentUserTeamRowId: null,
            teamMemberMap: null,
            loanQuotesData: null,
            originalLoanQuotesData: null,
            deletedLoanQuotesData: [],
            loanNotesData: null,
            originalLoanNotesData: null,
            hscPaymentsData: null,
            propertyPaymentsData: null,
            deletedPaymentsData: [],
            originalPaymentsData: null,
            original: null,
            previousData: null,
            seller: null,
            originalSeller: null,
            hasModifiedStatus: false,
            isHscApproved: false,
            isClosedReferral: false,
            hasModifiedListPrice: false,
            hasReducedListPrice: false,
            isBusy: null,
            error: null,
            success: null,
            emailNotificationMessages: [],
            financialsSpreadsheetInView: false,
            currentUser: null,
            newPropertyId: null,
            allTenants: null,
            allTenantsById: null,
            tenantsBySQFT: null,
            showDrawer: false,
            addNewItemType: null,
            newSeller: null,
            newBuyer: null,
            newAgent: null,
            newFirm: null,
            newLender: null,
            errorTabs: [],
            currentTab: 0,
            // ?edit=1 opens straight in the form rather than read-only, for a
            // link that sends someone here to change something.
            viewMode: (this.props.edit || false) && !(props.location && props.location.query && props.location.query.edit),
            sellerSelected: false,
            showModal: false,
            showHscModal: false,
            propertyNotesModalOpen: false,
            historyDeleteRowId: null,
            agentsGrossCumulativeProcured: {},
            hscAgentsGrossCumulative: {},
            resetDrawer: false,
            displayedHSCAgents: 1,
            recomputePayments: false,
            openEscrowDateError: false,
            tranche: null,
            netFee: null,
            isHotList: false,
            isNewDevelopment: false,
            isNeedOwner: false,
            isResearched: false,
            ownershipManuallyChanged: false,
            referringAgentData: {
                REFERRING_LISTING_AGENT: '',
                REFERRING_LISTING_AGENT_PERCENT: '',
                REFERRING_LISTING_AGENT_FIRM: '',
                REFERRING_BUYER_AGENT: '',
                REFERRING_BUYER_AGENT_PERCENT: '',
                REFERRING_BUYER_AGENT_FIRM: '',
            },
            isDialogueOpen: false,
            featuredActivatedLogId: null,
            notes: [],
            pendingNotes: [],
            zipLoading: false,
            showTerritoryModal: false,
            territoryOptions: [],
            historyFinancialsInView: false,
            historyFinancialsLoading: false,
            historyFinancialsData: null,
            historyFinancialsSnapshot: null,
            historyTabInView: null,
            historyTabSnapshot: null,
            historyTabData: null,
            historyTabLoading: false,
            historySnapshotCache: null,
            historyPartialModalOpen: false,
            historyPartialData: null,
        };
        this.isPropertyExists = this.isPropertyExists.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.setDataFromFinancials = this.setDataFromFinancials.bind(this);
        this.openFinancialsSpreadsheet = this.openFinancialsSpreadsheet.bind(this);
        this.closeFinancialsSpreadsheet = this.closeFinancialsSpreadsheet.bind(this);
        this.setValue = this.setValue.bind(this);
        this.handleChangeInput = this.handleChangeInput.bind(this);
        this.handleLeadLinksChange = this.handleLeadLinksChange.bind(this);
        this.handlePropsalInputChange = this.handlePropsalInputChange.bind(this);
        this.handleLoanQuotesChangeInput = this.handleLoanQuotesChangeInput.bind(this);
        this.handleLoanQuotesChangeDropdown = this.handleLoanQuotesChangeDropdown.bind(this);
        this.handleChangeDropdown = this.handleChangeDropdown.bind(this);
        this.handleSellerChangeDropdown = this.handleSellerChangeDropdown.bind(this);
        this.handleSellerChangeInput = this.handleSellerChangeInput.bind(this);
        this.handleChangeFile = this.handleChangeFile.bind(this);
        this.handleDeleteHistory = this.handleDeleteHistory.bind(this);
        this.showHistoryDeleteModal = this.showHistoryDeleteModal.bind(this);
        this.handleChangeSeller = this.handleChangeSeller.bind(this);
        this.addNewItem = this.addNewItem.bind(this);
        this.savedNewItem = this.savedNewItem.bind(this);
        this.addNewOwner = this.addNewOwner.bind(this);
        this.handleOwnersChange = this.handleOwnersChange.bind(this);
        this.checkCoordinatesAndSave = this.checkCoordinatesAndSave.bind(this);
        this.closeDrawer = this.closeDrawer.bind(this);
        this.getTenantsForTags = this.getTenantsForTags.bind(this);
        this.redirectToEscrowTracking = this.redirectToEscrowTracking.bind(this);
        this.redirectToHscTracking = this.redirectToHscTracking.bind(this);
        this.getAgentsGrossCumulativeProcured = this.getAgentsGrossCumulativeProcured.bind(this);
        this.getAgentGrossCumulativeProcured = this.getAgentGrossCumulativeProcured.bind(this);
        this.setPaymentsData = this.setPaymentsData.bind(this);
        this.handlePaymentsChangeDropdown = this.handlePaymentsChangeDropdown.bind(this);
        this.handleAddMember = this.handleAddMember.bind(this);
        this.drawerComponentRef = React.createRef();
        this.currentPageRef = React.createRef();
        this.refreshHistoryData = this.refreshHistoryData.bind(this);
        this.openHscPayments = this.openHscPayments.bind(this);
        this.handleHscPaymentsChangeInput = this.handleHscPaymentsChangeInput.bind(this);
        this.handleHscPaymentsChangeDropdown = this.handleHscPaymentsChangeDropdown.bind(this);
        this.getHscAgentsGrossCumulative = this.getHscAgentsGrossCumulative.bind(this);
        this.getHscAgentGrossCumulative = this.getHscAgentGrossCumulative.bind(this);
        this.computeHscAgentFees = this.computeHscAgentFees.bind(this);
        this.addHscMember = this.addHscMember.bind(this);
        this.recomputePayments = this.recomputePayments.bind(this);
        this.handleInputBlur = this.handleInputBlur.bind(this);
        this.checkHistoryAndSave = this.checkHistoryAndSave.bind(this);
        this.calculateGrossAmount = this.calculateGrossAmount.bind(this);
        this.handlePrintPagesDropDown = this.handlePrintPagesDropDown.bind(this);
        this.addNewColumn = this.addNewColumn.bind(this);
        this.toggleAllLoanQuoteColumns = this.toggleAllLoanQuoteColumns.bind(this);
        this.duplicateLoanQuoteColumn = this.duplicateLoanQuoteColumn.bind(this);
        this.deleteLoanQuoteColumn = this.deleteLoanQuoteColumn.bind(this);
        this.discardPendingLoanQuoteDeletes = this.discardPendingLoanQuoteDeletes.bind(this);
        this.saveData = this.saveData.bind(this)
        this.updateColumns = this.updateColumns.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.onConfirm = this.onConfirm.bind(this);
        this.fetchAccountNumber = this.fetchAccountNumber.bind(this)
        this.handleAddLoanNote = this.handleAddLoanNote.bind(this);
        this.handleDeleteLoanNote = this.handleDeleteLoanNote.bind(this);
        this.handleEditLoanNote = this.handleEditLoanNote.bind(this);
        this.fetchNotes = this.fetchNotes.bind(this);
        this.handleAddPendingNote = this.handleAddPendingNote.bind(this);
        this.handleEditPendingNote = this.handleEditPendingNote.bind(this);
        this.handleDeletePendingNote = this.handleDeletePendingNote.bind(this);
        this.flushPendingNotes = this.flushPendingNotes.bind(this);
        this.finishAddAndRedirect = this.finishAddAndRedirect.bind(this);
        this.openHistoryFinancialsSpreadsheet = this.openHistoryFinancialsSpreadsheet.bind(this);
        this.closeHistoryFinancialsSpreadsheet = this.closeHistoryFinancialsSpreadsheet.bind(this);
        this.openHistoryTabView = this.openHistoryTabView.bind(this);
        this.closeHistoryTabView = this.closeHistoryTabView.bind(this);
        this.decoratePaymentSnapshotPresence = this.decoratePaymentSnapshotPresence.bind(this);
        this.closeHistoryPartialModal = this.closeHistoryPartialModal.bind(this);
        this.saveHistoryFinancialSnapshot = this.saveHistoryFinancialSnapshot.bind(this);
        this.getHistoryFinancialSnapshot = this.getHistoryFinancialSnapshot.bind(this);
        this.handleRefreshProposalDefaults = this.handleRefreshProposalDefaults.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.params.id !== nextProps.params.id) {
            this.getProperty(nextProps.params.id);
        }
    }

    componentDidMount() {
        this.getProperty(this.props.params.id);
        const locationState = this.props.location.state || {};
        const index = locationState.index;
        if (locationState.fromList && index !== undefined && index !== null) {
            sessionStorage.setItem('lastClickedProperty', this.props.params.id + 'key_' + index);
            sessionStorage.setItem('lastClickedListSearch', locationState.listSearch || '');
            // Only the matching next return to /list should restore scroll — not a later fresh open.
            sessionStorage.setItem('restoreListScroll', '1');
        }
        request(arc.path.api, {
            service: 'arcimedes',
            action: 'open.datasource.table.Data.getData',
            params: ['code', 'TEAM', {
                limit: {
                    count: 1000,
                    offset: 0,
                },
                column: [
                    'ARCIMEDES_ROW_ID',
                    'FIRST_NAME',
                    'LAST_NAME',
                    'DELETED',
                    'IS_AGENT',
                ],
                filter: [
                    {
                        code: 'FIRST_NAME',
                        text: '',
                        type: 'notNull',
                    },
                    {
                        code: 'LAST_NAME',
                        text: '',
                        type: 'notNull',
                    },
                ],
                filterType: 'and',
                order: [
                    {
                        code: 'FIRST_NAME',
                        type: 'asc',
                    },
                    {
                        code: 'LAST_NAME',
                        type: 'asc',
                    },
                ],
            }],
        }).then(res => {
            let items = res.data ? res.data.filter(x => x.FIRST_NAME && x.LAST_NAME) : false;
            this.setState({ agentList: items });
        });
        this.fetchNotes()
        getData({
            tableCode: FEATURED_ACTIVATED_LOG,
            options: {
                filter: [
                    { text: this.props.params.id, code: 'PROPERTY_ID', type: 'exact' }
                ],
                filterType: 'and',
            },
        }).then((res) => {
            if (res && res.success && res.data && res.data.length) {
                this.setState({ featuredActivatedLogId: res.data[0].ARCIMEDES_ROW_ID });
            } else {
                this.setState({ featuredActivatedLogId: null });
            }
        })
        if (this.props.params.id) {
            this.fetchAccountNumber()
        }
        this.fetchStandardTextConfig();
        this.fetchCurrentUserTeamRowId();
    }

    fetchStandardTextConfig() {
        getData({
            tableCode: PRICING_ANALYSIS,
            options: {
                filterType: 'and',
                filter: [{ text: 'standard-text', code: 'PRODUCT_TYPE', type: 'exact' }],
            },
        }).then((res) => {
            if (res && res.success && res.data && res.data.length) {
                try {
                    const items = typeof res.data[0].ITEMS === 'string'
                        ? JSON.parse(res.data[0].ITEMS)
                        : res.data[0].ITEMS;
                    if (items && items.defaults) {
                        this.setState({ standardTextConfig: items });
                    }
                } catch (e) { /* ignore parse errors */ }
            }
        }).catch(() => {});
    }

    fetchCurrentUserTeamRowId() {
        const email = this.props.userData && this.props.userData.email;
        getData({
            tableCode: TEAM,
            options: {
                column: ['ARCIMEDES_ROW_ID', 'EMAIL'],
                limit: { count: 1000 },
            },
        }).then((res) => {
            if (res && res.success && Array.isArray(res.data)) {
                const emailToId = {};
                const idToEmail = {};
                res.data.forEach((m) => {
                    const id = String(m.ARCIMEDES_ROW_ID);
                    const memberEmail = (m.EMAIL || '').toLowerCase();
                    if (memberEmail) {
                        emailToId[memberEmail] = id;
                        idToEmail[id] = memberEmail;
                    }
                });
                const updates = { teamMemberMap: { emailToId, idToEmail } };
                if (email && emailToId[email.toLowerCase()]) {
                    updates.currentUserTeamRowId = emailToId[email.toLowerCase()];
                }
                this.setState(updates);
            }
        }).catch(() => {});
    }

    componentDidUpdate(prevProps, prevState) {
        if (!shallowEqual(this.props.location.query, prevProps.location.query)) {
            this.refreshHistoryData();
        }
        const configJustLoaded = this.state.standardTextConfig && !prevState.standardTextConfig;
        const teamIdJustLoaded = this.state.currentUserTeamRowId && !prevState.currentUserTeamRowId;
        const mapJustLoaded = this.state.teamMemberMap && !prevState.teamMemberMap;
        if ((configJustLoaded || teamIdJustLoaded || mapJustLoaded) && this.state.data && Object.keys(this.state.data).length) {
            if (!this.state.proposalData.UPDATED) {
                const updatedData = this.handleProposalDataByType(this.state.data, this.state.proposalData);
                this.setState({ proposalData: updatedData, proposalDataOriginal: updatedData });
            }
        }
    }
    fetchNotes() {
        const propertyId = this.props.params.id
            || (this.state.data && this.state.data.ARCIMEDES_ROW_ID)
            || (this.state.original && this.state.original.ARCIMEDES_ROW_ID);
        if (!propertyId) {
            this.setState({ notes: [] });
            return;
        }
        getData({
            tableCode: PROPERTY_NOTES,
            columns: [
                "ARCIMEDES_ROW_ID",
                "PROPERTY_ID",
                "NOTE_TEXT",
                "DATE_CREATED",
                "CREATED_BY",
                "LAST_MODIFIED_DATE",
                "LAST_MODIFIED_BY",
                "DELETED",
            ],
            options: {
                filter: [
                    {
                        text: '',
                        code: 'DELETED',
                        type: 'null',
                    },
                    {
                        text: propertyId,
                        code: "PROPERTY_ID",
                        type: "exact",
                    },
                ],
                filterType: 'and',
                order: [{ code: 'ARCIMEDES_ROW_ID', type: 'desc' }],
            },
        })
            .then((res) => {
                const list = (res && res.data !== undefined)
                    ? res.data.filter(note => !(note && note.NOTE_TEXT && note.NOTE_TEXT.startsWith(HISTORY_FINANCIALS_NOTE_PREFIX)))
                    : [];
                // Newest first (the `order` option above is ignored by the generic GetData
                // action, so sort here). Higher ARCIMEDES_ROW_ID = more recently added.
                list.sort((a, b) => Number(b.ARCIMEDES_ROW_ID) - Number(a.ARCIMEDES_ROW_ID));
                this.setState({ notes: list });
            })
            .catch(() => this.setState({ notes: [] }));
    }
    handleAddPendingNote(noteText) {
        const text = (noteText || "").trim();
        if (!text) return;
        const now = new Date().toISOString();
        const userName = this.state.currentUser || "User";
        const note = {
            PENDING_ID: `pending-${Date.now()}-${Math.random().toString(36).slice(2)}`,
            NOTE_TEXT: text,
            DATE_CREATED: now,
            CREATED_BY: userName,
            LAST_MODIFIED_DATE: now,
            LAST_MODIFIED_BY: userName,
            DELETED: 0,
        };
        this.setState(prevState => ({ pendingNotes: [note, ...prevState.pendingNotes] }));
    }
    handleEditPendingNote(pendingId, noteText) {
        const text = (noteText || "").trim();
        if (!pendingId || !text) return;
        this.setState(prevState => ({
            pendingNotes: prevState.pendingNotes.map(note => (
                note.PENDING_ID === pendingId
                    ? {
                        ...note,
                        NOTE_TEXT: text,
                        LAST_MODIFIED_DATE: new Date().toISOString(),
                        LAST_MODIFIED_BY: this.state.currentUser || "User",
                    }
                    : note
            )),
        }));
    }
    handleDeletePendingNote(pendingId) {
        if (!pendingId) return;
        this.setState(prevState => ({
            pendingNotes: prevState.pendingNotes.filter(note => note.PENDING_ID !== pendingId),
        }));
    }
    // Notes typed before the property existed have no PROPERTY_ID; write them once the
    // new id is known. Resolves to true only when they are safely persisted — the caller
    // keeps them in state otherwise so nothing typed is lost.
    flushPendingNotes(propertyId) {
        const pending = this.state.pendingNotes;
        if (!propertyId || !pending || !pending.length) return Promise.resolve(true);
        const rows = pending
            .slice()
            .reverse()
            .map(({ PENDING_ID, ...note }) => ({ ...note, PROPERTY_ID: Number(propertyId) }));
        return manageData({ tableCode: PROPERTY_NOTES, data: rows })
            .then((res) => {
                if (res && res.success) {
                    this.setState({ pendingNotes: [] });
                    return true;
                }
                return false;
            })
            .catch(() => false);
    }
    // Post-create: write anything queued against the brand-new id, then land on its
    // edit route. A failed note write holds the redirect so the queue isn't discarded.
    finishAddAndRedirect(newPropertyId) {
        return this.flushPendingNotes(newPropertyId)
            .then((notesSaved) => {
                if (!notesSaved) {
                    this.setState({ error: 'The property was saved, but its notes could not be. Reopen Notes and add them again.' });
                    return;
                }
                browserHistory.push({
                    pathname: `/property/${newPropertyId}`,
                    // The saved row travels with the route. The page it opens
                    // would otherwise re-read a property written a moment ago
                    // and show nothing but "Loading…" while it did.
                    state: {
                        justSaved: this.state.data,
                        savedMessage: this.state.success,
                        locationNotice: this.state.locationNotice,
                        // Travels for the same reason: the page that knew it
                        // was opened from the map is the one being replaced.
                        fromParcelMap: Boolean(this.openedFromParcelMap),
                    },
                });
            });
    }
    /** The list a property is found in — where Cancel and PROPERTIES lead. */
    propertiesList() {
        return `${arc.path.base}list?SOURCE=SUMMIT&STATUS=Active&TRANSACTION_TYPE=Investment+Sales`;
    }

    /** Whether this page is the far end of an add that started on the map. */
    cameFromParcelMap() {
        return Boolean(this.openedFromParcelMap || ((this.props.location || {}).state || {}).fromParcelMap);
    }

    refreshHistoryData() {
        const query = { ...this.props.location.query };
        const options = filter(query, 'history');

        options.param.PROPERTY_ID = this.props.params.id;
        Promise.all([
            executeQuery({ queryName: GET_PROPERTY_HISTORY, options: options })
        ]).then(res => {
            const filters = query.order ? (Array.isArray(query.order) ? query.order : [query.order]) : [];
            if (this.state.originalData.data[0].LOAN_TYPE == "Refi") {
                const _filter = this.state.originalData.data[0];
                const _agent = hscTeamMembers.find((e) => e.EMAIL === _filter['HSC_TEAM_MEMBER_1']);
                _filter.STATUS = "Refi";
                _filter.DATE = _filter.LOAN_CLOSING_DATE;
                _filter.LISTING_AGENT_FIRM_NAME = "HSC";
                _filter.ARCIMEDES_ROW_ID = null;
                _filter.PRICE = _filter.LOAN_AMOUNT / (_filter.LTV != null ? (_filter.LTV / 100) : '1');
                _agent && _agent.NAME ? _filter.LISTING_AGENT_4_FIRST_NAME = _agent.NAME : '';
                _filter.LISTING_AGENT_4_LAST_NAME = "";
                res[0].data.push(_filter);
            }

            const propertySource = this.state.data && this.state.data.SOURCE;
            const propertyHscFinancing = this.state.data && this.state.data.HSC_FINANCING;
            res[0].data.forEach(row => {
                row.SOURCE = row.SOURCE || propertySource;
                if (row.HSC_FINANCING === undefined || row.HSC_FINANCING === null) row.HSC_FINANCING = propertyHscFinancing;
            });
            const data = [this.state.currentHistoryData, ...res[0].data];

            this.setState({
                historyData: data,
                error: res[0].success ? null : res[0].message,
            }, () => this.decoratePaymentSnapshotPresence(data));
        });
    }

    static excludeSellerData(resData) {
        const data = { ...resData };
        sellerKeys.forEach(key => delete data[`SELLER_${key}`]);
        return data;
    }

    closeDrawer() {
        this.setState({ showDrawer: false, resetDrawer: true });
    }

    geocode(data, callback) {
        geocodeAddress(data).then((geo) => callback(geo, null), (failure) => callback(null, failure));
    }

    /** What the user is told about the map point this save kept or changed; null when there is nothing to say. */
    locationNotice(data, original, geo, failure) {
        if (failure) {
            return `The map point could not be looked up (${failure.message}), so it was left as it was.`;
        }
        if (!geo) {
            return hasValidCoords(original)
                ? 'This address could not be confirmed in its ZIP, so the map point was left where it was. Check the address and ZIP.'
                : 'This address could not be confirmed in its ZIP, so it has no map point yet. Check the address and ZIP.';
        }
        if (geo.city) {
            return `The city and ZIP were changed from ${data.CITY} ${data.ZIP || ''} to ${geo.city} ${geo.zip}: that is where this address is.`;
        }
        return geo.zip !== data.ZIP ? `The ZIP was changed from ${data.ZIP || 'blank'} to ${geo.zip}: that is the ZIP this address is in.` : null;
    }

    getProperty(id) {
        // The row an Add has just written, handed over by the push that opened
        // this route. `property` and `property/:id` are separate routes, so
        // that save happened in a component this one replaced, and without the
        // handover `data` starts null — which is what CRUD answers with a
        // full-page "Loading…". Measured at 4.6 seconds of white between
        // "Saved" and the property. The read below still runs and replaces it.
        const handed = ((this.props.location || {}).state || {});
        const saved = handed.justSaved && String(handed.justSaved.ARCIMEDES_ROW_ID) === String(id)
            ? handed.justSaved
            : null;

        this.bankEditBase = null;
        this.setState({
            data: saved,
            original: null,
            originalLoanQuotesData: null,
            // Deletes only reach the DB through a save; loading another property
            // drops the pending ones with the rest of its loan quote state.
            deletedLoanQuotesData: [],
            originalLoanNotesData: null,
            originalPaymentsData: null,
            error: null,
            // The alert the save put up belongs with it: the page no longer
            // changes when the route does, so losing it loses the only sign
            // that anything happened.
            success: saved ? handed.savedMessage || null : null,
            locationNotice: saved ? handed.locationNotice || null : null,
            emailNotificationMessages: [],
            currentUser: null,
        });

        const userName = this.props.userData.person.firstName + " " + this.props.userData.person.lastName;

        if (id === undefined) {
            executeBackendQuery({
                queryName: GET_ALL_TENANTS,
                params: {}
            }).then((res) => {
                if (res && res.success && Array.isArray(res.data) && res.data.length) {
                    const allTenants = res.data;
                    const allTenantsById = [];
                    allTenants.forEach((x) => (allTenantsById[x.ARCIMEDES_ROW_ID] = x));

                    this.setState({
                        allTenants: allTenants,
                        allTenantsById: allTenantsById,
                    });
                }
            });

            const data = {
                DATE_CREATED: new Date().toLocaleDateString("en-US"),
                CREATED_BY: userName,
                TRANSACTION_TYPE: "Investment Sales",
                LAST_MODIFIED_BY: userName,
                LAST_MODIFIED_DATE: new Date().toLocaleDateString("en-US"),
                PROPOSAL_DATE: new Date().toLocaleDateString("en-US"),
                FEATURED: "y",
                LISTING_AGENT_1_PERCENT: "",
                LISTING_AGENT_2_PERCENT: "",
                LISTING_AGENT_3_PERCENT: "",
                LISTING_AGENT_4_PERCENT: "",
                BUYER_AGENT_1_PERCENT: "",
                BUYER_AGENT_2_PERCENT: "",
                BUYER_AGENT_3_PERCENT: "",
                BUYER_AGENT_4_PERCENT: "",
                CREDITS_AT_CLOSING: '0',
                CORE_PROPERTY: 'y',
            };
            // Arriving from the parcel map, nothing has been written yet: the
            // parcel's columns fill the form and the payload waits for Save,
            // which is what the client asked to be the moment it is added.
            const token = (this.props.location.query || {}).fromParcel;
            const handoff = readParcelHandoff(token);

            if (handoff) {
                this.parcelHandoffToken = token;
                this.parcelHandoff = handoff;
                // The map opens this in a tab of its own, so there is nothing
                // behind it to go back to, and the parcel it was opened with
                // is used up by the save. Browser back landed the client on a
                // blank Add property, and then on a button that did nothing.
                this.openedFromParcelMap = true;
                Object.assign(data, handoff.overrides || {});
            }

            this.setState({
                data: data,
                original: {},
                loanQuotesData: convertLoanQuotesDataToForm([], data),
                originalLoanQuotesData: {},
                loanNotesData: [],
                originalLoanNotesData: [],
                originalPaymentsData: {},
                propertyPaymentsData: [],
                seller: {},
                originalSeller: {},
                currentUser: userName,
                financialsSpreadsheetInView: false,
            });
            return;
        }


        const query = { ...this.props.location.query };
        const options = filter(query, 'history');
        options.param.PROPERTY_ID = id;



        Promise.all([
            executeQuery({
                queryName: PROPERTY_DATA,
                params: {
                    PROPERTY_ID: id,
                },
            }),
            request(arc.path.api, {
                service: "arcimedes",
                action: "open.dataquery.execute",
                params: [PROPERTY_UNDERWRITING_TENANTS, {
                    param: {
                        PROPERTY_ID: id,
                    },
                },],
            }),
            executeBackendQuery({
                queryName: GET_ALL_TENANTS,
                params: {}
            }),
            executeQuery({
                queryName: GET_PROPERTY_HISTORY,
                options: options
            }),
            getData({
                tableCode: HSC_LOAN_QUOTES,
                options: {
                    filterType: 'and',
                    filter: [
                        {
                            text: id,
                            code: 'PROPERTY_ID',
                            type: 'exact',
                        },
                        {
                            text: '',
                            code: 'DELETED',
                            type: 'null',
                        }
                    ],
                },
            }),
            getData({
                tableCode: PROPERTY_PAYMENT_TEAM,
                columns: [
                    'ARCIMEDES_ROW_ID',
                    'PROPERTY_ID',
                    'STRIVE_TEAM_MEMBER_ID',
                    'STRIVE_TEAM_MEMBER_PERCENT',
                    'STRIVE_TEAM_MEMBER_GROSS_FEE',
                    'STRIVE_TEAM_MEMBER_NET_FEE',
                    'STRIVE_TEAM_MEMBER_NET_PERCENT'
                ],
                options: {
                    filterType: 'and',
                    filter: [
                        {
                            text: id,
                            code: 'PROPERTY_ID',
                            type: 'exact',
                        },
                        {
                            text: '',
                            code: 'DELETED',
                            type: 'null',
                        }
                    ],
                },
            }),
            getData({
                tableCode: PROPOSAL,
                columns: [
                    'ARCIMEDES_ROW_ID',
                    'PROPERTY_ID',
                    'STRENGTHS',
                    'CHALLENGES',
                    'BUYER_POOL',
                    'QUALIFICATIONS',
                    'RECOMMENDATIONS',
                    'UPDATED'
                ],
                options: {
                    filterType: 'and',
                    filter: [
                        {
                            text: id,
                            code: 'PROPERTY_ID',
                            type: 'exact',
                        }
                    ],
                },
            }),
            getData({
                tableCode: HOT_LIST,
                columns: [
                    'ARCIMEDES_ROW_ID',
                    'ID',
                    'NAME',
                    'EMAIL_ID',
                    'HOT_LIST_PROPERTIES'
                ],
                options: {
                    filterType: 'and',
                    filter: [
                        {
                            text: id,
                            code: 'PROPERTY_ID',
                            type: 'exact',
                        }
                    ],
                },
            }).catch(() => ({ success: false, data: [] })),
            executeQuery({
                queryName: HOTLIST_PROPERTIES_BY_EMAIL,
                params: {
                    EMAIL_ID: this.props.userData.email,
                },
            }),
            getData({
                tableCode: PROPERTY_LOAN_NOTES,
                columns: [
                    'ARCIMEDES_ROW_ID',
                    'PROPERTY_ID',
                    'NOTE_TEXT',
                    'DATE_CREATED',
                    'CREATED_BY',
                    'LAST_MODIFIED_DATE',
                    'LAST_MODIFIED_BY',
                    'DELETED'
                ],
                options: {
                    filterType: 'and',
                    filter: [
                        {
                            text: id,
                            code: 'PROPERTY_ID',
                            type: 'exact',
                        },
                        {
                            text: '',
                            code: 'DELETED',
                            type: 'null',
                        }
                    ],
                },
            }),
            getData({
                tableCode: NEW_DEVELOPMENT,
                columns: [
                    'ARCIMEDES_ROW_ID',
                    'PROPERTY_ID',
                ],
                options: {
                    filterType: 'and',
                    filter: [
                        {
                            text: id,
                            code: 'PROPERTY_ID',
                            type: 'equal',
                        },
                        {
                            text: '',
                            code: 'DELETED',
                            type: 'null',
                        }
                    ],
                },
            }).catch(() => ({ success: false, data: [] })),
            getData({
                tableCode: NEED_OWNER,
                columns: [
                    'ARCIMEDES_ROW_ID',
                    'PROPERTY_ID',
                ],
                options: {
                    filterType: 'and',
                    filter: [
                        {
                            text: id,
                            code: 'PROPERTY_ID',
                            type: 'equal',
                        },
                        {
                            text: '',
                            code: 'DELETED',
                            type: 'null',
                        }
                    ],
                },
            }).catch(() => ({ success: false, data: [] })),
            propertyResearchedApi.show(id).catch(() => false),
        ]).then(async (res) => {
            if (res && res[6] && res[6].success && res[6].data.length) {
                this.setState({
                    proposalData: {
                        BUYER_POOL: res[6].data[0].BUYER_POOL,
                        STRENGTHS: res[6].data[0].STRENGTHS,
                        CHALLENGES: res[6].data[0].CHALLENGES,
                        QUALIFICATIONS: res[6].data[0].QUALIFICATIONS,
                        RECOMMENDATIONS: res[6].data[0].RECOMMENDATIONS,
                        ARCIMEDES_ROW_ID: res[6].data[0].ARCIMEDES_ROW_ID,
                        UPDATED: res[6].data[0].UPDATED
                    },
                    proposalDataOriginal: {
                        BUYER_POOL: res[6].data[0].BUYER_POOL,
                        STRENGTHS: res[6].data[0].STRENGTHS,
                        CHALLENGES: res[6].data[0].CHALLENGES,
                        QUALIFICATIONS: res[6].data[0].QUALIFICATIONS,
                        RECOMMENDATIONS: res[6].data[0].RECOMMENDATIONS,
                        ARCIMEDES_ROW_ID: res[6].data[0].ARCIMEDES_ROW_ID,
                        UPDATED: res[6].data[0].UPDATED
                    },
                })
            }
            if (res && res[0] && res[0].success && Array.isArray(res[0].data) && res[0].data.length) {
                let { data, seller } = convertDataToForm(res[0].data[0], true);

                // if (res[10] && res[10].success && Array.isArray(res[10].data)) {
                //     data.lead_links = res[10].data.map(link => link.LINK_URL);
                // } else {
                //     data.lead_links = [];
                // }

                // Set NEW_DEVELOPMENT from NEW_DEVELOPMENT table (res[10])
                const hasNewDevEntry = res[10] && res[10].success && Array.isArray(res[10].data) && res[10].data.length > 0;
                data.NEW_DEVELOPMENT = hasNewDevEntry;

                // Set HOT_LIST from per-user HOT_LIST table (res[8] - HOTLIST_PROPERTIES_BY_EMAIL)
                const hotListPropsCsv = res[8] && res[8].success && Array.isArray(res[8].data) && res[8].data[0]
                    ? (res[8].data[0].HOT_LIST_PROPERTIES || '')
                    : '';
                const hotListPropsArr = hotListPropsCsv.split(',').map(s => s.trim()).filter(Boolean);
                const hasHotListEntry = hotListPropsArr.includes(String(id));
                data.HOT_LIST = hasHotListEntry;

                // Set NEED_OWNER from NEED_OWNER table (res[11])
                const hasNeedOwnerEntry = res[11] && res[11].success && Array.isArray(res[11].data) && res[11].data.length > 0;
                data.NEED_OWNER = hasNeedOwnerEntry;

                // Set isResearched from /api/v1/properties/{id}/researched (res[12])
                const hasResearchedEntry = Boolean(res[12]);

                // Fetch contract info from separate table
                const contractInfoRes = await executeQuery({
                    queryName: GET_PROPERTY_CONTRACT_INFO,
                    params: { PROPERTY_ID: id },
                });
                if (contractInfoRes && contractInfoRes.success && Array.isArray(contractInfoRes.data) && contractInfoRes.data.length) {
                    data.LISTING_AGENT = contractInfoRes.data[0].LISTING_AGENT;
                    data.TRANSACTION_COORDINATOR = contractInfoRes.data[0].TRANSACTION_COORDINATOR;
                    data._contractInfoId = contractInfoRes.data[0].ARCIMEDES_ROW_ID;
                }
                if (res[1] && res[1].success && Array.isArray(res[1].data) &&
                    res[2] && res[2].success && Array.isArray(res[2].data) && res[2].data.length) {
                    const underwritingTenants = res[1].data;
                    const allTenants = res[2].data;
                    const allTenantsById = [];
                    allTenants.forEach((x) => (allTenantsById[x.ARCIMEDES_ROW_ID] = x));
                    this.setState({
                        allTenants: allTenants,
                        allTenantsById: allTenantsById,
                        tenantsBySQFT: underwritingTenants,
                    });
                }

                const query = { ...this.props.location.query };
                const filters = query.order ? (Array.isArray(query.order) ? query.order : [query.order]) : [];

                const isStrive = data && ['SUMMIT', 'External'].includes(data.SOURCE);
                const currentData = new CurrentHistoryModel(res[0].data[0]);
                const historyData = res[3] && res[3].success && Array.isArray(res[3].data) ? [...res[3].data] : null;
                if (historyData) {
                    const propertySource = data && data.SOURCE;
                    const propertyHscFinancing = data && data.HSC_FINANCING;
                    historyData.forEach(row => {
                        row.SOURCE = row.SOURCE || propertySource;
                        if (row.HSC_FINANCING === undefined || row.HSC_FINANCING === null) row.HSC_FINANCING = propertyHscFinancing;
                    });
                }
                if (res[0].data[0].LOAN_TYPE == "Refi") {
                    const _filter = res[0].data[0];
                    const _agent = hscTeamMembers.find((e) => e.EMAIL === _filter['HSC_TEAM_MEMBER_1'])
                    if (res[0].data[0].SOURCE === "SUMMIT") {
                        _filter.STATUS = "Refi";
                    }
                    _filter.DATE = _filter.LOAN_CLOSING_DATE;
                    _filter.LISTING_AGENT_FIRM_NAME = "HSC";
                    _filter.LISTING_AGENT_1_FIRST_NAME = _filter.HSC_TEAM_MEMBER;
                    _filter.PRICE = Math.round(_filter.LOAN_AMOUNT / (_filter.LTV != null ? (_filter.LTV / 100) : 1));
                    _filter.ARCIMEDES_ROW_ID = null;
                    _agent && _agent.NAME ? _filter.LISTING_AGENT_4_FIRST_NAME = _agent.NAME : '';
                    _filter.LISTING_AGENT_4_LAST_NAME = "";
                    historyData.push(_filter);
                }
                historyData.sort((a, b) => {
                    return (b.ARCIMEDES_ROW_ID || 0) - (a.ARCIMEDES_ROW_ID || 0);
                });
                historyData.unshift(currentData);
                const loanQuotesData = res[4] && res[4].success && Array.isArray(res[4].data) ? convertLoanQuotesDataToForm(res[4].data, res[0].data[0]) : null;
                loanQuotesData && loanQuotesData.length && loanQuotesData.forEach((item, index) => {
                    if (!item["PRINT_PAGE_NUMBER"]) {
                        item["PRINT_PAGE_NUMBER"] = index <= 4 ? 1 : 2;
                    }
                })
                const originalLoanQuotesData = res[4] && res[4].success && Array.isArray(res[4].data) ? cloneDeep(loanQuotesData) : null;
                const loanNotesData = res[9] && res[9].success && Array.isArray(res[9].data) ? res[9].data : [];
                const originalLoanNotesData = res[9] && res[9].success && Array.isArray(res[9].data) ? cloneDeep(res[9].data) : [];
                let propertyPaymentsData = [];
                if (isStrive) {
                    propertyPaymentsData = res[5] && res[5].success && Array.isArray(res[5].data) ? convertPaymentsDataToForm(res[5].data, id, res[0].data[0].TRANSACTION_TYPE === 'Referral') : Array.from({ length: res[0].data[0].TRANSACTION_TYPE === 'Referral' ? minReferralMembers : minStriveMembers }, () => ({ PROPERTY_ID: id }));
                }
                const originalPaymentsData = res[5] && res[5].success && Array.isArray(res[5].data) ? cloneDeep(propertyPaymentsData) : null;
                let displayedHSCAgents = hscAgentsKeys.filter((key) => data && data[key] != null).length;
                const freshProposal = (res[6] && res[6].success && res[6].data && res[6].data.length)
                    ? { BUYER_POOL: res[6].data[0].BUYER_POOL, STRENGTHS: res[6].data[0].STRENGTHS, CHALLENGES: res[6].data[0].CHALLENGES, QUALIFICATIONS: res[6].data[0].QUALIFICATIONS, RECOMMENDATIONS: res[6].data[0].RECOMMENDATIONS, ARCIMEDES_ROW_ID: res[6].data[0].ARCIMEDES_ROW_ID, UPDATED: res[6].data[0].UPDATED }
                    : this.state.proposalData;
                let updatedData = freshProposal;
                if (!freshProposal.UPDATED) {
                    updatedData = this.handleProposalDataByType(data, freshProposal);
                }

                this.setState({
                    currentHistoryData: currentData,
                    financialsSpreadsheetInView: false,
                    data: { ...this.state.data, ...data },
                    originalData: res[0],
                    original: CRUDProperty.excludeSellerData(res[0].data[0]),
                    originalLoanQuotesData: originalLoanQuotesData,
                    loanNotesData: loanNotesData,
                    originalLoanNotesData: originalLoanNotesData,
                    historyData: historyData,
                    loanQuotesData: loanQuotesData,
                    propertyPaymentsData: propertyPaymentsData,
                    originalPaymentsData: originalPaymentsData,
                    displayedHSCAgents: displayedHSCAgents < 1 ? 1 : displayedHSCAgents,
                    seller: seller,
                    originalSeller: { ...seller },
                    currentUser: userName,
                    error: null,
                    loadError: null,
                    proposalData: updatedData,
                    proposalDataOriginal: updatedData,
                    isHotList: hasHotListEntry,
                    isNewDevelopment: hasNewDevEntry,
                    isNeedOwner: hasNeedOwnerEntry,
                    isResearched: hasResearchedEntry,
                }, async () => {
                    await this.getNetFeeFromFeeAmount(data);
                    await this.getAgentsGrossCumulativeProcured(data, propertyPaymentsData);
                    await this.getHscAgentsGrossCumulative(data);
                    this.decoratePaymentSnapshotPresence(historyData);
                });
            } else {
                this.setState({
                    data: false,
                    original: false,
                    originalLoanQuotesData: false,
                    originalPaymentsData: false,
                    seller: false,
                    originalSeller: false,
                    loadError: null,
                    error: res[0].message ? res[0].message : "Unidentified Error",
                });
            }
        }).catch((err) => {
            // Without this terminal catch, a rejection in any of the parallel
            // loads above (or a throw while post-processing them) left `data`
            // stuck on null forever — the page showed an infinite spinner that
            // a refresh could not clear. Surface a recoverable error instead.
            console.error("Failed to load property", id, err);
            this.setState({
                data: false,
                original: false,
                originalLoanQuotesData: false,
                originalPaymentsData: false,
                seller: false,
                originalSeller: false,
                loadError: "Failed to load this property. Please try again.",
            });
        });
    }

    resolveProposalDefaults(propertyData, proposalData) {
        const config = this.state.standardTextConfig;
        if (!config || !config.defaults) {
            return { ...proposalData };
        }

        const PROPOSAL_FIELDS = ['BUYER_POOL', 'QUALIFICATIONS', 'RECOMMENDATIONS', 'STRENGTHS', 'CHALLENGES'];
        let result = { ...proposalData };

        PROPOSAL_FIELDS.forEach((key) => {
            if (config.defaults[key]) {
                result[key] = config.defaults[key].replace(/\n/g, ' \n ');
            }
        });

        if (config.overrides && Array.isArray(config.overrides)) {
            const category = propertyData && propertyData.CATEGORY ? propertyData.CATEGORY : '';
            const userTeamRowId = this.state.currentUserTeamRowId;
            const propertyState = propertyData && propertyData.STATE ? propertyData.STATE.toUpperCase().trim() : '';
            const map = this.state.teamMemberMap || {};
            const emailToId = map.emailToId || {};

            const propertyAgentIds = [];
            ['HSC_TEAM_MEMBER_1', 'HSC_TEAM_MEMBER_2'].forEach((k) => {
                const agentEmail = propertyData && propertyData[k] ? propertyData[k].toLowerCase().trim() : '';
                if (agentEmail && emailToId[agentEmail]) {
                    propertyAgentIds.push(emailToId[agentEmail]);
                }
            });

            const teamMemberMatchesRule = (memberIds) => {
                if (userTeamRowId && memberIds.includes(String(userTeamRowId))) return true;
                return propertyAgentIds.some((id) => memberIds.includes(id));
            };

            config.overrides.forEach((rule) => {
                let matches = false;

                if (rule.conditionType === 'category' && category && rule.conditionValue === category) {
                    matches = true;
                } else if (rule.conditionType === 'team_members') {
                    const memberIds = Array.isArray(rule.conditionValue) ? rule.conditionValue : [];
                    matches = teamMemberMatchesRule(memberIds);
                } else if (rule.conditionType === 'state') {
                    const ruleStates = Array.isArray(rule.conditionValue) ? rule.conditionValue : [];
                    matches = propertyState && ruleStates.includes(propertyState);
                } else if (rule.conditionType === 'team_members_state' && rule.conditionValue) {
                    const cv = rule.conditionValue;
                    const memberIds = Array.isArray(cv.teamMembers) ? cv.teamMembers : [];
                    const ruleStates = Array.isArray(cv.states) ? cv.states : [];
                    const teamMatch = teamMemberMatchesRule(memberIds);
                    const stateMatch = propertyState && ruleStates.includes(propertyState);
                    matches = teamMatch && stateMatch;
                }

                if (matches && rule.fields) {
                    Object.keys(rule.fields).forEach((key) => {
                        if (PROPOSAL_FIELDS.includes(key)) {
                            result[key] = rule.fields[key].replace(/\n/g, ' \n ');
                        }
                    });
                }
            });
        }

        return result;
    }

    handleProposalDataByType(propertyData, proposalData) {
        return this.resolveProposalDefaults(propertyData, proposalData);
    }

    // Manually re-pulls proposal text from the Standard Text defaults/overrides for
    // properties whose proposal has already been edited (UPDATED === '1'), which
    // normally opts out of the automatic defaults resolver in componentDidUpdate.
    // The user still has to click Save to persist the refreshed text.
    handleRefreshProposalDefaults() {
        if (!this.state.standardTextConfig || !this.state.data) return;
        const refreshed = this.resolveProposalDefaults(this.state.data, this.state.proposalData);
        // Mark as edited so the auto-resolver does not immediately undo the refresh
        // on the next render cycle (and so any Save picks up the new values).
        refreshed.UPDATED = new Date().toISOString();
        this.setState({ proposalData: refreshed });
    }

    saveUnderwritingTenants(tenants) {
        manageData({
            tableCode: UNDERWRITING_TENANTS,
            data: tenants,
        }).then((result) => {
            if (!result || !result.success) {
                this.setState({
                    error: result.message ? result.message : "Unidentified Error",
                });
            }
        });
    }

    async getAgentsGrossCumulativeProcured(data, paymentsData) {
        if (!(data && paymentsData && ['SUMMIT', 'External'].includes(data.SOURCE) && data.STATUS === 'Closed' && data.CLOSE_OF_ESCROW && paymentsData.length)) return;

        const year = stringUStoISO(data.CLOSE_OF_ESCROW).split('-')[0];
        const agentIndices = [];
        const requests = [];

        paymentsData.forEach((row, index) => {
            if (row.STRIVE_TEAM_MEMBER_ID) {
                agentIndices.push(index);
                const q = { AGENT_ID: row.STRIVE_TEAM_MEMBER_ID, YEAR: year, order: 'CLOSE_OF_ESCROW.asc' };
                requests.push(executeQuery({ queryName: AGENT_COMMISSION_PAID, options: filter(q, 'agent-commission') }));
            }
        });

        if (!requests.length) return;

        const results = await Promise.all(requests);
        const propertyPaymentsData = cloneDeep(this.state.propertyPaymentsData);
        const agentsGrossCumulativeProcured = {};

        results.forEach((result, i) => {
            const paymentIndex = agentIndices[i];
            if (!result || !result.success || !Array.isArray(result.data)) return;

            // Deduplicate by property, sort by COE — same approach as the agent commission breakdown page
            const seen = new Set();
            const deals = result.data
                .filter(d => { if (seen.has(d.ARCIMEDES_ROW_ID)) return false; seen.add(d.ARCIMEDES_ROW_ID); return true; })
                .sort((a, b) => new Date(a.CLOSE_OF_ESCROW) - new Date(b.CLOSE_OF_ESCROW));

            let previousCumulative = 0;
            for (const deal of deals) {
                const listing = parseFloat(deal.LISTING_GROSS_COMMISSION || 0);
                const buying = parseFloat(deal.BUYING_GROSS_COMMISSION || 0);
                const grossCumulativeForPaid = previousCumulative + listing + buying;

                if (String(deal.ARCIMEDES_ROW_ID) === String(data.ARCIMEDES_ROW_ID)) {
                    agentsGrossCumulativeProcured[`GROSS_CUMULATIVE_${paymentIndex + 1}`] = grossCumulativeForPaid;

                    const grossFee = parseFloat(deal.TEAM_MEMBER_GROSS_FEE || 0);
                    if (grossFee && propertyPaymentsData[paymentIndex]) {
                        // Same tranche formula as buildRow (GrossType.Paid)
                        const agentPreviousPercent = getPaymentPercentage(previousCumulative) / 100;
                        const agentCurrentPercent = getPaymentPercentage(grossCumulativeForPaid) / 100;
                        let net;
                        if (agentPreviousPercent !== agentCurrentPercent) {
                            const threshold = getPaymentThreshold(grossCumulativeForPaid);
                            if (grossFee >= (threshold - previousCumulative)) {
                                net = (threshold - previousCumulative) * agentPreviousPercent + (grossFee - (threshold - previousCumulative)) * agentCurrentPercent;
                            } else {
                                net = (grossFee - (grossCumulativeForPaid - threshold)) * agentPreviousPercent + (grossCumulativeForPaid - threshold) * agentCurrentPercent;
                            }
                        } else {
                            net = grossFee * agentCurrentPercent;
                        }
                        propertyPaymentsData[paymentIndex].STRIVE_TEAM_MEMBER_NET_FEE = (Math.floor(net * 100) / 100).toFixed(2);
                        propertyPaymentsData[paymentIndex].STRIVE_TEAM_MEMBER_NET_PERCENT = (net / grossFee * 100).toFixed(2);
                    }
                    break;
                }
                previousCumulative = grossCumulativeForPaid;
            }
        });

        this.setState({ agentsGrossCumulativeProcured, propertyPaymentsData });
    }

    computeHscAgentFees(data, memberKey) {
        const agentsGrossCumulative = cloneDeep(this.state.hscAgentsGrossCumulative);

        data[memberKey + '_GROSS_FEE'] = priceToNumber(data.HSC_LIST_FEE) * percentToNumber(data[memberKey + '_PERCENT']) / 100;
        const previousCumulative = agentsGrossCumulative[data[memberKey]];
        const cumulative = data[memberKey + '_GROSS_FEE'] ? data[memberKey + '_GROSS_FEE'] + previousCumulative : previousCumulative;
        const agentPreviousPercent = getHSCCumulativeAgentPercent(previousCumulative);
        const agentPercent = getHSCCumulativeAgentPercent(cumulative);
        let agentNet;
        if (agentPreviousPercent !== agentPercent) {
            const threshold = getHSCCumulativeThreshold(cumulative);
            agentNet = (threshold - previousCumulative) * agentPreviousPercent + (cumulative - threshold) * agentPercent;
        }
        else
            agentNet = data[memberKey + '_GROSS_FEE'] ? data[memberKey + '_GROSS_FEE'] * agentPercent : 0;

        data[memberKey + '_NET_FEE'] = Number(agentNet).toFixed(2);
        data[memberKey + '_NET_PERCENT'] = agentNet / data[memberKey + '_GROSS_FEE'] * 100;
        data[memberKey + '_GROSS_FEE'] = data[memberKey + '_GROSS_FEE'].toFixed(2)
        return data;
    }

    async getHscAgentGrossCumulative(data, teamMember) {
        if ((data.SOURCE === 'HSC' || data.HSC_FINANCING) && data.LOAN_CLOSING_DATE) {
            const loanClosingDate = stringUStoISO(data.LOAN_CLOSING_DATE);
            const request = executeQuery({
                queryName: HSC_AGENT_CUMULATIVE,
                params: {
                    HSC_TEAM_MEMBER: teamMember,
                    CURRENT_PROPERTY: data.ARCIMEDES_ROW_ID,
                    DATE: loanClosingDate,
                }
            });

            const res = await request;
            let hscAgentsGrossCumulative = this.state.hscAgentsGrossCumulative, errorMessage = null;

            if (res.success && Array.isArray(res.data)) {
                hscAgentsGrossCumulative[teamMember] = res.data[0] && res.data[0].HSC_AGENT_GROSS_CUMULATIVE ? parseFloat(res.data[0].HSC_AGENT_GROSS_CUMULATIVE) : 0;
            } else
                errorMessage = res.message ? res.message : "Unidentified Error";

            if (errorMessage)
                this.setState({
                    error: errorMessage,
                });
            else
                this.setState({
                    hscAgentsGrossCumulative,
                });
        }
    }
    async getNetFeeFromFeeAmount(propData) {
        const data = { ...propData };
        const date = new Date(data && data.CLOSE_OF_ESCROW);
        const year = date.getFullYear();
        const id = data && data.LISTING_AGENT_1;
        const feeAmount = data && data.REFERRAL_FEE;

        if (feeAmount && year != 1970 && id) {
            let q = {
                AGENT_ID: id,
                YEAR: year,
                order: 'CLOSE_OF_ESCROW.asc'
            }

            const options = filter(q, 'agent-commission');

            Promise.all([
                executeQuery({ queryName: AGENT_COMMISSION_PROCURED, options }),
                executeQuery({ queryName: AGENT_COMMISSION_PAID, options })
            ]).then(res => {
                if (res && res[0] && res[0].success && Array.isArray(res[0].data) &&
                    res[1] && res[1].success && Array.isArray(res[1].data)) {
                    let grossCumulative = 0;
                    let currentTrenche = 0;
                    let insertionIndex = 0;
                    let paidData = removeDuplicateObjects(res[1].data.filter(property => property.MEMBER_ID === id));
                    let map = new Map();
                    res[0].data.forEach(item => {
                        map.set(item.ARCIMEDES_ROW_ID, item)
                    });
                    paidData.forEach(item => {
                        if (map.has(item.ARCIMEDES_ROW_ID)) {
                            let TEAM_MEMBER_GROSS_FEE = item.TEAM_MEMBER_GROSS_FEE;
                            map.set(item.ARCIMEDES_ROW_ID, { ...map.get(item.ARCIMEDES_ROW_ID), TEAM_MEMBER_GROSS_FEE });
                        } else {
                            map.set(item.ARCIMEDES_ROW_ID, item);
                        }
                    });
                    const mergedArray = Array.from(map.values());
                    mergedArray.sort(compareDates);
                    const newCloseDate = new Date(data.CLOSE_OF_ESCROW);
                    const index = mergedArray.findIndex(item => new Date(item.CLOSE_OF_ESCROW) > newCloseDate);
                    if (index === -1) {
                        insertionIndex = mergedArray.length - 1;
                    } else {
                        insertionIndex = index - 1;
                    }
                    mergedArray.forEach((agentObj, index) => {
                        const listingProcuredGrossFee = agentObj.LISTING_GROSS_COMMISSION ? parseFloat(agentObj.LISTING_GROSS_COMMISSION) : 0;
                        const buyingProcuredGrossFee = agentObj.BUYING_GROSS_COMMISSION ? parseFloat(agentObj.BUYING_GROSS_COMMISSION) : 0;
                        const totalProcuredGrossFee = listingProcuredGrossFee + buyingProcuredGrossFee;
                        grossCumulative += totalProcuredGrossFee;
                        if (insertionIndex === index) {
                            currentTrenche = getCurrentTrancheOnGrossAmount(grossCumulative)
                            return;
                        }
                    });

                    data['TRANCHE'] = currentTrenche * 100;
                    data['NET_FEE'] = ((parseFloat(feeAmount.replace(/,/g, '')) * currentTrenche)).toFixed(2);
                    this.setState({
                        netFee: (parseFloat(data.NET_FEE.replace(/,/g, ''))).toFixed(2),
                        tranche: (currentTrenche * 100).toString(),
                        data: convertDataToForm(data)
                    });
                }
            });
        }

    }
    async getHscAgentsGrossCumulative(data) {
        let assignedTeamMembers = [];
        hscAgentsKeys.map((key) => {
            if (data && data[key])
                assignedTeamMembers.push(data[key])
        })
        if (data && (data.SOURCE === 'HSC' || data.HSC_FINANCING) && data.LOAN_CLOSING_DATE) {
            const requests = [];
            const loanClosingDate = stringUStoISO(data.LOAN_CLOSING_DATE);
            assignedTeamMembers.forEach((agent) => {
                requests.push(
                    executeQuery({
                        queryName: HSC_AGENT_CUMULATIVE,
                        params: {
                            HSC_TEAM_MEMBER: agent,
                            CURRENT_PROPERTY: data.ARCIMEDES_ROW_ID,
                            DATE: loanClosingDate,
                        }
                    })
                );
            });


            const res = await Promise.all(requests);
            let hscAgentsGrossCumulative = {}, errorMessage = null;
            res.forEach((r, index) => {
                if (r.success && Array.isArray(r.data)) {
                    hscAgentsGrossCumulative[hscTeamMembers[index].EMAIL] = r.data[0] && r.data[0].HSC_AGENT_GROSS_CUMULATIVE ? parseFloat(r.data[0].HSC_AGENT_GROSS_CUMULATIVE) : 0;
                } else
                    errorMessage = r.message ? r.message : "Unidentified Error";
            });

            if (errorMessage)
                this.setState({
                    error: errorMessage,
                });
            else
                this.setState({
                    hscAgentsGrossCumulative,
                });
        }
    }

    async getAgentGrossCumulativeProcured(id, closeOfEscrow) {
        const res = await executeQuery({
            queryName: GET_AGENT_GROSS_CUMULATIVE,
            params: {
                CURRENT_STRIVE_TEAM_MEMBER: id,
                CLOSE_OF_ESCROW: stringUStoISO(closeOfEscrow)
            }
        });
        if (res && res.success && Array.isArray(res.data)) {
            let grossCumulativeProcured = res.data[0] && res.data[0].LISTING_PROCURED_GROSS_CUMULATIVE ? parseFloat(res.data[0].LISTING_PROCURED_GROSS_CUMULATIVE) : 0;
            grossCumulativeProcured += res.data[0] && res.data[0].BUYING_PROCURED_GROSS_CUMULATIVE ? parseFloat(res.data[0].BUYING_PROCURED_GROSS_CUMULATIVE) : 0;
            return grossCumulativeProcured;
        }
        this.setState({
            error: res.message ? res.message : "Unidentified Error",
        });
        return 0;
    }

    static editTrackingTask(data, task, key, substringStart, substringEnd) {
        let newTask = cloneDeep(task);
        const str = newTask.substring(substringStart, substringEnd);
        if (str) {
            newTask = newTask.replace(str, data[key] ? data[key] : "");
        } else {
            newTask = newTask.split("");
            newTask.splice(substringStart, 0, data[key] ? data[key] : "");
            newTask = newTask.join("");
        }
        return newTask;
    }

    fetchAccountNumber() {
        let options = {
            "param": {
                "PROPERTY_ID": this.props.params.id
            }
        }
        Promise.all([
            executeQuery({ queryName: GET_PROPERTY_ACCOUNT_NUMBER, options: options })
        ]).then(res => {
            if (res && res[0] && res[0].data && res[0].data[0]) {
                this.setState(prevState => ({ ...prevState, account: { id: res[0].data[0].ARCIMEDES_ROW_ID, value: res[0].data[0].ACCOUNT_NUMBER } }))
            }
        });
    }

    fetchSeller() {
        request(arc.path.api, {
            service: "arcimedes",
            action: "open.datasource.table.Data.getData",
            params: ["code", SELLERS, {
                filter: [{
                    text: this.state.data.SELLER_ID,
                    code: "ARCIMEDES_ROW_ID",
                    type: "exact",
                },],
            },],
        }).then((res) => {
            if (res && res.success && Array.isArray(res.data) && res.data.length) {
                const seller = {};
                sellerKeys.forEach(key => {
                    seller[key] = res.data[0][key];
                });
                this.setState({
                    seller,
                    originalSeller: { ...seller },
                    sellerSelected: false,
                    error: null,
                });
            } else {
                this.setState({
                    data: false,
                    error: res.message ? res.message : "Unidentified Error",
                });
            }
        });
    }

    static updatePropertyData({ data, oldData, original }) {
        const newData = {
            PROPERTY_ID: oldData.ARCIMEDES_ROW_ID,
        };

        let task = `${original.NAME} - ${original.CITY ? original.CITY : ""}, ${original.STATE ? original.STATE : ""}`;
        if (data.hasOwnProperty("NAME")) {
            task = CRUDProperty.editTrackingTask(data, task, "NAME", 0, task.indexOf("-") - 1);
        }
        if (data.hasOwnProperty("CITY")) {
            task = CRUDProperty.editTrackingTask(data, task, "CITY", task.indexOf("-") + 2, task.indexOf(","));
        }
        if (data.hasOwnProperty("STATE")) {
            task = CRUDProperty.editTrackingTask(data, task, "STATE", task.indexOf(",") + 2, task.length);
        }
        newData.TASK = task;

        return newData;
    }

    async fetchEscrowData(data) {

        let inEscrow = false;
        const propertyInEscrow = await this.getPropertyEscrowTracking(this.state.data.ARCIMEDES_ROW_ID);
        const oldData = this.state.data;
        const striveID = summitFirmId;
        const isStatusActive = Object.keys(this.state.data).length && this.state.data.hasOwnProperty('STATUS') && this.state.data.STATUS && this.state.data.STATUS.toLowerCase() === "active";

        // In Escrow if source is SUMMIT & status is Under Contract
        //       or if status is Under Contract & Buyer Agent Firm is SUMMIT
        if ((oldData.SOURCE === "SUMMIT" && oldData.STATUS === "Under Contract") ||
            (oldData.STATUS === "Under Contract" && oldData.BUYER_AGENT_4_FIRM === striveID)) {
            inEscrow = true;
        }
        // Add property to STRIVE Escrow Tracking
        if (inEscrow && oldData.ARCIMEDES_ROW_ID &&
            (!propertyInEscrow || !propertyInEscrow.ARCIMEDES_ROW_ID || propertyInEscrow.DELETED === "1")) {
            let newData = {
                PROPERTY_ID: oldData.ARCIMEDES_ROW_ID,
                TASK: `${oldData.NAME} - ${oldData.CITY ? oldData.CITY : ""}, ${oldData.STATE ? oldData.STATE : ""}`,
                DELETED: null,
            };
            this.updatePropertyTracking(newData, SUMMIT_ESCROW_TRACKING);
        }

        // Update property info in STRIVE Escrow Tracking
        if (propertyInEscrow && propertyInEscrow.ARCIMEDES_ROW_ID && propertyInEscrow.DELETED !== "1" && oldData.ARCIMEDES_ROW_ID &&
            (data.hasOwnProperty("NAME") || data.hasOwnProperty("CITY") || data.hasOwnProperty("STATE"))) {
            const original = this.state.original;
            const newData = CRUDProperty.updatePropertyData({ data, oldData, original });
            this.updatePropertyTracking(newData, SUMMIT_ESCROW_TRACKING);
        }

        // Remove property from STRIVE Escrow Tracking
        if ((!inEscrow && propertyInEscrow && propertyInEscrow.ARCIMEDES_ROW_ID && propertyInEscrow.DELETED !== "1")
            || oldData.DELETED === "1") {
            let data = {
                PROPERTY_ID: this.state.data.ARCIMEDES_ROW_ID,
                DELETED: "1",
            };

            const deleteEscrowRecords = {
                TITLE_COMPANY: '',
                ESCROW_OFFICER: '',
                PSA_SENT_TO_BUYER: '',
                PSA_SENT_TO_BUYER_CHECKBOX: 0,
                HAVE_ALL_DUE_DILIGENCE_MATERIALS: '',
                EFFECTIVE_DATE: '',
                EFFECTIVE_DATE_CHECKBOX: 0,
                ROFR_NOTICE_SENT_TO_TENANT: '',
                ROFR_NOTICE_SENT_TO_TENANT_CHECKBOX: 0,
                ROFR_WAIVER_SENT_TO_BUYERSIDE__TITLE_CO: '',
                ROFR_WAIVER_SENT_TO_BUYERSIDE__TITLE_CO_CHECKBOX: 0,
                PSA_SENT_TO_TITLE: '',
                PSA_SENT_TO_TITLE_CHECKBOX: 0,
                SURVEY_SENT_TO_TITLE: '',
                SURVEY_SENT_TO_TITLE_CHECKBOX: 0,
                RECEIPTED_PSA_RECEIVED__SENT_TO_BUYERS_AGENT: '',
                RECEIPTED_PSA_RECEIVED__SENT_TO_BUYERS_AGENT_CHECKBOX: 0,
                DD_SITE_CREATED__ACCESS_GRANTED: '',
                DD_SITE_CREATED__ACCESS_GRANTED_CHECKBOX: 0,
                UPDATED_DB__ISUMMIT: '',
                UPDATED_TO_UC_ON_EXTERNALS: '',
                WIRING_INSTRUCTIONS_SENT_TO_BUYERAGENT: '',
                EARNEST_MONEY_RECEIVED: '',
                EARNEST_MONEY_RECEIVED_CHECKBOX: 0,
                HAS_TITLE_APPROVED_SURVEY: '',
                CLOSING_DATE_CHECKBOX: '',
                CLOSING_DATE: '',
                CLOSING_EXTENSION: '',
                CLOSING_PERIOD: '',
                TITLE_SENT_OUT_CLOSING_STATEMENTS_FOR_REVIEW_CHECKBOX: 0,
                TITLE_SENT_OUT_CLOSING_STATEMENTS_FOR_REVIEW: '',
                UPDATE_INSURANCE_CERTIFICATES_CHECKBOX: 0,
                UPDATE_INSURANCE_CERTIFICATES: '',
                SEND_TITLE_INVOICE_WIRE_CAM_DEPOSITS_PRORATIONS_CHECKBOX: 0,
                SEND_TITLE_INVOICE_WIRE_CAM_DEPOSITS_PRORATIONS: '',
                VERIFY_CLOSE_10_DAYS_BEFORE_CLOSING_CHECKBOX: 0,
                VERIFY_CLOSE_10_DAYS_BEFORE_CLOSING: '',
                ESTOPPELSSDNA_DUE_CHECKBOX: 0,
                ESTOPPELSSDNA_DUE: '',
                ESTOPPELSNDA_REQUESTED_FROM_LENDER_BUYER_OR_TENANT_CHECKBOX: 0,
                ESTOPPELSNDA_REQUESTED_FROM_LENDER_BUYER_OR_TENANT: '',
                ADDITIONAL_EARNEST_MONEY_RECEIVED_CHECKBOX: 0,
                ADDITIONAL_EARNEST_MONEY_RECEIVED: '',
                FINANCING_PERIOD_ENDS_CHECKBOX: 0,
                FINANCING_PERIOD_ENDS: '',
                FINANCING_APPROVAL_CHECKBOX: 0,
                FINANCING_APPROVAL: '',
                FEASIBILITY_PERIOD_EXPIRES__DEPOSIT_NONREFUNDABLE_CHECKBOX: 0,
                FEASIBILITY_PERIOD_EXPIRES__DEPOSIT_NONREFUNDABLE: '',
                FEASIBILITY_EXTENSION: '',
                FEASIBILITY_PERIOD: '',
                FINANCING_APPLICATION_DEADLINE_CHECKBOX: 0,
                FINANCING_APPLICATION_DEADLINE: '',
                TITLE_OBJECTION_PERIOD_CHECKBOX: 0,
                TITLE_OBJECTION_PERIOD: '',
                SELLER_RESPONSE_TO_BUYER_OBJECTIONS_CHECKBOX: 0,
                SELLER_RESPONSE_TO_BUYER_OBJECTIONS: '',
                BUYERS_TITLE_OBJECTIONS_DUE_CHECKBOX: 0,
                BUYERS_TITLE_OBJECTIONS_DUE: '',
                RECEIVED_TITLE_COMMITMENT_CHECKBOX: 0,
                RECEIVED_TITLE_COMMITMENT: '',
                SURVEY_ORDERED_CHECKBOX: 0,
                SURVEY_ORDERED: '',
            }

            if (isStatusActive) {
                // Delete the escrow tracking data if the property status is modified to active
                data = { ...data, ...deleteEscrowRecords }
            }

            this.updatePropertyTracking(data, SUMMIT_ESCROW_TRACKING);
        }
    }

    async fetchHscTrackingData(data) {
        let tracking = false;
        const property = await this.getPropertyHscTracking(this.state.data.ARCIMEDES_ROW_ID);
        const oldData = this.state.data;

        // Tracking if (source is HSC or is HSC financing) & status is Loan In Process
        if ((oldData.SOURCE === 'HSC' || oldData.HSC_FINANCING) && oldData.HSC_STATUS === 'Loan In Process') {
            tracking = true;
        }

        // Add property to HSC Tracking
        if (tracking && oldData.ARCIMEDES_ROW_ID &&
            (!property || !property.ARCIMEDES_ROW_ID || property.DELETED === '1')) {
            let newData = {
                PROPERTY_ID: oldData.ARCIMEDES_ROW_ID,
                TASK: `${oldData.NAME} - ${oldData.CITY ? oldData.CITY : ''}, ${oldData.STATE ? oldData.STATE : ''}`,
                DELETED: null,
            };
            this.updatePropertyTracking(newData, HSC_TRACKING);
        }

        // Update property info in HSC Tracking
        if (property && property.ARCIMEDES_ROW_ID && property.DELETED !== '1' && oldData.ARCIMEDES_ROW_ID &&
            (data.hasOwnProperty('NAME') || data.hasOwnProperty('CITY') || data.hasOwnProperty('STATE'))) {
            const original = this.state.original;
            const newData = CRUDProperty.updatePropertyData({ data, oldData, original });
            this.updatePropertyTracking(newData, HSC_TRACKING);
        }

        // Remove property from HSC Tracking
        if ((!tracking && property && property.ARCIMEDES_ROW_ID && property.DELETED !== '1') || oldData.DELETED === '1') {
            const data = {
                PROPERTY_ID: this.state.data.ARCIMEDES_ROW_ID,
                DELETED: '1',
            };
            this.updatePropertyTracking(data, HSC_TRACKING);
        }
    }
    async saveData(newData, showSaveAlert = true) {

        const loanQuotesDataCopy = [...this.state.loanQuotesData]
        if (loanQuotesDataCopy.length) {
            loanQuotesDataCopy.forEach((data) => {
                if (!data.ARCIMEDES_ROW_ID && !isLiveLoanQuote(data)) {
                    data.AUTOPOPULATE = 1;
                }
                else if (data.ARCIMEDES_ROW_ID && isLiveLoanQuote(data) && data.AUTOPOPULATE) {
                    data.AUTOPOPULATE = 0;
                }
            })
        }
        this.setState({ loanQuotesData: loanQuotesDataCopy })
        const changedData = { ...newData };
        if (Object.keys(changedData).length) {
            for (let datafields in changedData) {
                const restricedFields = ["DOORS", 'OFFICE_TO_WAREHOUSE', 'CLEAR_HEIGHT']
                if (restricedFields.includes(datafields)) {
                    delete changedData[datafields];
                }
            }
        }

        let data = {};
        const seller = { ...this.state.seller };
        let lqData = convertLoanQuotesFormToData(this.state.loanQuotesData);
        let paymentsData = this.state.propertyPaymentsData ? convertPaymentsFormToData(this.state.propertyPaymentsData) : [];
        let deletedPaymentsData = this.state.deletedPaymentsData ? this.state.deletedPaymentsData : [];
        let hotlistData = '';
        let newDevelopmentData = '';

        // Prepare lead_links data for saving to separate table
        const leadLinks = this.state.data.lead_links || [];
        let leadLinksData = [];

        // Check if property is being deleted (from the data being saved)
        // Check newData parameter, changedData, and current state
        const isBeingDeleted = (newData && newData.DELETED === "1") ||
            (changedData && changedData.DELETED === "1") ||
            (this.state.data && this.state.data.DELETED === "1");
        const wasDeleted = this.state.original && this.state.original.DELETED === "1";


        if (changedData) {
            data = convertFormToData(changedData);
        } else {
            data = convertFormToData(this.state.data);
        }
        // Property Address Format
        data.ADDRESS = formatAddress(data.ADDRESS);
        data.ADDRESS = data.ADDRESS != null ? data.ADDRESS.replace(/ *\([^)]*\) */g, "") : data.ADDRESS;
        data.ADDRESS = data.ADDRESS != null ? data.ADDRESS.replace('(', '') : data.ADDRESS;
        data.ADDRESS = data.ADDRESS != null ? data.ADDRESS.replace(')', '') : data.ADDRESS;
        data.ADDRESS = data.ADDRESS != null ? data.ADDRESS.replaceAll('.', ' ') : data.ADDRESS;


        if (this.state.currentUser) {
            data.LAST_MODIFIED_BY = this.state.currentUser;
        } else {
            // Fallback to userData if currentUser is not set
            const userName = (this.props.userData && this.props.userData.person && this.props.userData.person.firstName && this.props.userData.person.lastName)
                ? `${this.props.userData.person.firstName} ${this.props.userData.person.lastName}`
                : (this.props.userData && this.props.userData.email) || 'System';
            data.LAST_MODIFIED_BY = userName;
            console.warn('⚠️ currentUser was not set, using fallback:', userName);
        }
        data.LAST_MODIFIED_DATE = new Date().toISOString().split("T")[0];

        // Fix for Phase 1: Set DATE_CREATED and CREATED_BY if they're null (legacy data fix)
        if (!this.state.original.DATE_CREATED || !this.state.original.CREATED_BY) {
            if (!data.DATE_CREATED && !this.state.original.DATE_CREATED) {
                data.DATE_CREATED = new Date().toISOString().split("T")[0];
            }
            if (!data.CREATED_BY && !this.state.original.CREATED_BY) {
                data.CREATED_BY = data.LAST_MODIFIED_BY;
            }
        }

        if (this.state.original.STATUS === 'Proposal') {
            data.PROPOSAL_DATE = new Date().toISOString().split("T")[0];
        }
        hotlistData = await this.getHotListPropertiesByEmail();
        newDevelopmentData = await this.getNewDevelopmentPropertiesByEmail();
        if (data.HOT_LIST) {
            this.setState({ isHotList: true });
        } else {
            this.setState({ isHotList: false });
        }
        if (data.NEW_DEVELOPMENT) {
            this.setState({ isNewDevelopment: true });
        } else {
            this.setState({ isNewDevelopment: false });
        }
        if (this.state.original.CLOSE_OF_ESCROW !== data.CLOSE_OF_ESCROW)
            paymentsData = await this.recomputePayments(data, paymentsData);

        if (this.state.original.STATUS !== data.STATUS)
            this.setState({ hasModifiedStatus: true });
        if (this.state.data.SOURCE === 'HSC' && (this.state.original.HSC_STATUS !== data.HSC_STATUS))
            this.setState({ hasModifiedStatus: true });
        if (data.HSC_APPROVED === 'y')
            this.setState({ isHscApproved: true });
        if (this.state.original.LIST_PRICE !== data.LIST_PRICE)
            this.setState({ hasModifiedListPrice: true });
        if (this.state.original.LIST_PRICE > data.LIST_PRICE)
            this.setState({ hasReducedListPrice: true });
        if (data.TRANSACTION_TYPE === 'Referral' && this.state.original.CLOSE_OF_ESCROW !== data.CLOSE_OF_ESCROW && data.CLOSE_OF_ESCROW) {
            this.setState({ isClosedReferral: true });
        }

        if (this.state.original.STATUS === 'Proposal' && data.STATUS === 'Property Info')
            data.PROPERTY_INFO_SINCE = new Date().toISOString().split('T')[0];
        if (this.state.original.STATUS !== 'Off Market' && data.STATUS === 'Off Market')
            data.OFF_MARKET_SINCE = new Date().toISOString().split('T')[0];
        // Stamp when the property first enters the Courting (HSC) status, so the
        // properties list can show/sort by that date.
        if (this.state.original.HSC_STATUS !== 'Courting' && data.HSC_STATUS === 'Courting')
            data.COURTING_SINCE = new Date().toISOString().split('T')[0];

        if (["Active", "Closed"].includes(this.state.original["STATUS"])
            && ["Under Contract", "In Negotiation"].includes(data["STATUS"])) {
            data.UNDER_CONTRACT_IN_NEGOTIATION_SINCE = new Date().toISOString().split("T")[0];
        } else if (["Under Contract", "In Negotiation"].includes(this.state.original["STATUS"])
            && ["Active", "Closed"].includes(data["STATUS"])
            && this.state.original.UNDER_CONTRACT_IN_NEGOTIATION_SINCE
            && (data.LISTED_DATE || data.EXPIRATION_DATE)) {
            const lastModifiedDate = new Date(this.state.original.UNDER_CONTRACT_IN_NEGOTIATION_SINCE);
            const today = new Date();

            // Calculate how many days a property spent in a status of 'Under Contract' or 'In Negotiation'
            const diffDays = Math.floor(Math.abs(today - lastModifiedDate) / (1000 * 60 * 60 * 24));

            if (data.LISTED_DATE) {
                const listingDate = new Date(data.LISTED_DATE);
                listingDate.setDate(listingDate.getDate() + diffDays);
                data.LISTED_DATE = listingDate.toISOString().split("T")[0];
            }

            if (data.EXPIRATION_DATE) {
                const expiringDate = new Date(data.EXPIRATION_DATE);
                expiringDate.setDate(expiringDate.getDate() + diffDays);
                data.EXPIRATION_DATE = expiringDate.toISOString().split("T")[0];
            }
        }

        if (Number(data.IS_LISTING) !== 1 && ["Active", "In Negotiation", "Under Contract", "Removed"].includes(data.STATUS)) {
            data.IS_LISTING = 1;
        }

        if (Number(data.IS_LISTING) === 1 && ["Closed", "Off Market"].includes(data.STATUS)) {
            data.IS_LISTING = 0;
        }
        // #7221 adding proposed agent as listing 1 agent
        if (!this.props.edit && editsOwnSummitDealsOnly(getCurrentAccess()) && newData.NAME && data.STATUS === "Proposal" && data.SOURCE == 'SUMMIT') {
            const currentUserFromList = this.state.agentList.filter(res => res.FIRST_NAME + " " + res.LAST_NAME === this.state.currentUser);
            if (currentUserFromList.length) {
                data.LISTING_AGENT_1 = currentUserFromList[0].ARCIMEDES_ROW_ID;
                data.LISTING_AGENT_1_PERCENT = '100.00'
            }
        }

        if (editsOwnSummitDealsOnly(getCurrentAccess()) && data.STATUS == 'Closed' && data.SOURCE == 'External') {
            if (!data.CLOSE_OF_ESCROW && !this.state.openElscrowDialog) {
                this.setState({ openEscrowDialog: true });
                return;
            }
        }

        if (!data.WAS_PROPOSAL && data.STATUS === "Proposal") {
            data.WAS_PROPOSAL = 1;
        }

        if (data.CLOSE_OF_ESCROW && data.TRANSACTION_TYPE === 'Referral')
            data.STATUS = 'Closed';

        if (this.state.original.STATUS !== data.STATUS && data.STATUS === 'Flagged') {
            data.FLAGGED_DATE = new Date().toISOString().split("T")[0];
        }

        // When FEATURED is active, send FEATURED_DATE (date we made FEATURED active); when unchecked, save as empty
        if (data.FEATURED) {
            data.FEATURED_DATE = (this.state.original.FEATURED && this.state.original.FEATURED_DATE)
                ? this.state.original.FEATURED_DATE
                : new Date().toISOString().split("T")[0];
        } else {
            data.FEATURED_DATE = '2000-01-01';
        }

        if (data.CLOSE_OF_ESCROW) {
            // handle validation of close of escrow date field
            const validDatePattern = /^(\d{2})\/(\d{2})\/(\d{4})$/;
            if ((data.CLOSE_OF_ESCROW.includes("/") || !data.CLOSE_OF_ESCROW.includes("-")) && !validDatePattern.test(data.CLOSE_OF_ESCROW)) {
                this.setState({ openEscrowDateError: true });
                return;
            }
        }

        // Discard unchanged values. The Lender Contact goes with any Lender sent:
        // the server drops a contact a new Lender arrives without.
        const sendsLender = !(this.state.original.hasOwnProperty('LENDER_ID') && data.LENDER_ID === this.state.original.LENDER_ID);
        const changedFields = [];
        Object.keys(data).forEach((key) => {
            if (this.state.original.hasOwnProperty(key) && data[key] === this.state.original[key] || excludedKeys.includes(key)) {
                if (!(key === 'LENDER_CONTACT_ID' && sendsLender)) delete data[key];
            } else {
                changedFields.push(key);
            }
        });
        Object.keys(seller).forEach((key) => {
            if (this.state.originalSeller.hasOwnProperty(key) && seller[key] === this.state.originalSeller[key])
                delete seller[key];
        });

        let lqDataArray = [];
        lqData.forEach(elem => {
            elem.IS_PRINTABLE = elem.IS_PRINTABLE == true ? 1 : 0;
            if (elem.LOAN_QUOTES_MODIFIED === true || elem.ARCIMEDES_ROW_ID) {
                if (!elem.PROPERTY_ID && this.state.data.ARCIMEDES_ROW_ID) {
                    elem.PROPERTY_ID = this.state.data.ARCIMEDES_ROW_ID
                } else if (!elem.PROPERTY_ID && this.state.original.ARCIMEDES_ROW_ID) {
                    elem.PROPERTY_ID = this.state.original.ARCIMEDES_ROW_ID
                } else if (!elem.PROPERTY_ID && this.props.params.id) {
                    elem.PROPERTY_ID = this.props.params.id
                }
                lqDataArray.push(elem);
                delete elem.LOAN_QUOTES_MODIFIED;
            }
        });

        // Quotes deleted on the tab. These rows are already in DB shape, and
        // carry nothing but the id and the DELETED flag the gateway soft-deletes
        // on, so they skip convertLoanQuotesFormToData above.
        (this.state.deletedLoanQuotesData || []).forEach(elem => {
            if (elem.ARCIMEDES_ROW_ID) {
                lqDataArray.push(elem);
            }
        });

        let paymentsDataArray = [];
        if (this.state.original.TRANSACTION_TYPE === 'Extra Payment' && paymentsData) {
            // These fields can be undefined on a new/blank Extra Payment property;
            // guard so .replace()/.toString() can't throw and abort the save.
            const feeToNumber = (v) => parseFloat(String(v == null ? '' : v).replace(/,/g, '')) || 0;
            const toText = (v) => (v == null ? '' : v).toString();
            // `data` holds the values being saved (unchanged keys were discarded
            // above); `original` is the pre-edit row. Reading only from `original`
            // left the payment row pointing at the previous listing agent when
            // the agent was changed in this same save.
            const savedField = (key) => data[key] !== undefined ? data[key] : this.state.original[key];
            if (paymentsData && paymentsData[0] && paymentsData[0].ARCIMEDES_ROW_ID && paymentsData[0].ARCIMEDES_ROW_ID.trim() !== '') {
                paymentsData[0].PAYMENT_MODIFIED = true,
                    paymentsData[0].STRIVE_TEAM_MEMBER_ID = savedField('LISTING_AGENT_1');
                paymentsData[0].STRIVE_TEAM_MEMBER_PERCENT = savedField('LISTING_AGENT_1_PERCENT');
                paymentsData[0].STRIVE_TEAM_MEMBER_NET_FEE = feeToNumber(data.NET_FEE);
                paymentsData[0].STRIVE_TEAM_MEMBER_NET_PERCENT = toText(data.TRANCHE);
                paymentsData[0].STRIVE_TEAM_MEMBER_GROSS_FEE = feeToNumber(savedField('REFERRAL_FEE'));
            } else {
                const extraPaymentPaymentData = new Array({
                    PROPERTY_ID: paymentsData[0].PROPERTY_ID,
                    PAYMENT_MODIFIED: true,
                    STRIVE_TEAM_MEMBER_ID: savedField('LISTING_AGENT_1'),
                    STRIVE_TEAM_MEMBER_PERCENT: savedField('LISTING_AGENT_1_PERCENT'),
                    STRIVE_TEAM_MEMBER_NET_FEE: feeToNumber(data.NET_FEE),
                    STRIVE_TEAM_MEMBER_NET_PERCENT: toText(data.TRANCHE),
                    STRIVE_TEAM_MEMBER_GROSS_FEE: savedField('REFERRAL_FEE')
                });
                paymentsData = [...extraPaymentPaymentData];
            }
        }
        paymentsData && paymentsData.forEach(elem => {
            if (elem.PAYMENT_MODIFIED === true) {
                paymentsDataArray.push(elem);
                delete elem.PAYMENT_MODIFIED;
            }
        });
        deletedPaymentsData.forEach(elem => {
            if (elem.ARCIMEDES_ROW_ID)
                paymentsDataArray.push(elem);
        });

        // Prepare loan notes data
        let loanNotesDataArray = [];
        if (this.state.loanNotesData && Array.isArray(this.state.loanNotesData)) {
            this.state.loanNotesData.forEach(note => {
                // Include notes that are new (no ARCIMEDES_ROW_ID) or have been modified/deleted
                if (!note.ARCIMEDES_ROW_ID || note.DELETED === '1' || note.DELETED === 1 || note.MODIFIED) {
                    const propertyId = this.props.params.id || this.state.newPropertyId || this.state.data.ARCIMEDES_ROW_ID;
                    const noteData = {
                        ...note,
                        PROPERTY_ID: propertyId,
                        LAST_MODIFIED_BY: this.state.currentUser || data.LAST_MODIFIED_BY,
                        LAST_MODIFIED_DATE: new Date().toISOString().split("T")[0]
                    };
                    // Remove the MODIFIED flag before saving
                    delete noteData.MODIFIED;
                    loanNotesDataArray.push(noteData);
                }
            });
        }

        this.setState({
            referringAgentData: {
                REFERRING_LISTING_AGENT: data.REFERRING_LISTING_AGENT,
                REFERRING_LISTING_AGENT_PERCENT: data.REFERRING_LISTING_AGENT_PERCENT,
                REFERRING_LISTING_AGENT_FIRM: data.REFERRING_LISTING_AGENT_FIRM,
                REFERRING_BUYER_AGENT: data.REFERRING_BUYER_AGENT,
                REFERRING_BUYER_AGENT_PERCENT: data.REFERRING_BUYER_AGENT_PERCENT,
                REFERRING_BUYER_AGENT_FIRM: data.REFERRING_BUYER_AGENT_FIRM
            }
        });

        // No changes detected, nothing to do
        if (!Object.keys(data).length && !Object.keys(seller).length && !lqDataArray.length && !paymentsData.length && !loanNotesDataArray.length) {
            this.setState({
                isBusy: null,
                error: null,
                success: "No data to update",
            });
            window.scrollTo(0, 0);
            return;
        }

        this.setState({
            isBusy: true,
            error: null,
            success: null,
            emailNotificationMessages: [],
        });
        const isExtraPayment = this.state.data && this.state.data.TRANSACTION_TYPE === 'Extra Payment';
        if (isExtraPayment) {
            await this.calculateGrossAmount();
            data.STATUS = 'Closed';
        }
        await this.fetchEscrowData(data);
        await this.fetchHscTrackingData(data);

        data.ARCIMEDES_ROW_ID = this.props.params.id
            || this.state.newPropertyId
            || (this.state.original && this.state.original.ARCIMEDES_ROW_ID)
            || null;

        // Prepare lead_links data for saving to LEAD_LINKS table
        // We need to delete old links and save new ones
        // Strategy: Get existing links, mark them as deleted, then insert new ones
        if (data.ARCIMEDES_ROW_ID) {
            // For existing properties, we'll need to fetch and delete old links
            // Then insert the new links
            const nonEmptyLinks = leadLinks.filter(link => link && link.trim() !== '');

            if (nonEmptyLinks.length > 0) {
                leadLinksData = nonEmptyLinks.map(link => ({
                    PROPERTY_ID: data.ARCIMEDES_ROW_ID,
                    LINK_URL: link.trim()
                }));
            }
        }

        const updatedProposalData = removeKeysFromObject({ ...this.state.proposalData, PROPERTY_ID: data.ARCIMEDES_ROW_ID, ARCIMEDES_ROW_ID: this.state.proposalData.ARCIMEDES_ROW_ID }, PROPOSAL_COLUMNS);
        const updatedPropertyData = removeKeysFromObject({ ...data, STRENGTHS: undefined, BUYER_POOL: undefined, CHALLENGES: undefined, QUALIFICATIONS: undefined, RECOMMENDATIONS: undefined }, PROPERTY_COLUMNS);

        let featured_data = {
            PROPERTY_ID: this.props.params.id,
            FEATURED_ACTIVATED: this.state.data.FEATURED ? 'y' : 'n',
            DATE_ACTIVATED: this.state.data.FEATURED ? new Date().toLocaleDateString('en-US') : '',
        }

        if (this.state.featuredActivatedLogId) {
            featured_data.ARCIMEDES_ROW_ID = this.state.featuredActivatedLogId;
        }

        // Store for debugging
        window.lastSaveData = {
            property: updatedPropertyData,
            proposal: updatedProposalData,
            seller: Object.keys(seller).length ? seller : null,
            loanQuotes: lqDataArray,
            payments: paymentsDataArray,
            loanNotes: loanNotesDataArray,
            timestamp: new Date().toISOString()
        };

        // The map's create is the only path that also attaches the investor and
        // the NEED_OWNER flag, so a property arriving from a parcel is written
        // there first and everything below then updates that row.
        if (this.parcelHandoff) {
            // Read again rather than trusting what the tab opened with: the
            // owner can be changed on the map while this form sits here, and
            // saving the choice it no longer shows is the whole bug.
            const handoff = readParcelHandoff(this.parcelHandoffToken) || this.parcelHandoff;
            let created = null;

            try {
                created = await mapApi.createProperty(
                    handoff.parcel,
                    updatedPropertyData,
                    handoff.ownerChoice,
                );
            } catch (problem) {
                // The parcel stays on the instance so Save can be pressed
                // again: nothing was written, and losing it would leave the
                // form able to save only a property with no owner. isBusy and
                // viewMode go back with it, or the button stays disabled and
                // "Saving…" and only a reload frees the form.
                this.setState({
                    isBusy: null,
                    viewMode: false,
                    error: problem.message || 'Could not add this parcel to iCLIMB.',
                    success: null,
                });

                return null;
            }

            this.parcelHandoff = null;
            clearParcelHandoff(this.parcelHandoffToken);
            updatedPropertyData.ARCIMEDES_ROW_ID = created.id;
            updatedProposalData.PROPERTY_ID = created.id;
        }

        return Promise.all([
            manageData({
                tableCode: PROPERTIES,
                data: [updatedPropertyData],
            }),

            // The server refuses it too (WritePolicy, proposals >= edit); not
            // sending it keeps a save by someone without Proposals quiet. The
            // placeholder keeps res[1] a response object for the save branches.
            can('proposals', 'edit') ? manageData({
                tableCode: PROPOSAL,
                data: [updatedProposalData],
            }) : Promise.resolve({ success: true, data: [] }),
            this.props.edit && Object.keys(seller).length &&
            manageData({
                tableCode: SELLERS,
                data: [{
                    ARCIMEDES_ROW_ID: this.state.data.SELLER_ID,
                    ...seller,
                }],
            }),
            this.props.edit && lqDataArray.length &&
            manageData({
                tableCode: HSC_LOAN_QUOTES,
                data: lqDataArray,
            }),
            data.ARCIMEDES_ROW_ID &&
            getData({
                tableCode: HSC_LOAN_QUOTES,
                options: {
                    filter: [
                        {
                            text: data.ARCIMEDES_ROW_ID,
                            code: "PROPERTY_ID",
                            type: "exact",
                        },
                    ],
                },
            }),
            this.props.edit && paymentsDataArray.length &&
            manageData({
                tableCode: PROPERTY_PAYMENT_TEAM,
                data: paymentsDataArray,
            }),
            this.props.edit && paymentsDataArray.length &&
            getData({
                tableCode: PROPERTY_PAYMENT_TEAM,
                options: {
                    filter: [
                        {
                            text: data.ARCIMEDES_ROW_ID,
                            code: "PROPERTY_ID",
                            type: "exact",
                        },
                    ],
                },
            }),
            data.ARCIMEDES_ROW_ID &&
            getData({
                tableCode: REFERRING_OUTSIDE_AGENT,
                options: {
                    filter: [
                        {
                            text: data.ARCIMEDES_ROW_ID,
                            code: "PROPERTY_ID",
                            type: "exact",
                        },
                    ],
                },
            }),
            // Get existing lead_links to mark them as deleted before inserting new ones
            data.ARCIMEDES_ROW_ID &&
            getData({
                tableCode: LEAD_LINKS,
                options: {
                    filter: [
                        {
                            text: data.ARCIMEDES_ROW_ID,
                            code: "PROPERTY_ID",
                            type: "exact",
                        },
                        {
                            text: '',
                            code: 'DELETED',
                            type: 'null',
                        }
                    ],
                },
            }),
            // Save loan notes
            loanNotesDataArray.length &&
            manageData({
                tableCode: PROPERTY_LOAN_NOTES,
                data: loanNotesDataArray,
            }),
            // Get updated loan notes
            data.ARCIMEDES_ROW_ID &&
            getData({
                tableCode: PROPERTY_LOAN_NOTES,
                options: {
                    filterType: 'and',
                    filter: [
                        {
                            text: data.ARCIMEDES_ROW_ID,
                            code: "PROPERTY_ID",
                            type: "exact",
                        },
                        {
                            text: '',
                            code: 'DELETED',
                            type: 'null',
                        }
                    ],
                },
            }),
            manageData({
                tableCode: FEATURED_ACTIVATED_LOG,
                data: [featured_data],
            })
        ]).then(async (res) => {
            // Snapshot before any await/setState: later `.then` runs after `original` is updated to the saved row,
            // so `this.state.original` there would match `currentProperty` and break transition detection (e.g. Active → Off Market).
            // Only `state.original` is used for `previousProperty`; the post-edit form (`state.data`) is not a
            // reliable source for pre-save status fields and would manufacture false transitions.
            const propertySnapshotBeforeSave = cloneDeep(this.state.original);
            // Payload sent to Arc (may include fields omitted from the save response).
            const savedPropertyPayload = cloneDeep(data);

            // A refused property write comes back as { success: false, message } with no data.
            const savedProperty = res && res[0] && res[0].success && res[0].data ? res[0].data[0] : null;

            // Handle lead_links: delete old ones and insert new ones
            const existingLeadLinks = res && res[8] && res[8].success ? res[8].data : [];
            const propertyId = savedProperty ? savedProperty.ARCIMEDES_ROW_ID : null;

            const propertyAccount = this.state.account.id ?
                {
                    PROPERTY_ID: this.props.params.id,
                    ACCOUNT_NUMBER: this.state.account.value,
                    ARCIMEDES_ROW_ID: this.state.account.id
                } :
                {
                    PROPERTY_ID: this.props.params.id ? this.props.params.id : propertyId,
                    ACCOUNT_NUMBER: this.state.account.value
                }
            if (propertyAccount.PROPERTY_ID && propertyAccount.ACCOUNT_NUMBER) {
                manageData({
                    tableCode: PROPERTY_ACCOUNT_NUMBERS,
                    data: [propertyAccount],
                })
            }

            // Save contract info (LISTING_AGENT, TRANSACTION_COORDINATOR) to separate table
            const contractPropertyId = this.props.params.id || propertyId;
            const savedContractInfo = {
                LISTING_AGENT: this.state.data.LISTING_AGENT || null,
                TRANSACTION_COORDINATOR: this.state.data.TRANSACTION_COORDINATOR || null,
                _contractInfoId: this.state.data._contractInfoId || null,
            };
            if (contractPropertyId) {
                const contractInfoData = {
                    PROPERTY_ID: contractPropertyId,
                    LISTING_AGENT: savedContractInfo.LISTING_AGENT,
                    TRANSACTION_COORDINATOR: savedContractInfo.TRANSACTION_COORDINATOR,
                };
                if (savedContractInfo._contractInfoId) {
                    contractInfoData.ARCIMEDES_ROW_ID = savedContractInfo._contractInfoId;
                }
                const contractSaveRes = await manageData({
                    tableCode: PROPERTY_CONTRACT_INFO,
                    data: [contractInfoData],
                });
                if (contractSaveRes && contractSaveRes.success && contractSaveRes.data && contractSaveRes.data[0]) {
                    savedContractInfo._contractInfoId = contractSaveRes.data[0].ARCIMEDES_ROW_ID;
                }
            }


            // Delete existing lead_links
            if (existingLeadLinks.length > 0) {
                const linksToDelete = existingLeadLinks.map(link => ({
                    ARCIMEDES_ROW_ID: link.ARCIMEDES_ROW_ID,
                    DELETED: '1'
                }));

                await manageData({
                    tableCode: LEAD_LINKS,
                    data: linksToDelete,
                });
            }

            // Insert new lead_links
            if (leadLinksData.length > 0 && propertyId) {
                // Make sure all links have the correct property ID
                const linksToInsert = leadLinksData.map(link => ({
                    ...link,
                    PROPERTY_ID: propertyId
                }));

                await manageData({
                    tableCode: LEAD_LINKS,
                    data: linksToInsert,
                });
            }

            // On closing property with a buyer in Buy-Side Agent: set buyer as new investor, current investor as previous owner
            const savedData = this.state.data;
            // Only run auto-ownership logic when status JUST changed to Closed (not on every re-save of an already-closed property).
            // Without this guard, re-saving an already-Closed property with a BUYER_ID would recreate the buyer as current owner
            // even after a user manually removed them via the Investors tab.
            const isNewlyClosed = this.state.original && this.state.original.STATUS !== 'Closed' && savedData.STATUS === 'Closed';
            if (propertyId && isNewlyClosed && savedData.CLOSE_OF_ESCROW && savedData.BUYER_ID) {
                try {
                    const ownershipRes = await executeQuery({
                        queryName: GET_PROPERTY_OWNERSHIPS,
                        options: {
                            param: {
                                PROPERTY_ID: String(propertyId),
                                limit: String(9999),
                                offset: String(0)
                            }
                        }
                    });
                    const ownerships = (ownershipRes && ownershipRes.success && ownershipRes.data) ? ownershipRes.data : [];
                    // Mark current ownership(s) as previous owner (IS_CURRENT = 0, END_DATE = close of escrow or current date)
                    const currentOwnerships = ownerships.filter(o => o.IS_CURRENT === 1 || o.IS_CURRENT === "1");
                    let currentInvestorIds = [];
                    for (const ownership of currentOwnerships) {
                        const invRes = await executeQuery({
                            queryName: GET_OWNERSHIP_INVESTORS,
                            options: {
                                param: {
                                    PROPERTY_OWNERSHIP_ID: String(ownership.ARCIMEDES_ROW_ID),
                                    limit: String(9999),
                                    offset: String(0)
                                }
                            }
                        });
                        const investors = (invRes && invRes.success && invRes.data) ? invRes.data : [];
                        currentInvestorIds = currentInvestorIds.concat(investors.map(i => i.INVESTOR_ID));
                    }
                    const buyerIdStr = String(savedData.BUYER_ID);
                    if (currentInvestorIds.map(id => String(id)).indexOf(buyerIdStr) === -1) {
                        const actionDate = savedData.CLOSE_OF_ESCROW;
                        for (const ownership of currentOwnerships) {
                            await manageData({
                                tableCode: PROPERTY_OWNERSHIP,
                                data: [{
                                    ARCIMEDES_ROW_ID: ownership.ARCIMEDES_ROW_ID,
                                    PROPERTY_ID: ownership.PROPERTY_ID,
                                    START_DATE: ownership.START_DATE,
                                    END_DATE: actionDate,
                                    IS_CURRENT: 0
                                }]
                            });
                        }

                        // Create new ownership period with buyer as new investor
                        const newOwnershipRes = await manageData({
                            tableCode: PROPERTY_OWNERSHIP,
                            data: [{
                                PROPERTY_ID: Number(propertyId),
                                START_DATE: actionDate,
                                END_DATE: null,
                                IS_CURRENT: 1
                            }]
                        });

                        if (newOwnershipRes && newOwnershipRes.success && newOwnershipRes.data && newOwnershipRes.data[0]) {
                            const newOwnershipId = newOwnershipRes.data[0].ARCIMEDES_ROW_ID;
                            await manageData({
                                tableCode: PROPERTY_OWNERSHIP_INVESTORS,
                                data: [{
                                    PROPERTY_OWNERSHIP_ID: Number(newOwnershipId),
                                    INVESTOR_ID: Number(savedData.BUYER_ID)
                                }]
                            });
                        }

                        // Sync CRM investor-properties: add new buyer, remove archived investors
                        try {
                            const removeIds = currentInvestorIds
                                .map(id => Number(id))
                                .filter(id => Number.isFinite(id));
                            const addIds = [Number(savedData.BUYER_ID)].filter(id => Number.isFinite(id));
                            if (addIds.length || removeIds.length) {
                                await axios.post('/api/crm/investor-properties', {
                                    propertyId,
                                    addInvestorIds: addIds,
                                    removeInvestorIds: removeIds,
                                    propertyCategory: savedData.CATEGORY || null,
                                    propertyType: savedData.TYPE || null,
                                }, { withCredentials: true });
                            }
                        } catch (syncErr) {
                            console.error('CRM investor properties sync failed on close:', syncErr);
                        }
                    }
                } catch (err) {
                    console.error('Error updating ownership on property close:', err);
                }
            }

            if (propertyId && isNewlyClosed && savedData.CLOSE_OF_ESCROW && !savedData.BUYER_ID && savedData.SOURCE !== 'SUMMIT') {
                try {
                    const ownershipRes = await executeQuery({
                        queryName: GET_PROPERTY_OWNERSHIPS,
                        options: {
                            param: {
                                PROPERTY_ID: String(propertyId),
                                limit: String(9999),
                                offset: String(0)
                            }
                        }
                    });
                    const ownerships = (ownershipRes && ownershipRes.success && ownershipRes.data) ? ownershipRes.data : [];
                    const currentOwnerships = ownerships.filter(o => o.IS_CURRENT === 1 || o.IS_CURRENT === "1");

                    if (currentOwnerships.length > 0) {
                        // Collect current investor IDs for CRM sync
                        let currentInvestorIds = [];
                        for (const ownership of currentOwnerships) {
                            const invRes = await executeQuery({
                                queryName: GET_OWNERSHIP_INVESTORS,
                                options: {
                                    param: {
                                        PROPERTY_OWNERSHIP_ID: String(ownership.ARCIMEDES_ROW_ID),
                                        limit: String(9999),
                                        offset: String(0)
                                    }
                                }
                            });
                            const investors = (invRes && invRes.success && invRes.data) ? invRes.data : [];
                            currentInvestorIds = currentInvestorIds.concat(investors.map(i => i.INVESTOR_ID));
                        }

                        const actionDate = savedData.CLOSE_OF_ESCROW;
                        // Archive each current ownership: set END_DATE to sale date, IS_CURRENT = 0
                        for (const ownership of currentOwnerships) {
                            await manageData({
                                tableCode: PROPERTY_OWNERSHIP,
                                data: [{
                                    ARCIMEDES_ROW_ID: ownership.ARCIMEDES_ROW_ID,
                                    PROPERTY_ID: ownership.PROPERTY_ID,
                                    START_DATE: ownership.START_DATE,
                                    END_DATE: actionDate,
                                    IS_CURRENT: 0
                                }]
                            });
                        }

                        // Sync CRM: remove archived investors from this property
                        try {
                            const removeIds = currentInvestorIds
                                .map(id => Number(id))
                                .filter(id => Number.isFinite(id));
                            if (removeIds.length) {
                                await axios.post('/api/crm/investor-properties', {
                                    propertyId,
                                    addInvestorIds: [],
                                    removeInvestorIds: removeIds,
                                    propertyCategory: savedData.CATEGORY || null,
                                }, { withCredentials: true });
                            }
                        } catch (syncErr) {
                            console.error('CRM investor properties sync failed on close without buyer:', syncErr);
                        }

                        await new Promise(resolve => this.setState({ isNeedOwner: true }, resolve));
                    }
                } catch (err) {
                    console.error('Error archiving ownership on property close without buyer:', err);
                }
            }

            // When property is deleted: remove all investor links and sync to CRM
            if (propertyId && isBeingDeleted && !wasDeleted) {
                try {
                    console.log('Property being deleted, removing all investor links...', propertyId);
                    
                    // Get all ownerships for this property
                    const ownershipRes = await executeQuery({
                        queryName: GET_PROPERTY_OWNERSHIPS,
                        options: {
                            param: {
                                PROPERTY_ID: String(propertyId),
                                limit: String(9999),
                                offset: String(0)
                            }
                        }
                    });
                    
                    const ownerships = (ownershipRes && ownershipRes.success && ownershipRes.data) ? ownershipRes.data : [];
                    let allInvestorIds = [];
                    
                    // Collect all investors from all ownerships (both current and archived)
                    for (const ownership of ownerships) {
                        const invRes = await executeQuery({
                            queryName: GET_OWNERSHIP_INVESTORS,
                            options: {
                                param: {
                                    PROPERTY_OWNERSHIP_ID: String(ownership.ARCIMEDES_ROW_ID),
                                    limit: String(9999),
                                    offset: String(0)
                                }
                            }
                        });
                        const investors = (invRes && invRes.success && invRes.data) ? invRes.data : [];
                        
                        // Mark all investor links as deleted
                        if (investors.length > 0) {
                            const investorLinksToDelete = investors.map(inv => ({
                                ARCIMEDES_ROW_ID: inv.ARCIMEDES_ROW_ID,
                                DELETED: 1
                            }));
                            
                            await manageData({
                                tableCode: PROPERTY_OWNERSHIP_INVESTORS,
                                data: investorLinksToDelete
                            });
                            
                            allInvestorIds = allInvestorIds.concat(investors.map(i => i.INVESTOR_ID));
                        }
                    }
                    
                    // Remove duplicates from investor IDs
                    allInvestorIds = [...new Set(allInvestorIds)];
                    
                    // Mark all ownership records as deleted
                    if (ownerships.length > 0) {
                        const ownershipsToDelete = ownerships.map(ownership => ({
                            ARCIMEDES_ROW_ID: ownership.ARCIMEDES_ROW_ID,
                            DELETED: 1
                        }));
                        
                        await manageData({
                            tableCode: PROPERTY_OWNERSHIP,
                            data: ownershipsToDelete
                        });
                        
                        console.log('Marked ownership records as deleted:', ownerships.length);
                    }
                    
                    // Sync to CRM: remove this property from all investors' property lists
                    if (allInvestorIds.length > 0) {
                        try {
                            const removeIds = allInvestorIds
                                .map(id => Number(id))
                                .filter(id => Number.isFinite(id));
                            
                            if (removeIds.length) {
                                console.log('Syncing property deletion to CRM for investors:', removeIds);
                                await axios.post('/api/crm/investor-properties', {
                                    propertyId,
                                    addInvestorIds: [],
                                    removeInvestorIds: removeIds,
                                    removalKind: 'detach', // Use 'detach' to completely remove from both Current and Previous Properties
                                    propertyCategory: savedData.CATEGORY || null,
                                }, { withCredentials: true });
                                console.log('Successfully synced property deletion to CRM');
                            }
                        } catch (syncErr) {
                            console.error('CRM investor properties sync failed on property deletion:', syncErr);
                            // Don't throw error - property is already deleted in iCLIMB, CRM sync is a bonus
                        }
                    }
                    
                    console.log('Property deletion complete:', { 
                        propertyId, 
                        investorCount: allInvestorIds.length,
                        ownershipCount: ownerships.length 
                    });
                } catch (err) {
                    console.error('Error removing investor links on property deletion:', err);
                    // Don't throw error - property is being deleted anyway
                }
            }

            // Sync CAD_SITE, ACRES, ASSESSED_VALUE to underwriting tables
            await this.syncPropertyFieldsToUnderwriting(propertyId, changedFields);

            // Fetch updated lead_links to include in state
            let updatedLeadLinks = [];
            if (propertyId) {
                const leadLinksResponse = await getData({
                    tableCode: LEAD_LINKS,
                    options: {
                        filter: [
                            {
                                text: propertyId,
                                code: "PROPERTY_ID",
                                type: "exact",
                            },
                            {
                                text: '',
                                code: 'DELETED',
                                type: 'null',
                            }
                        ],
                    },
                });

                if (leadLinksResponse && leadLinksResponse.success && leadLinksResponse.data) {
                    updatedLeadLinks = leadLinksResponse.data.map(link => link.LINK_URL);
                }
            }

            let paymentsData = this.state.propertyPaymentsData;
            if (savedProperty && savedProperty.TRANSACTION_TYPE === 'Investment Sales')
                paymentsData = res && res[6] && res[6].success ? convertPaymentsDataToForm(res[6].data, savedProperty.ARCIMEDES_ROW_ID, 'Investment Sales') : this.state.propertyPaymentsData;
            if (savedProperty && savedProperty.TRANSACTION_TYPE === 'Referral')
                paymentsData = res && res[6] && res[6].success ? convertPaymentsDataToForm(res[6].data, savedProperty.ARCIMEDES_ROW_ID, 'Referral') : this.state.propertyPaymentsData;
            if (savedProperty && savedProperty.TRANSACTION_TYPE === 'Extra Payment')
                paymentsData = res && res[6] && res[6].success ? convertPaymentsDataToForm(res[6].data, savedProperty.ARCIMEDES_ROW_ID, 'Extra Payment') : this.state.propertyPaymentsData;

            // Update loan notes data from response
            let updatedLoanNotesData = this.state.loanNotesData;
            if (res && res[10] && res[10].success && Array.isArray(res[10].data)) {
                updatedLoanNotesData = res[10].data;
            }

            // Update loan quotes data from response.
            // res[3] is the HSC_LOAN_QUOTES save result — NOT res[2], which is SELLERS.
            // Branches below used to read res[2].data here, feeding the seller row into
            // convertLoanQuotesDataToForm and wiping out the real loan quotes.
            let updatedLoanQuotesData = this.state.loanQuotesData;
            let updatedOriginalLoanQuotesData = this.state.originalLoanQuotesData;
            if (res && res[3] && res[3].success) {
                updatedLoanQuotesData = convertLoanQuotesDataToForm(res[3].data, savedProperty || this.state.original);
                updatedOriginalLoanQuotesData = convertLoanQuotesDataToForm(res[3].data, savedProperty || this.state.original);

                // The pending deletes went out with this save.
                if (this.state.deletedLoanQuotesData && this.state.deletedLoanQuotesData.length) {
                    this.setState({ deletedLoanQuotesData: [] });
                }
            }

            // A property/seller save can succeed while the loan quotes save fails outright
            // (res[3].success === false). Without this, the branches below only look at
            // res[0]/res[1]/res[2] and would still report "Saved" while quotes silently
            // didn't persist.
            const loanQuotesSaveFailed = !!(res && res[3] && res[3].success === false);
            const loanQuotesSaveErrorMessage = loanQuotesSaveFailed
                ? `Failed to save: Loan Quotes. ${res[3].message || ''}`.trim()
                : null;

            if (res && res[0] && res[0].success && res[1] && res[1].success && res[2] && res[2].success) {
                // changes in both property & seller
                const formData = convertDataToForm(res[0].data[0]);
                formData.NEW_DEVELOPMENT = this.state.isNewDevelopment;
                formData.HOT_LIST = this.state.isHotList;
                formData.NEED_OWNER = this.state.isNeedOwner;
                formData.lead_links = updatedLeadLinks; // Add lead_links to form data
                Object.assign(formData, savedContractInfo);

                this.setState((prevState) => ({
                    isBusy: null,
                    success: (showSaveAlert && !loanQuotesSaveFailed) ? "Saved" : null,
                    error: loanQuotesSaveFailed ? loanQuotesSaveErrorMessage : null,
                    propertyPaymentsData: paymentsData,
                    previousData: prevState.original,
                    data: formData,
                    original: { ...res[0].data[0] },
                    loanQuotesData: updatedLoanQuotesData,
                    originalLoanQuotesData: updatedOriginalLoanQuotesData,
                    loanNotesData: updatedLoanNotesData,
                    originalLoanNotesData: cloneDeep(updatedLoanNotesData),
                    seller: { ...res[2].data[0] },
                    originalSeller: { ...res[2].data[0] },
                    newPropertyId: null,
                }), () => {
                    if (!this.props.edit) {
                        // redirect from add
                        const newPropertyId = res[0].data[0].ARCIMEDES_ROW_ID;
                        const redirectToNewProperty = () => this.finishAddAndRedirect(newPropertyId);
                        if (lqData && lqData.length && lqData.length > 0) {
                            lqData = lqData.map((lq) => (
                                {
                                    ...lq,
                                    PROPERTY_ID: newPropertyId
                                }
                            ))
                            manageData({
                                tableCode: HSC_LOAN_QUOTES,
                                data: lqData,
                            }).then(redirectToNewProperty)
                        } else {
                            redirectToNewProperty();
                        }
                    }
                    window.scrollTo(0, 0);
                });
            } else if (res && res[0] && res[0].success && res[2] && res[2].success) {
                // changes in both property & loan quotes
                const formData3 = convertDataToForm(res[0].data[0]);
                formData3.NEW_DEVELOPMENT = this.state.isNewDevelopment;
                formData3.HOT_LIST = this.state.isHotList;
                formData3.NEED_OWNER = this.state.isNeedOwner;
                formData3.lead_links = updatedLeadLinks; // Add lead_links to form data
                Object.assign(formData3, savedContractInfo);

                this.setState((prevState) => ({
                    isBusy: null,
                    success: (showSaveAlert && !loanQuotesSaveFailed) ? "Saved" : null,
                    error: loanQuotesSaveFailed ? loanQuotesSaveErrorMessage : null,
                    propertyPaymentsData: paymentsData,
                    previousData: prevState.original,
                    data: formData3,
                    original: { ...res[0].data[0] },
                    loanQuotesData: updatedLoanQuotesData,
                    originalLoanQuotesData: updatedOriginalLoanQuotesData,
                    loanNotesData: updatedLoanNotesData,
                    originalLoanNotesData: cloneDeep(updatedLoanNotesData),
                    newPropertyId: null,
                }), () => {
                    if (!this.props.edit) {
                        // redirect from add
                        const newPropertyId = res[0].data[0].ARCIMEDES_ROW_ID;
                        const redirectToNewProperty = () => this.finishAddAndRedirect(newPropertyId);
                        if (lqData && lqData.length && lqData.length > 0) {
                            lqData = lqData.map((lq) => (
                                {
                                    ...lq,
                                    PROPERTY_ID: newPropertyId
                                }
                            ))
                            manageData({
                                tableCode: HSC_LOAN_QUOTES,
                                data: lqData,
                            }).then(redirectToNewProperty)
                        } else {
                            redirectToNewProperty();
                        }
                    }
                    window.scrollTo(0, 0);
                });
            } else if (res && res[1] && res[1].success && res[2] && res[2].success) {
                // changes in seller & loan quotes
                const data = { ...this.state.data };
                this.setState(() => ({
                    isBusy: null,
                    success: (showSaveAlert && !loanQuotesSaveFailed) ? "Saved" : null,
                    error: loanQuotesSaveFailed ? loanQuotesSaveErrorMessage : null,
                    loanQuotesData: updatedLoanQuotesData,
                    originalLoanQuotesData: updatedOriginalLoanQuotesData,
                    loanNotesData: updatedLoanNotesData,
                    originalLoanNotesData: cloneDeep(updatedLoanNotesData),
                    seller: { ...res[2].data[0] },
                    originalSeller: { ...res[2].data[0] },
                    newPropertyId: null,
                }), () => {
                    if (!this.props.edit) {
                        // redirect from add
                        const newPropertyId = res[0].data[0].ARCIMEDES_ROW_ID;
                        const redirectToNewProperty = () => this.finishAddAndRedirect(newPropertyId);
                        if (lqData && lqData.length && lqData.length > 0) {
                            lqData = lqData.map((lq) => (
                                {
                                    ...lq,
                                    PROPERTY_ID: newPropertyId
                                }
                            ))
                            manageData({
                                tableCode: HSC_LOAN_QUOTES,
                                data: lqData,
                            }).then(redirectToNewProperty)
                        } else {
                            redirectToNewProperty();
                        }
                    }
                    window.scrollTo(0, 0);
                });
            } else if (res && res[0] && res[0].success) {
                // changes in property
                const formData4 = convertDataToForm(res[0].data[0]);
                formData4.NEW_DEVELOPMENT = this.state.isNewDevelopment;
                formData4.HOT_LIST = this.state.isHotList;
                formData4.NEED_OWNER = this.state.isNeedOwner;
                formData4.lead_links = updatedLeadLinks; // Add lead_links to form data
                Object.assign(formData4, savedContractInfo);

                this.setState((prevState) => ({
                    isBusy: null,
                    success: (showSaveAlert && !loanQuotesSaveFailed) ? "Saved" : null,
                    error: loanQuotesSaveFailed ? loanQuotesSaveErrorMessage : null,
                    propertyPaymentsData: paymentsData,
                    previousData: prevState.original,
                    data: formData4,
                    original: { ...res[0].data[0] },
                    loanQuotesData: updatedLoanQuotesData,
                    originalLoanQuotesData: updatedOriginalLoanQuotesData,
                    loanNotesData: updatedLoanNotesData,
                    originalLoanNotesData: cloneDeep(updatedLoanNotesData),
                    newPropertyId: null,
                }), async () => {
                    const date = new Date(res[0].data[0].CLOSE_OF_ESCROW);
                    const closeOfEscrowYear = date.getFullYear();
                    const propertyId = res[0].data[0].ARCIMEDES_ROW_ID;

                    const referringPropertyArcId = res[7] && res[7].data[0] ? res[7].data[0].ARCIMEDES_ROW_ID : '';
                    let referringProperty = [];
                    if (referringPropertyArcId === '') {
                        referringProperty = [{
                            ...this.state.referringAgentData,
                            PROPERTY_ID: propertyId,
                        }]
                    } else {
                        referringProperty = [{
                            ...this.state.referringAgentData,
                            ARCIMEDES_ROW_ID: referringPropertyArcId,
                            PROPERTY_ID: propertyId,
                        }]
                    }
                    manageData({
                        tableCode: REFERRING_OUTSIDE_AGENT,
                        data: referringProperty
                    }).then(res => {
                        if (res && res.success) {
                            const referringAgentData = res && res && res.success && res.data[0] ?
                                {
                                    PROPERTY_ID: propertyId,
                                    REFERRING_LISTING_AGENT: res.data[0].REFERRING_LISTING_AGENT,
                                    REFERRING_LISTING_AGENT_PERCENT: res.data[0].REFERRING_LISTING_AGENT_PERCENT,
                                    REFERRING_LISTING_AGENT_FIRM: res.data[0].REFERRING_LISTING_AGENT_FIRM,
                                    REFERRING_BUYER_AGENT: res.data[0].REFERRING_BUYER_AGENT,
                                    REFERRING_BUYER_AGENT_PERCENT: res.data[0].REFERRING_BUYER_AGENT_PERCENT,
                                    REFERRING_BUYER_AGENT_FIRM: res.data[0].REFERRING_BUYER_AGENT_FIRM,
                                    ARCIMEDES_ROW_ID: res.data[0].ARCIMEDES_ROW_ID
                                } : null;

                            //this.getProperty(res.data[0].PROPERTY_ID);
                            this.setState({
                                isBusy: null,
                                success: showSaveAlert ? "Saved" : null,
                                referringAgentData: referringAgentData
                            })
                        } else {
                            console.error('Save error - referring agent data:', res);
                            this.setState({
                                isBusy: null,
                                error: res && res.message ? res.message : 'Unspecified error',
                            });
                        }
                    });

                    if (hotlistData && hotlistData.data && hotlistData.data[0]) {
                        let hotListProperties = hotlistData.data[0].HOT_LIST_PROPERTIES || '';
                        let propertiesArray = hotListProperties.split(',').filter(Boolean);

                        const arcId = res[0].data[0].ARCIMEDES_ROW_ID.toString();

                        if (this.state.isHotList) {
                            if (!propertiesArray.includes(arcId)) {
                                propertiesArray.push(arcId);
                            }
                        } else {
                            propertiesArray = propertiesArray.filter(id => id !== arcId);
                        }

                        hotlistData.data[0].HOT_LIST_PROPERTIES = propertiesArray.join(',');
                    } else {
                        hotlistData.data = [{
                            ID: this.props.userData.id,
                            NAME: this.props.userData.person.firstName,
                            EMAIL_ID: this.props.userData.email,
                            HOT_LIST_PROPERTIES: res[0].data[0].ARCIMEDES_ROW_ID.toString(),
                        }];
                    }

                    manageData({
                        tableCode: HOT_LIST,
                        data: hotlistData.data
                    }).then(res => {
                        if (res && res.success) {
                            let hotListProperties = res.data[0].HOT_LIST_PROPERTIES;
                            let propertiesArray = hotListProperties.split(',');
                            if (propertiesArray.includes(propertyId.toString())) {
                                data['HOT_LIST'] = true;
                                this.setData({ isHotList: true });
                            } else {
                                data['HOT_LIST'] = false;
                                this.setData({ isHotList: false });
                            }
                            this.setState({
                                isBusy: null,
                                success: showSaveAlert ? "Saved" : null,
                            })
                        } else {
                            console.error('Save error - hotlist data:', res);
                            this.setState({
                                isBusy: null,
                                error: res && res.message ? res.message : 'Unspecified error',
                            });
                        }
                    });

                    const arcId = res[0].data[0].ARCIMEDES_ROW_ID.toString();

                    // NEW_DEVELOPMENT table: simple PROPERTY_ID tracking
                    const devTrackerEntry = await getData({
                        tableCode: NEW_DEVELOPMENT,
                        columns: ['ARCIMEDES_ROW_ID', 'PROPERTY_ID', 'DELETED'],
                        options: {
                            filterType: 'and',
                            filter: [{ code: 'PROPERTY_ID', text: arcId, type: 'equal' }],
                        },
                    });
                    const devEntry = devTrackerEntry && devTrackerEntry.success && devTrackerEntry.data && devTrackerEntry.data[0];
                    if (this.state.isNewDevelopment) {
                        if (devEntry && devEntry.DELETED) {
                            await manageData({
                                tableCode: NEW_DEVELOPMENT,
                                data: [{ ARCIMEDES_ROW_ID: devEntry.ARCIMEDES_ROW_ID, DELETED: null }],
                            });
                        } else if (!devEntry) {
                            await manageData({
                                tableCode: NEW_DEVELOPMENT,
                                data: [{ PROPERTY_ID: arcId }],
                            });
                        }
                        data['NEW_DEVELOPMENT'] = true;
                    } else {
                        if (devEntry && !devEntry.DELETED) {
                            await manageData({
                                tableCode: NEW_DEVELOPMENT,
                                data: [{ ARCIMEDES_ROW_ID: devEntry.ARCIMEDES_ROW_ID, DELETED: '1' }],
                            });
                        }
                        data['NEW_DEVELOPMENT'] = false;
                    }

                    // NEW_DEVELOPMENT_HISTORY table: per-user tracking (same pattern as HOT_LIST)
                    if (newDevelopmentData && newDevelopmentData.data && newDevelopmentData.data[0]) {
                        let newDevProperties = newDevelopmentData.data[0].NEW_DEVELOPMENT_PROPERTIES || '';
                        let newDevArray = newDevProperties.split(',').filter(Boolean);

                        if (this.state.isNewDevelopment) {
                            if (!newDevArray.includes(arcId)) {
                                newDevArray.push(arcId);
                            }
                        } else {
                            newDevArray = newDevArray.filter(id => id !== arcId);
                        }

                        newDevelopmentData.data[0].NEW_DEVELOPMENT_PROPERTIES = newDevArray.join(',');
                    } else {
                        newDevelopmentData.data = [{
                            ID: this.props.userData.id,
                            NAME: this.props.userData.person.firstName,
                            EMAIL_ID: this.props.userData.email,
                            NEW_DEVELOPMENT_PROPERTIES: this.state.isNewDevelopment ? arcId : '',
                        }];
                    }

                    manageData({
                        tableCode: NEW_DEVELOPMENT_HISTORY,
                        data: newDevelopmentData.data
                    }).then(res => {
                        if (!res || !res.success) {
                            console.error('Save error - new development history data:', res);
                        }
                    });

                    // NEED_OWNER table: simple PROPERTY_ID tracking
                    const needOwnerEntry = await getData({
                        tableCode: NEED_OWNER,
                        columns: ['ARCIMEDES_ROW_ID', 'PROPERTY_ID', 'DELETED'],
                        options: {
                            filterType: 'and',
                            filter: [{ code: 'PROPERTY_ID', text: arcId, type: 'equal' }],
                        },
                    });
                    const ownerEntry = needOwnerEntry && needOwnerEntry.success && needOwnerEntry.data && needOwnerEntry.data[0];
                    if (this.state.isNeedOwner) {
                        if (ownerEntry && ownerEntry.DELETED) {
                            await manageData({
                                tableCode: NEED_OWNER,
                                data: [{ ARCIMEDES_ROW_ID: ownerEntry.ARCIMEDES_ROW_ID, DELETED: null }],
                            });
                        } else if (!ownerEntry) {
                            await manageData({
                                tableCode: NEED_OWNER,
                                data: [{ PROPERTY_ID: arcId }],
                            });
                        }
                    } else {
                        if (ownerEntry && !ownerEntry.DELETED) {
                            await manageData({
                                tableCode: NEED_OWNER,
                                data: [{ ARCIMEDES_ROW_ID: ownerEntry.ARCIMEDES_ROW_ID, DELETED: '1' }],
                            });
                        }
                    }

                    // Researched flag: plain REST endpoint, not an Arc table.
                    await propertyResearchedApi.update(arcId, this.state.isResearched).catch(err => {
                        console.error('Error saving researched flag:', err);
                    });

                    if (res[0].data[0].TRANSACTION_TYPE === 'Extra Payment' && res[0].data[0].REFERRAL_FEE && closeOfEscrowYear != 1970 && res[0].data[0].LISTING_AGENT_1) {
                        await this.getNetFeeFromFeeAmount(res[0].data[0]);
                        if (paymentsDataArray.length == 0) {
                            manageData({
                                tableCode: PROPERTY_PAYMENT_TEAM,
                                data: [{
                                    PROPERTY_ID: res[0].data[0].ARCIMEDES_ROW_ID,
                                    STRIVE_TEAM_MEMBER_ID: res[0].data[0].LISTING_AGENT_1,
                                    STRIVE_TEAM_MEMBER_PERCENT: res[0].data[0].LISTING_AGENT_1_PERCENT,
                                    STRIVE_TEAM_MEMBER_NET_FEE: this.state.netFee,
                                    STRIVE_TEAM_MEMBER_NET_PERCENT: this.state.tranche,
                                    STRIVE_TEAM_MEMBER_GROSS_FEE: res[0].data[0].REFERRAL_FEE
                                }]
                            }).then(res => {
                                if (res && res.success) {
                                    this.setState({
                                        isBusy: null,
                                        success: showSaveAlert ? "Saved" : null,
                                    })
                                } else {
                                    this.setState({
                                        isBusy: null,
                                        error: res && res.message ? res.message : 'Unspecified error',
                                    });
                                }
                            });
                        }

                    }


                    if (!this.props.edit) {
                        // redirect from add
                        const newPropertyId = res[0].data[0].ARCIMEDES_ROW_ID;
                        const redirectToNewProperty = () => this.finishAddAndRedirect(newPropertyId);
                        if (lqData && lqData.length && lqData.length > 0) {
                            lqData = lqData.map((lq) => (
                                {
                                    ...lq,
                                    PROPERTY_ID: newPropertyId
                                }
                            ))
                            manageData({
                                tableCode: HSC_LOAN_QUOTES,
                                data: lqData,
                            }).then(redirectToNewProperty)
                        } else {
                            redirectToNewProperty();
                        }
                    } else {
                        // new seller selected, get seller data
                        res[0].data[0].SELLER_ID && this.state.sellerSelected && this.fetchSeller();
                    }
                    window.scrollTo(0, 0);
                });
            } else if (res && res[2] && res[2].success) {
                // changes in seller
                this.setState(() => ({
                    isBusy: null,
                    success: (showSaveAlert && !loanQuotesSaveFailed) ? "Saved" : null,
                    error: loanQuotesSaveFailed ? loanQuotesSaveErrorMessage : null,
                    loanQuotesData: updatedLoanQuotesData,
                    originalLoanQuotesData: updatedOriginalLoanQuotesData,
                    seller: { ...res[2].data[0] },
                    originalSeller: { ...res[2].data[0] },
                    newPropertyId: null,
                }), () => {
                    if (!this.props.edit) {
                        // redirect from add
                        const newPropertyId = res[0].data[0].ARCIMEDES_ROW_ID;
                        const redirectToNewProperty = () => this.finishAddAndRedirect(newPropertyId);
                        if (lqData && lqData.length && lqData.length > 0) {
                            lqData = lqData.map((lq) => (
                                {
                                    ...lq,
                                    PROPERTY_ID: newPropertyId
                                }
                            ))
                            manageData({
                                tableCode: HSC_LOAN_QUOTES,
                                data: lqData,
                            }).then(redirectToNewProperty)
                        } else {
                            redirectToNewProperty();
                        }
                    }
                    window.scrollTo(0, 0);
                });
            } else {
                console.error('Save error - main property save:', res);

                // Find which API call failed
                const failedCalls = [];
                if (res[0] && !res[0].success) failedCalls.push('Property');
                if (res[1] && !res[1].success) failedCalls.push('Proposal');
                if (res[2] && !res[2].success) failedCalls.push('Seller');
                if (res[3] && !res[3].success) failedCalls.push('Loan Quotes');

                const errorMessage = failedCalls.length > 0
                    ? `Failed to save: ${failedCalls.join(', ')}. ${(res[0] && res[0].message) || (res[1] && res[1].message) || (res[2] && res[2].message) || (res[3] && res[3].message) || ''}`
                    : (res[2] && res[2].message ? res[2].message : "Unspecified error");

                this.setState({
                    isBusy: null,
                    error: errorMessage,
                    // The quotes in this batch were written even though the property was not; taking their
                    // ids back makes a retry update them instead of inserting them again.
                    ...(res[3] && res[3].success ? { loanQuotesData: updatedLoanQuotesData, originalLoanQuotesData: updatedOriginalLoanQuotesData } : {}),
                });
            }

            if (savedProperty && res[1] && res[1].data && res[1].data.length && res[1].data[0].hasOwnProperty('BUYER_POOL')) {
                const data = { ...savedProperty }
                let updatedData = this.state.proposalData;
                if (!this.state.proposalData.UPDATED) {
                    updatedData = this.handleProposalDataByType(data, this.state.proposalData);
                }
                updatedData = { ...updatedData, ARCIMEDES_ROW_ID: res[1].data[0].ARCIMEDES_ROW_ID };
                this.setState(() => ({
                    proposalData: updatedData,
                    proposalDataOriginal: updatedData
                }));
            }


            const link = res[0].success ?
                res[0].data[0].SOURCE === 'HSC' ?
                    `${url}list?NAME=${res[0].data[0].NAME}&SOURCE=PEAK&ADDRESS=${res[0].data[0].ADDRESS}&PEAK_STATUS=${res[0].data[0].HSC_STATUS}&TRANSACTION_TYPE=${res[0].data[0].TRANSACTION_TYPE}`
                    :
                    `${url}list?NAME=${res[0].data[0].NAME}&SOURCE=${res[0].data[0].SOURCE}&ADDRESS=${res[0].data[0].ADDRESS}&STATUS=${res[0].data[0].STATUS}&TRANSACTION_TYPE=${res[0].data[0].TRANSACTION_TYPE}`
                : '';

            return {
                success: res[0].success,
                property: {
                    ...savedProperty,
                    LINK: link
                },
                propertySnapshotBeforeSave,
                savedPropertyPayload,
            };
        }).then((res) => {
            if (!this.props.params.id) {
                this.fetchEscrowData(res.property);
                this.fetchHscTrackingData(res.property);
            }

            if (res.success) {
                const currentPropertyForEmail = {
                    ...(res.property || {}),
                    ...(res.savedPropertyPayload || {}),
                };
                if (currentPropertyForEmail.CITY) {
                    currentPropertyForEmail.CITY = zipLookupCity(currentPropertyForEmail.CITY);
                }
                const emailSnap = pickPropertyForEmailNotifications(
                    res.propertySnapshotBeforeSave || {},
                    currentPropertyForEmail
                );
                syncPropertyEmailNotifications(res.property.ARCIMEDES_ROW_ID, {
                    previousProperty: emailSnap.previousProperty,
                    currentProperty: emailSnap.currentProperty,
                    agentList: this.state.agentList,
                    buyerAgent4FirmValue: buyer_agent4_firmvalue,
                });
                const previousProperty = res.propertySnapshotBeforeSave || this.state.previousData || this.state.original;
                this.checkHistoryAndSave(res.property, previousProperty);

                const savedCategory = currentPropertyForEmail.CATEGORY
                    || res.property.CATEGORY
                    || this.state.data.CATEGORY;
                const savedType = currentPropertyForEmail.TYPE
                    || res.property.TYPE
                    || this.state.data.TYPE;
                if (res.property.ARCIMEDES_ROW_ID && savedCategory) {
                    this.syncInvestorProductTypes(res.property.ARCIMEDES_ROW_ID, savedCategory, savedType);
                }
            }

            const stateUpdates = {
                hasModifiedStatus: false,
                isHscApproved: false,
                isClosedReferral: false,
                hasModifiedListPrice: false,
                hasReducedListPrice: false,
            };

            if (res.success && res.property) {
                const updatedCurrentHistory = new CurrentHistoryModel(res.property);
                stateUpdates.currentHistoryData = updatedCurrentHistory;
                if (Array.isArray(this.state.historyData)) {
                    stateUpdates.historyData = this.state.historyData.map(row =>
                        row && !row.ARCIMEDES_ROW_ID ? updatedCurrentHistory : row
                    );
                }
            }

            this.setState(stateUpdates);
        }).catch(error => {
            console.error('Promise chain error:', error);
            this.setState({
                isBusy: null,
                error: error.message || 'An unexpected error occurred while saving',
            });
        });
    }

    savePropertyHistory(property) {
        const data = new PropertyHistoryModel(property);
        const query = { ...this.props.location.query };
        const options = filter(query, 'history');
        options.param.PROPERTY_ID = property.ARCIMEDES_ROW_ID;
        const filters = query.order ? (Array.isArray(query.order) ? query.order : [query.order]) : [];

        manageData({ tableCode: PROPERTY_HISTORY, data: [data] }).then(res => {
            if (!res || !res.success) {
                this.setState({
                    error: res && res.message ? res.message : "Unspecified error",
                });
            } else {
                this.resolveHistoryRowId(res, property.ARCIMEDES_ROW_ID).then((historyRowId) => {
                    if (historyRowId) {
                        this.saveHistoryFinancialSnapshot(historyRowId, property);
                    }
                });
                Promise.all([
                    executeQuery({
                        queryName: GET_PROPERTY_HISTORY,
                        options: options
                    }),
                    executeQuery({
                        queryName: PROPERTY_DATA,
                        params: {
                            PROPERTY_ID: property.ARCIMEDES_ROW_ID,
                        },
                    })
                ]).then(res => {
                    const currentData = new CurrentHistoryModel(res[1].data[0]);
                    const storedRows = res && res[0] && res[0].success && Array.isArray(res[0].data) ? res[0].data : [];
                    const propertySource = res[1].data[0].SOURCE;
                    const propertyHscFinancing = res[1].data[0].HSC_FINANCING;
                    storedRows.forEach(row => {
                        row.SOURCE = row.SOURCE || propertySource;
                        if (row.HSC_FINANCING === undefined || row.HSC_FINANCING === null) row.HSC_FINANCING = propertyHscFinancing;
                    });
                    const historyData = [currentData, ...storedRows];
                    this.setState({
                        currentHistoryData: currentData,
                        historyData,
                    }, () => this.decoratePaymentSnapshotPresence(historyData));
                });
            }
        });
    }

    async resolveHistoryRowId(createRes, propertyId) {
        const createdRowId = createRes && createRes.data && createRes.data[0] && createRes.data[0].ARCIMEDES_ROW_ID;
        if (createdRowId) return createdRowId;
        if (!propertyId) return null;

        const res = await getData({
            tableCode: PROPERTY_HISTORY,
            options: {
                filterType: 'and',
                filter: [
                    { text: String(propertyId), code: "PROPERTY_ID", type: "exact" },
                    { text: '', code: "DELETED", type: "null" },
                ],
                order: [{ code: "ARCIMEDES_ROW_ID", type: "desc" }],
            },
        });
        if (res && res.success && Array.isArray(res.data) && res.data.length) {
            return res.data[0].ARCIMEDES_ROW_ID;
        }
        return null;
    }

    async saveHistoryFinancialSnapshot(historyRowId, property) {
        if (!historyRowId || !property || !property.ARCIMEDES_ROW_ID) return;

        const propertyId = String(property.ARCIMEDES_ROW_ID);
        const now = new Date().toISOString();
        const userName = this.state.currentUser || property.LAST_MODIFIED_BY || "System";
        const snapshot = {
            version: 2,
            capturedAt: now,
            property: cloneDeep(property),
            type: property.TYPE,
            category: property.CATEGORY,
            proposal: cloneDeep(this.state.proposalData) || null,
            loanQuotes: cloneDeep(this.state.loanQuotesData) || null,
            loanNotes: cloneDeep(this.state.loanNotesData) || null,
            propertyPayments: cloneDeep(this.state.propertyPaymentsData) || null,
            seller: cloneDeep(this.state.seller) || null,
        };

        try {
            const [ownershipsRes] = await Promise.all([
                executeQuery({ queryName: GET_PROPERTY_OWNERSHIPS, params: { PROPERTY_ID: propertyId } }),
            ]);
            const ownerships = ownershipsRes && ownershipsRes.success && Array.isArray(ownershipsRes.data) ? ownershipsRes.data : [];
            const investorsByOwnership = {};
            await Promise.all(ownerships.map(async (ownership) => {
                if (!ownership || !ownership.ARCIMEDES_ROW_ID) return;
                const invRes = await executeQuery({ queryName: GET_OWNERSHIP_INVESTORS, params: { PROPERTY_OWNERSHIP_ID: ownership.ARCIMEDES_ROW_ID } });
                investorsByOwnership[ownership.ARCIMEDES_ROW_ID] = invRes && invRes.success && Array.isArray(invRes.data) ? invRes.data : [];
            }));
            snapshot.ownerships = ownerships;
            snapshot.ownershipInvestors = investorsByOwnership;
        } catch (err) {
            console.error("Failed to capture ownership snapshot:", err);
        }

        try {
            if (['STNL', 'Other'].includes(property.TYPE)) {
                const [singleTenantRes, rentScheduleRes] = await Promise.all([
                    getData({
                        tableCode: UNDERWRITING_SINGLE_TENANT,
                        options: {
                            filter: [{ text: propertyId, code: "PROPERTY_ID", type: "exact" }],
                        },
                    }),
                    getData({
                        tableCode: UNDERWRITING_RENT_SCHEDULE,
                        options: {
                            filterType: 'and',
                            filter: [
                                { text: propertyId, code: "PROPERTY_ID", type: "exact" },
                                { text: '', code: "DELETED", type: "null" },
                            ],
                            order: [{ code: "ARCIMEDES_ROW_ID", type: "asc" }],
                        },
                    }),
                ]);

                snapshot.singleTenant = {
                    underwriting: singleTenantRes && singleTenantRes.success && singleTenantRes.data && singleTenantRes.data[0] ? singleTenantRes.data[0] : {},
                    rentSchedule: rentScheduleRes && rentScheduleRes.success && Array.isArray(rentScheduleRes.data) ? rentScheduleRes.data : [],
                };
            } else {
                const tenantOptions = filter({ PROPERTY_ID: propertyId, order: 'TENANT_ROW_ID.asc' }, 'underwritingMT');
                const [multiTenantRes, parcelsRes, camsRes, tenantTypesRes, tenantsRes] = await Promise.all([
                    getData({
                        tableCode: UNDERWRITING_MULTI_TENANT,
                        options: {
                            filter: [{ text: propertyId, code: "PROPERTY_ID", type: "exact" }],
                        },
                    }),
                    getData({
                        tableCode: UNDERWRITING_PARCELS,
                        options: {
                            filter: [{ text: propertyId, code: "PROPERTY_ID", type: "exact" }],
                            order: [{ code: "PARCEL", type: "asc" }],
                        },
                    }),
                    getData({
                        tableCode: UNDERWRITING_EXPENSES_CAMS,
                        options: {
                            filterType: 'and',
                            filter: [
                                { text: propertyId, code: "PROPERTY_ID", type: "exact" },
                                { text: '', code: "DELETED", type: "null" },
                            ],
                            order: [{ code: "CAM_INDEX", type: "asc" }],
                        },
                    }),
                    getData({
                        tableCode: UNDERWRITING_TENANT_TYPES,
                        options: {
                            filter: [{ text: propertyId, code: "PROPERTY_ID", type: "exact" }],
                            order: [{ code: "REIMB_TYPES_INDEX", type: "asc" }],
                        },
                    }),
                    executeBackendQuery({ queryName: UNDERWRITING_TENANT_LIST, options: tenantOptions }),
                ]);

                snapshot.multiTenant = {
                    underwriting: multiTenantRes && multiTenantRes.success && multiTenantRes.data && multiTenantRes.data[0] ? multiTenantRes.data[0] : {},
                    parcels: parcelsRes && parcelsRes.success && Array.isArray(parcelsRes.data) ? parcelsRes.data : [],
                    cams: camsRes && camsRes.success && Array.isArray(camsRes.data) ? camsRes.data : [],
                    tenantTypes: tenantTypesRes && tenantTypesRes.success && Array.isArray(tenantTypesRes.data) ? tenantTypesRes.data : [],
                    tenants: tenantsRes && tenantsRes.success && Array.isArray(tenantsRes.data) ? tenantsRes.data : [],
                };
            }

            const snapshotString = JSON.stringify(snapshot);
            const marker = `${HISTORY_FINANCIALS_NOTE_PREFIX}${historyRowId}`;
            const chunks = [];
            for (let i = 0; i < snapshotString.length; i += HISTORY_FINANCIALS_NOTE_CHUNK_SIZE) {
                chunks.push(snapshotString.slice(i, i + HISTORY_FINANCIALS_NOTE_CHUNK_SIZE));
            }
            const rows = chunks.map((chunk, index) => ({
                PROPERTY_ID: Number(propertyId),
                NOTE_TEXT: `${marker}::part:${index + 1}/${chunks.length}::${chunk}`,
                DATE_CREATED: now,
                CREATED_BY: userName,
                LAST_MODIFIED_DATE: now,
                LAST_MODIFIED_BY: userName,
                DELETED: 0,
            }));
            await manageData({
                tableCode: PROPERTY_NOTES,
                data: rows,
            });
        } catch (err) {
            console.error("Failed to save financial history snapshot:", err);
        }
    }

    async getHistoryFinancialSnapshot(historyRowId) {
        if (!historyRowId || !this.props.params.id) return null;

        const markerBase = `${HISTORY_FINANCIALS_NOTE_PREFIX}${historyRowId}`;
        const res = await getData({
            tableCode: PROPERTY_NOTES,
            columns: ["NOTE_TEXT"],
            options: {
                filter: [
                    { text: this.props.params.id, code: "PROPERTY_ID", type: "exact" },
                ],
                order: [{ code: "ARCIMEDES_ROW_ID", type: "desc" }],
            },
        });

        if (!(res && res.success && Array.isArray(res.data))) return null;
        const notes = res.data
            .map((row) => row && row.NOTE_TEXT)
            .filter(Boolean);

        // Backward compatibility for old single-note snapshots.
        const legacyMarker = `${markerBase}::`;
        const legacyNote = notes.find((text) => text.startsWith(legacyMarker) && !text.includes("::part:"));
        if (legacyNote) {
            try {
                return JSON.parse(legacyNote.slice(legacyMarker.length));
            } catch (e) {
                return null;
            }
        }

        const partPrefix = `${markerBase}::part:`;
        const partRegex = new RegExp(`^${markerBase.replace(/[.*+?^${}()|[\\]\\\\]/g, '\\$&')}::part:(\\d+)\\/(\\d+)::`);
        const partNotes = notes
            .filter((text) => text.startsWith(partPrefix))
            .map((text) => {
                const match = text.match(partRegex);
                if (!match) return null;
                const index = parseInt(match[1], 10);
                const total = parseInt(match[2], 10);
                const payload = text.slice(match[0].length);
                return Number.isFinite(index) && Number.isFinite(total) ? { index, total, payload } : null;
            })
            .filter(Boolean);

        if (!partNotes.length) return null;
        const total = partNotes[0].total;
        if (partNotes.length < total) return null;
        partNotes.sort((a, b) => a.index - b.index);
        const payload = partNotes.slice(0, total).map((p) => p.payload).join("");
        try {
            return JSON.parse(payload);
        } catch (e) {
            return null;
        }
    }

    async openHistoryFinancialsSpreadsheet(historyRow) {
        if (!historyRow) return;
        this.setState({
            historyFinancialsLoading: true,
            error: null,
        });

        if (historyRow.ARCIMEDES_ROW_ID) {
            const cache = this.state.historySnapshotCache;
            let snapshot = cache ? cache[historyRow.ARCIMEDES_ROW_ID] : null;
            if (!snapshot) {
                snapshot = await this.getHistoryFinancialSnapshot(historyRow.ARCIMEDES_ROW_ID);
            }
            if (snapshot && snapshot.property) {
                this.setState({
                    historyFinancialsLoading: false,
                    historyFinancialsInView: true,
                    historyFinancialsData: snapshot.property,
                    historyFinancialsSnapshot: snapshot,
                });
                return;
            }
        }

        // No stored snapshot (live row or pre-snapshot row): show current financials fetched live from DB.
        this.setState({
            historyFinancialsLoading: false,
            historyFinancialsInView: true,
            historyFinancialsData: this.state.data,
            historyFinancialsSnapshot: null,
        });
    }

    closeHistoryFinancialsSpreadsheet() {
        this.setState({
            historyFinancialsInView: false,
            historyFinancialsData: null,
            historyFinancialsSnapshot: null,
            historyFinancialsLoading: false,
        });
    }

    async buildHistorySnapshotCache() {
        if (!this.props.params.id) return {};
        const res = await getData({
            tableCode: PROPERTY_NOTES,
            columns: ["NOTE_TEXT"],
            options: {
                filter: [{ text: this.props.params.id, code: "PROPERTY_ID", type: "exact" }],
                order: [{ code: "ARCIMEDES_ROW_ID", type: "desc" }],
            },
        });
        const cache = {};
        if (!(res && res.success && Array.isArray(res.data))) {
            this.setState({ historySnapshotCache: cache });
            return cache;
        }
        const notes = res.data.map(r => r && r.NOTE_TEXT).filter(Boolean);
        const partRegex = new RegExp(`^${HISTORY_FINANCIALS_NOTE_PREFIX}(\\d+)::part:(\\d+)/(\\d+)::`);
        const byId = {};
        notes.forEach(text => {
            const legacy = text.match(new RegExp(`^${HISTORY_FINANCIALS_NOTE_PREFIX}(\\d+)::(?!part:)`));
            if (legacy) {
                const id = legacy[1];
                if (!byId[id]) byId[id] = { legacy: text.slice(legacy[0].length) };
                return;
            }
            const m = text.match(partRegex);
            if (!m) return;
            const id = m[1];
            const index = parseInt(m[2], 10);
            const total = parseInt(m[3], 10);
            if (!byId[id]) byId[id] = { parts: [], total };
            if (byId[id].parts) {
                byId[id].parts.push({ index, total, payload: text.slice(m[0].length) });
                byId[id].total = total;
            }
        });
        Object.keys(byId).forEach(id => {
            const entry = byId[id];
            try {
                if (entry.legacy) {
                    cache[id] = JSON.parse(entry.legacy);
                    return;
                }
                if (!entry.parts || entry.parts.length < entry.total) return;
                entry.parts.sort((a, b) => a.index - b.index);
                const payload = entry.parts.slice(0, entry.total).map(p => p.payload).join("");
                cache[id] = JSON.parse(payload);
            } catch (e) { /* skip bad row */ }
        });
        this.setState({ historySnapshotCache: cache });
        return cache;
    }

    async decoratePaymentSnapshotPresence(rows) {
        const hasPaymentRows = (arr) => Array.isArray(arr) && arr.some(p => p && (p.STRIVE_TEAM_MEMBER_ID || p.STRIVE_TEAM_MEMBER_GROSS_FEE || p.STRIVE_TEAM_MEMBER_NET_FEE));
        const cache = await this.buildHistorySnapshotCache();
        const map = {};
        (rows || []).forEach(row => {
            if (row && row.ARCIMEDES_ROW_ID) {
                const snap = cache[row.ARCIMEDES_ROW_ID];
                map[row.ARCIMEDES_ROW_ID] = hasPaymentRows(snap && snap.propertyPayments);
            }
        });
        const liveHas = hasPaymentRows(this.state.propertyPaymentsData);
        this.setState(prev => {
            if (!Array.isArray(prev.historyData)) return null;
            return {
                historyData: prev.historyData.map(row => {
                    if (!row) return row;
                    const has = row.ARCIMEDES_ROW_ID ? (row.ARCIMEDES_ROW_ID in map ? map[row.ARCIMEDES_ROW_ID] : row.HAS_PAYMENT_SNAPSHOT) : liveHas;
                    return Object.assign(Object.create(Object.getPrototypeOf(row)), row, { HAS_PAYMENT_SNAPSHOT: has });
                }),
            };
        });
    }

    openHistoryTabView(historyRow, tabName) {
        if (!historyRow || !tabName) return;
        if (tabName === 'FINANCIALS') {
            return this.openHistoryFinancialsSpreadsheet(historyRow);
        }
        const cache = this.state.historySnapshotCache;
        const cached = historyRow.ARCIMEDES_ROW_ID && cache ? cache[historyRow.ARCIMEDES_ROW_ID] : null;
        if (cached || !historyRow.ARCIMEDES_ROW_ID) {
            this.setState({
                historyTabInView: tabName,
                historyTabSnapshot: cached,
                historyTabData: cached && cached.property ? cached.property : this.state.data,
                historyTabLoading: false,
                error: null,
            });
            return;
        }
        this.setState({
            historyTabInView: tabName,
            historyTabSnapshot: null,
            historyTabData: this.state.data,
            historyTabLoading: true,
            error: null,
        });
        const requestedTab = tabName;
        const requestedRowId = historyRow.ARCIMEDES_ROW_ID;
        this.getHistoryFinancialSnapshot(requestedRowId).then((snapshot) => {
            if (this.state.historyTabInView !== requestedTab) return;
            const tabData = snapshot && snapshot.property ? snapshot.property : this.state.data;
            this.setState({
                historyTabSnapshot: snapshot,
                historyTabData: tabData,
                historyTabLoading: false,
            });
        }).catch(() => {
            if (this.state.historyTabInView !== requestedTab) return;
            this.setState({ historyTabLoading: false });
        });
    }

    closeHistoryTabView() {
        this.setState({
            historyTabInView: null,
            historyTabSnapshot: null,
            historyTabData: null,
            historyTabLoading: false,
        });
    }

    renderHistoryTabModal() {
        const tabName = this.state.historyTabInView;
        if (!tabName || tabName === 'FINANCIALS') return null;
        const snapshot = this.state.historyTabSnapshot || {};
        const snapData = this.state.historyTabData || snapshot.property || this.state.data || {};
        const noop = () => {};
        const deleted = snapData && snapData.DELETED === "1";
        const ownDealsOnly = editsOwnSummitDealsOnly(getCurrentAccess());
        const isReferral = snapData && snapData.TRANSACTION_TYPE === 'Referral';
        const isFinancing = snapData && snapData.SOURCE === 'HSC';
        const isStriveFinancing = snapData && snapData.HSC_FINANCING;
        const isExtraPayment = snapData && snapData.TRANSACTION_TYPE === 'Extra Payment';
        const snapshotApprovedQuote = (snapshot.loanQuotes || []).find(
            (q) => q && String(q.APPROVED).toLowerCase() === 'yes'
        );
        const lenderContactOverride = snapshotApprovedQuote ? snapshotApprovedQuote.BANK_CONTACT : '';

        let content = null;
        switch (tabName) {
            case 'PROPERTY':
                content = (
                    <PropertyInfo
                        data={snapData}
                        account={this.state.account.value}
                        handleChangeDropdown={noop}
                        handleChangeInput={noop}
                        handleChangeFile={noop}
                        getTenantsForTags={this.getTenantsForTags}
                        viewMode={true}
                        deleted={deleted}
                        isReferral={isReferral}
                        isFinancing={isFinancing}
                        isStriveFinancing={isStriveFinancing}
                        redirectToHscTracking={noop}
                        ownDealsOnly={ownDealsOnly}
                        isExtraPayment={isExtraPayment}
                        onShowNotes={noop}
                        notes={[]}
                        zipLoading={false}
                    />
                );
                break;
            case 'INVESTORS':
                content = (
                    <OwnershipInfo
                        data={snapData}
                        propertyId={snapData && snapData.ARCIMEDES_ROW_ID}
                        handleOwnersChange={noop}
                        viewMode={true}
                        deleted={deleted}
                        addNewItem={noop}
                        isNeedOwner={false}
                        onNeedOwnerChange={noop}
                        isResearched={false}
                        onResearchedChange={noop}
                        snapshotOwnerships={snapshot.ownerships}
                        snapshotInvestors={snapshot.ownershipInvestors}
                    />
                );
                break;
            case 'LISTING AGENT':
                content = (
                    <ListingAgent
                        data={snapData}
                        handleChangeDropdown={noop}
                        handleChangeInput={noop}
                        addNewItem={noop}
                        newAgent={null}
                        newFirm={null}
                        viewMode={true}
                        deleted={deleted}
                        userData={this.props.userData}
                    />
                );
                break;
            case 'PROPOSAL':
                if (!can('proposals', 'view')) break;
                content = (
                    <Proposal
                        data={snapshot.proposal || this.state.proposalData}
                        handleChangeInput={noop}
                        viewMode={true}
                        deleted={deleted}
                    />
                );
                break;
            case 'REP AGREEMENT':
                content = (
                    <RepresentationAgreement
                        data={snapData}
                        handleChangeInput={noop}
                        handleChangeFile={noop}
                        viewMode={true}
                        deleted={deleted}
                    />
                );
                break;
            case 'IN NEG/UNDER CONTRACT':
                content = (
                    <InNegotiationUnderContract
                        data={snapData}
                        agentList={this.state.agentList}
                        handleChangeInput={noop}
                        handleChangeDropdown={noop}
                        handleChangeFile={noop}
                        redirectToEscrowTracking={noop}
                        viewMode={true}
                        deleted={deleted}
                        isStriveFinancing={isStriveFinancing}
                    />
                );
                break;
            case 'BUYSIDE AGENT':
                content = (
                    <BuysideAgent
                        data={snapData}
                        handleChangeDropdown={noop}
                        handleChangeInput={noop}
                        addNewItem={noop}
                        newAgent={null}
                        newBuyer={null}
                        newFirm={null}
                        viewMode={true}
                        deleted={deleted}
                        isSnapshot
                    />
                );
                break;
            case 'SALE INFO':
                content = (
                    <SaleInformation
                        ownDealsOnly={ownDealsOnly}
                        data={snapData}
                        handleChangeInput={noop}
                        handleInputBlur={noop}
                        handleChangeDropdown={noop}
                        handleChangeFile={noop}
                        viewMode={true}
                        deleted={deleted}
                        isFinancing={isFinancing}
                        isReferral={isReferral}
                        isExtraPayment={isExtraPayment}
                        isStriveFinancing={isStriveFinancing}
                        calculateGrossAmount={noop}
                    />
                );
                break;
            case 'WEBSITE':
                content = (
                    <Website
                        data={snapData}
                        handleChangeInput={noop}
                        handleChangeFile={noop}
                        viewMode={true}
                        deleted={deleted}
                    />
                );
                break;
            case 'PAYMENT':
                content = (
                    <PropertyPayments
                        paymentsData={snapshot.propertyPayments || this.state.propertyPaymentsData}
                        propertyData={snapData}
                        handleAddMember={noop}
                        handleChangeDropdown={noop}
                        handleChangeInput={noop}
                        viewMode={true}
                        deleted={deleted}
                        isReferral={isReferral}
                    />
                );
                break;
            case 'LOAN INFO':
                content = (
                    <Loan
                        isTeamMember={false}
                        data={snapData}
                        handleChangeDropdown={noop}
                        handleChangeInput={noop}
                        handleInputBlur={noop}
                        handleChangeFile={noop}
                        displayedAgentsNr={this.state.displayedHSCAgents}
                        addHscMember={noop}
                        addNewItem={noop}
                        openHscPayments={noop}
                        hscTeamMembers={[]}
                        newLender={null}
                        newAgent={null}
                        viewMode={true}
                        deleted={deleted}
                        loanNotes={snapshot.loanNotes || this.state.loanNotesData}
                        currentUser={this.state.currentUser}
                        onAddLoanNote={noop}
                        onDeleteLoanNote={noop}
                        onEditLoanNote={noop}
                        lenderContactOverride={lenderContactOverride}
                        loanQuotes={snapshot.loanQuotes || this.state.loanQuotesData}
                    />
                );
                break;
            case 'LOAN QUOTES':
                content = (
                    <LoanQuotes
                        printTitle={snapData && `${snapData.NAME} - ${snapData.CITY}, ${snapData.STATE}`}
                        data={snapshot.loanQuotes || this.state.loanQuotesData}
                        NOIPercent={snapData && snapData.NOI_PERCENT}
                        LoanType={snapData && snapData.LOAN_TYPE}
                        negotiationPrice={snapData && snapData.NEGOTIATION_PRICE}
                        handleChangeInput={noop}
                        handleChangeDropdown={noop}
                        handlePrintPagesDropDown={noop}
                        viewMode={true}
                        deleted={deleted}
                        hscTeamMemberIds={[]}
                        addNewColumn={noop}
                        updateColumns={noop}
                    />
                );
                break;
            default:
                content = <div>No data available for this tab.</div>;
        }

        const capturedAt = snapshot && snapshot.capturedAt ? new Date(snapshot.capturedAt) : null;
        const capturedLabel = capturedAt && !isNaN(capturedAt.getTime())
            ? capturedAt.toLocaleString(undefined, { year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' })
            : null;
        const subtitle = [
            snapData && snapData.NAME,
            capturedLabel ? `Captured ${capturedLabel}` : (snapshot ? null : 'Live data — no snapshot available for this row'),
        ].filter(Boolean).join(' · ');

        return (
            <Modal show={true} onClose={this.closeHistoryTabView} className="history-tab-modal">
                <div className="history-tab-modal-content">
                    <div className="history-tab-modal-header">
                        <div>
                            <span className="modal-title">{tabName} (Snapshot)</span>
                            {subtitle ? <span className="history-tab-modal-subtitle">{subtitle}</span> : null}
                        </div>
                        <div className='history-tab-modal-close' onClick={this.closeHistoryTabView}>×</div>
                    </div>
                    <div className="history-tab-modal-body">
                        {this.state.historyTabLoading ? (
                            <div className="history-tab-modal-loading">Loading snapshot…</div>
                        ) : content}
                    </div>
                </div>
            </Modal>
        );
    }

    closeHistoryPartialModal() {
        this.setState({
            historyPartialModalOpen: false,
            historyPartialData: null,
        });
    }

    updatePropertyTracking(data, table) {
        manageData({ tableCode: table, data: [data] }).then(res => {
            if (!res || !res.success)
                this.setState({
                    error: res && res.message ? res.message : "Unspecified error",
                });
        });
    }

    async getPropertyEscrowTracking(propertyId) {
        const res = await request(arc.path.api, {
            service: "arcimedes",
            action: "open.dataquery.execute",
            params: [ESCROW_TRACKING, { param: { PROPERTY_ID: propertyId } }],
        });

        if (res && res.success && Array.isArray(res.data) && res.data.length)
            return res.data[0];
        return null;
    }

    async getPropertyHscTracking(propertyId) {
        if (propertyId && typeof (propertyId) !== 'string') {
            propertyId = propertyId.toString();
        }
        const options = {
            filter: [{
                'text': propertyId,
                'code': 'PROPERTY_ID',
                'type': 'exact',
            }],
        };
        const res = await getData({ tableCode: HSC_TRACKING, options });

        if (res && res.success && Array.isArray(res.data) && res.data.length)
            return res.data[0];
        return null;
    }

    static verifyPercentDecimalsLimit({ value, isAgentPercent }) {
        if (isAgentPercent) {
            const number = value.split(".");
            const decimals = number[1] ? number[1].length : null;
            if (decimals && decimals > 15) {
                return true;
            }
        }
        return false;
    }
    checkHistoryAndSave(currentProperty, previousProperty) {
        const currentStatus = currentProperty && currentProperty.STATUS;
        const previousStatus = previousProperty && previousProperty.STATUS;

        if (currentStatus && previousStatus && currentStatus !== previousStatus) {
            this.savePropertyHistory(previousProperty);
        }
    }
    clearBuysideAgentFieldsAndUnderContratPrice() {
        this.clearBuysideAgentFields();
        this.state.data.NEGOTIATION_PRICE ? this.state.data.NEGOTIATION_PRICE = "" : this.state.data.HSC_PRICE = "";
        this.state.data.POTENTIAL_FEE = "";
        this.state.data.NEGOTIATION_PRICE_PER_SQFT = "";
        this.state.data.NEGOTIATION_CAP_RATE = "";
        this.state.data.IN_NEG_FILE_1 = "";
        this.state.data.IN_NEG_FILE_2 = "";
        this.state.data.IN_NEG_FILE_3 = "";
        this.state.data.IN_NEG_FILE_4 = "";
        this.state.data.IN_NEG_FILE_5 = "";
    }
    clearBuysideAgentFields() {
        this.state.data.BUYER_ID = "";
        this.state.data.BUYER_AGENT_1 = "";
        this.state.data.BUYER_AGENT_1_PERCENT = "";
        this.state.data.BUYER_AGENT_2 = "";
        this.state.data.BUYER_AGENT_2_PERCENT = "";
        this.state.data.BUYER_AGENT_3 = "";
        this.state.data.BUYER_AGENT_3_PERCENT = "";
        this.state.data.BUYER_AGENT_4 = "";
        this.state.data.BUYER_AGENT_4_FIRM = "";
        this.state.data.BUYER_AGENT_4_PERCENT = "";
        this.state.data.REFERRING_BUYER_AGENT = "";
        this.state.data.REFERRING_BUYER_AGENT_FIRM = "";
    }
    clearSaleInfoFields() {
        this.state.data.SOLD_PRICE = "";
        this.state.data.CLOSE_OF_ESCROW = "";
        this.state.data.CLOSE_CAP_RATE = "";
        this.state.data.CLOSE_NOI = "";
        this.state.data.CLOSE_PRICE_PER_SQFT = "";
        this.state.data.DOWN_PAYMENT = "";
        this.state.data.LOAN_AMOUNT = "";
        this.state.data.LIST_FEE = "";
        this.state.data.BUYSIDE_FEE = "";
        this.state.data.POTENTIAL_FEE = "";
        this.state.data.TOTAL_CLOSING_FEE_AUTO = "";
        this.state.data.SELLER_FEE_PERCENTAGE = "";
        this.state.data.REFERRAL_FEE = "";
        this.state.data.NET_FEE = "";
        this.state.data.SELLER_STATEMENT_FILE = "";
        this.state.data.BUYER_STATEMENT_FILE = "";
    }
    checkCoordinatesAndSave(data, original) {
        if (!data.ADDRESS || !data.CITY || !data.STATE) {
            data.LATITUDE = null;
            data.LONGITUDE = null;
            this.setState({ locationNotice: null });
            this.saveData(data);
        } else if (data.ADDRESS !== original.ADDRESS || data.CITY !== original.CITY || data.STATE !== original.STATE || data.ZIP !== original.ZIP || !hasValidCoords(original)) {
            this.geocode(data, (geo, failure) => {
                this.setState({ locationNotice: this.locationNotice(data, original, geo, failure) });
                if (geo) {
                    data.LATITUDE = geo.lat;
                    data.LONGITUDE = geo.lng;
                    data.ZIP = geo.zip;
                    if (geo.city) data.CITY = geo.city;
                } else {
                    // Nothing stored is dropped: the point stays until the address is confirmed.
                    data.LATITUDE = original.LATITUDE || null;
                    data.LONGITUDE = original.LONGITUDE || null;
                }
                this.saveData(data);
            });
        } else {
            delete data.APPRAISED_VALUE;
            this.setState({ locationNotice: null });
            this.saveData(data);
        }
    }

    openHscPayments() {
        this.setState({ showHscModal: true });
    }

    async isPropertyExists(e) {
        e.preventDefault();
        // Synchronous lock prevents re-entry during the async address-check HTTP call,
        // eliminating the race condition that caused duplicate property creation on rapid double-click.
        if (this._isSubmitting) return;
        this._isSubmitting = true;
        try {
            const data = this.state.data;
            if (!this.props.edit) {
                const res = await request(arc.path.api, {
                    service: "arcimedes",
                    action: "open.dataquery.execute",
                    params: [PROPERTIES_ADDRESS, { param: { ADDRESS: data.ADDRESS, CITY: data.CITY, ZIP: data.ZIP, STATE: data.STATE } }]
                });
                if (res.data.length > 0) {
                    this.setState({ openReminderDialog: true });
                } else {
                    this.handleSubmit(e);
                }
            } else {
                this.handleSubmit(e);
            }
        } finally {
            this._isSubmitting = false;
        }
    }

    handleSubmit(e) {
        e.preventDefault();

        if (this.state.viewMode) {
            this.bankEditBase = null;
            this.setState({ viewMode: false, accessNotice: null });
        }

        if (this.state.data.NAME === undefined || this.state.data.NAME === "") {
            this.setState({ errorTabs: [0], success: null });
            return;
        } else {
            this.setState({ errorTabs: [] });
        }

        if (this.state.isBusy || this.state.viewMode === true) return;

        // "Can alter but not save": a Senior Agent may type a new List Price on
        // an Active / In Negotiation / Under Contract listing, but Save puts it
        // back and saves everything else.
        if (this._revertingHeldBack) return;
        if (this.heldBackFields().length) {
            this.revertHeldBackFields().then(() => {
                this._keepAccessNotice = true;
                // The original event is long gone (React pools them).
                this.handleSubmit({ preventDefault() {} });
                this._keepAccessNotice = false;
            });
            return;
        }
        if (!this._keepAccessNotice && this.state.accessNotice) this.setState({ accessNotice: null });

        // The Rep Agreement amendment prompt fires when a listing financial —
        // List Price, NOI, or Cap Rate — actually changes. Compare numerically,
        // not as formatted strings: the form holds "5,220,000" / "6" while the DB
        // holds "5220000.00" / "6.0000", so a raw string compare reports a change
        // on every save even when nothing was edited.
        const financialChanged = (key, parse) => {
            const current = this.state.data[key];
            const originalValue = this.state.original[key];
            return (
                parse(String(current == null ? "" : current)) !==
                parse(String(originalValue == null ? "" : originalValue))
            );
        };
        const financialsChanged =
            financialChanged("LIST_PRICE", priceToNumber) ||
            financialChanged("NET_OPERATING_INCOME", priceToNumber) ||
            financialChanged("PROFORMA_NOI", priceToNumber) ||
            financialChanged("CAPITALIZATION_RATE", percentToNumber) ||
            financialChanged("PROFORMA_CAP_RATE", percentToNumber);
        if (["Active", "In Negotiation", "Under Contract"].includes(this.state.data.STATUS) && this.state.data.SOURCE === "SUMMIT" && financialsChanged) {
            this.setState({ isDialogueOpen: true });
            return;
        }

        if (this.state.data.STATUS === 'Active' && (this.state.original.STATUS === 'Under Contract' || this.state.original.STATUS === 'In Negotiation')) {
            this.clearBuysideAgentFieldsAndUnderContratPrice();
        }
        if (this.state.original.STATUS === 'Closed' && !['Closed', 'Removed', 'Off Market', 'Property Info'].includes(this.state.data.STATUS)) {
            this.clearSaleInfoFields();
            this.clearBuysideAgentFields();
        }
        const data = this.state.data;
        const original = this.state.original;
        this.setState({ viewMode: true, isBusy: true }, () =>
            this.checkCoordinatesAndSave(data, original)
        );
    }

    /** The soft-locked fields this edit changed (access-levels.js). */
    heldBackFields() {
        const samePrice = (a, b) => priceToNumber(String(a == null ? "" : a)) === priceToNumber(String(b == null ? "" : b));
        return changedSoftLockedFields(this.getEditLocks(), this.state.data, this.state.original, samePrice);
    }

    /**
     * Puts the soft-locked fields back as they were loaded and says so.
     * Through setData, so the fields worked out from them (price per sq ft,
     * fees) follow. Resolves once the state has settled.
     */
    async revertHeldBackFields() {
        const heldBack = this.heldBackFields();
        if (!heldBack.length) return false;
        this._revertingHeldBack = true;
        try {
            for (const key of heldBack) {
                await this.setData(key, this.state.original[key]);
                await new Promise((resolve) => this.setState({}, resolve));
            }
            await new Promise((resolve) => this.setState({ accessNotice: this.getEditLocks().softReason }, resolve));
        } finally {
            this._revertingHeldBack = false;
        }
        return true;
    }

    /**
     * Data arriving from somewhere other than the form (the underwriting
     * spreadsheet) gets the same limits: locked and held-back fields keep the
     * values the record was loaded with.
     */
    withLockedFieldsKept(newData) {
        const locks = this.getEditLocks();
        const original = this.state.original || {};
        const kept = { ...newData };
        let priceHeld = false;
        Object.keys(kept).forEach((key) => {
            if ((isFieldLocked(locks, key) || locks.soft[key]) && kept[key] !== original[key] && key !== 'ARCIMEDES_ROW_ID') {
                kept[key] = original[key];
                if (key === 'LIST_PRICE') priceHeld = true;
            }
        });
        if (priceHeld) PRICE_DERIVED_FIELDS.forEach((key) => { kept[key] = original[key]; });
        return kept;
    }

    static getAgentProcuredPercent({ agentId, data }) {
        let percent = 0;
        if (data.LISTING_AGENT_1 === agentId) {
            percent += percentToNumber(data.LISTING_AGENT_1_PERCENT);
        }
        else if (data.LISTING_AGENT_2 === agentId)
            percent += percentToNumber(data.LISTING_AGENT_2_PERCENT);
        else if (data.LISTING_AGENT_3 === agentId)
            percent += percentToNumber(data.LISTING_AGENT_3_PERCENT);
        if (data.BUYER_AGENT_1 === agentId)
            percent += percentToNumber(data.BUYER_AGENT_1_PERCENT);
        else if (data.BUYER_AGENT_2 === agentId)
            percent += percentToNumber(data.BUYER_AGENT_2_PERCENT);
        else if (data.BUYER_AGENT_3 === agentId)
            percent += percentToNumber(data.BUYER_AGENT_3_PERCENT);
        return percent;
    }

    static computeFees({ fee, percentProcured, percentPaid, grossCumulativeProcured, grossFeeProcured = null, grossFeePaid = null }) {
        if (!fee && !grossFeePaid)
            return {
                grossPaid: null,
                net: null,
                netPercentage: null
            };
        const grossProcured = grossFeeProcured !== null ? grossFeeProcured : priceToNumber(fee) * percentProcured / 100;
        const grossPaid = grossFeePaid !== null ? grossFeePaid : priceToNumber(fee) * percentToNumber(percentPaid) / 100;
        const previousPaymentPercentProcured = getPaymentPercentage(grossCumulativeProcured - grossProcured) / 100;
        const paymentPercentProcured = getPaymentPercentage(grossCumulativeProcured) / 100;
        let net;
        if (previousPaymentPercentProcured !== paymentPercentProcured) {
            const threshold = getPaymentThreshold(grossCumulativeProcured);
            const amountOverThreshold = grossCumulativeProcured - threshold;
            const previousProcured = grossCumulativeProcured - grossProcured;
            const previousGrossCumulativeTranche = threshold - previousProcured;
            if (previousGrossCumulativeTranche > grossPaid) {
                net = (grossPaid - (grossCumulativeProcured - threshold)) * previousPaymentPercentProcured + (grossCumulativeProcured - threshold) * paymentPercentProcured;
            } else {
                net = (threshold - (grossCumulativeProcured - grossProcured)) * previousPaymentPercentProcured + (grossPaid - (threshold - (grossCumulativeProcured - grossProcured))) * paymentPercentProcured;
            }

        } else {
            net = grossPaid * paymentPercentProcured;
        }
        const netPercentage = grossPaid ? net / grossPaid * 100 : null;

        return {
            grossPaid: grossPaid ? grossPaid.toFixed(2) : null,
            net: net ? (Math.floor(net * 100) / 100).toFixed(2) : null,
            netPercentage: netPercentage ? netPercentage.toFixed(2) : null,
        };
    }

    async setPaymentsData({ key, value, index }) {
        if (this.isTabLocked('PAYMENT')) return;
        let paymentsData = cloneDeep(this.state.propertyPaymentsData);
        let deletedRows = cloneDeep(this.state.deletedPaymentsData);
        let propData = { ...this.state.data };
        const isReferral = propData.TRANSACTION_TYPE === 'Referral';
        const agentsGrossCumulativeProcured = cloneDeep(this.state.agentsGrossCumulativeProcured);
        const strivePercentage = getAgentContribution(propData, paymentsData[index]['STRIVE_TEAM_MEMBER_ID']);
        paymentsData[index][key] = value;
        if (key === 'STRIVE_TEAM_MEMBER_PERCENT' && paymentsData[index].STRIVE_TEAM_MEMBER_ID) {
            const percentProcured = CRUDProperty.getAgentProcuredPercent({ agentId: paymentsData[index].STRIVE_TEAM_MEMBER_ID, data: propData });
            const grossCumulativeProcured = agentsGrossCumulativeProcured[`GROSS_CUMULATIVE_${index + 1}`] || 0;
            // const grossCumulativeProcured = await this.getAgentGrossCumulativeProcured(paymentsData[index].STRIVE_TEAM_MEMBER_ID, propData.CLOSE_OF_ESCROW);
            const { grossPaid, net, netPercentage } = CRUDProperty.computeFees({
                fee: isReferral ? propData.REFERRAL_FEE : propData.POTENTIAL_FEE,
                percentProcured: strivePercentage,
                percentPaid: value,
                grossCumulativeProcured,
            });
            paymentsData[index].STRIVE_TEAM_MEMBER_GROSS_FEE = grossPaid;
            paymentsData[index].STRIVE_TEAM_MEMBER_NET_FEE = net;
            paymentsData[index].STRIVE_TEAM_MEMBER_NET_PERCENT = netPercentage;
        }

        if (key === 'STRIVE_TEAM_MEMBER_ID' && value && propData.CLOSE_OF_ESCROW) {
            // get Summit RE Team Member gross cumulative procured
            let grossCumulativeProcured = await this.getAgentGrossCumulativeProcured(value, propData.CLOSE_OF_ESCROW);
            agentsGrossCumulativeProcured[`GROSS_CUMULATIVE_${index + 1}`] = grossCumulativeProcured;

            if (paymentsData[index].STRIVE_TEAM_MEMBER_PERCENT) {
                const percentProcured = CRUDProperty.getAgentProcuredPercent({ agentId: value, data: propData });
                const { grossPaid, net, netPercentage } = CRUDProperty.computeFees({
                    fee: isReferral ? propData.REFERRAL_FEE : propData.POTENTIAL_FEE,
                    percentProcured,
                    percentPaid: paymentsData[index].STRIVE_TEAM_MEMBER_PERCENT,
                    grossCumulativeProcured,
                });
                paymentsData[index].STRIVE_TEAM_MEMBER_GROSS_FEE = grossPaid;
                paymentsData[index].STRIVE_TEAM_MEMBER_NET_FEE = net;
                paymentsData[index].STRIVE_TEAM_MEMBER_NET_PERCENT = netPercentage;
            }
        }

        if (key === 'STRIVE_TEAM_MEMBER_ID' && !value) {
            paymentsData[index].STRIVE_TEAM_MEMBER_GROSS_FEE = null;
            paymentsData[index].STRIVE_TEAM_MEMBER_NET_FEE = null;
            paymentsData[index].STRIVE_TEAM_MEMBER_NET_PERCENT = null;
            paymentsData[index].STRIVE_TEAM_MEMBER_PERCENT = null;
        }

        paymentsData[index].PAYMENT_MODIFIED = true;

        if (key === 'DELETED') {
            const deletedRow = { ...paymentsData[index] };
            delete deletedRow.PAYMENT_MODIFIED;
            deletedRows.push(deletedRow);
            paymentsData.splice(index, 1);
        }

        this.setState({
            propertyPaymentsData: paymentsData,
            deletedPaymentsData: deletedRows,
            agentsGrossCumulativeProcured,
        });
    }

    setLoanQuotesData(key, value) {
        if (this.isTabLocked('LOAN QUOTES')) return;
        let lqData = this.state.loanQuotesData;

        const nameKey = key.split('-');
        let lqKey = nameKey[0];
        let lqRow = nameKey[1];

        lqData[lqRow][lqKey] = value;

        if (lqKey === 'APPROVED') {
            if (String(value).toLowerCase() === 'yes') {
                // Only one quote can be approved at a time — clear it on the others.
                lqData.forEach((q, i) => {
                    if (q && i !== Number(lqRow) && String(q.APPROVED).toLowerCase() === 'yes') {
                        q.APPROVED = '';
                        q.LOAN_QUOTES_MODIFIED = true;
                    }
                });
                this.applyApprovedLoanQuoteToLoanInfo(lqData[lqRow]);
            } else {
                this.clearApprovedLoanInfo();
            }
        }

        // Keep Loan Info's Lender in step with the approved quote: editing that
        // quote's Lender (BANK) — directly or via its Lender Contact, which writes
        // the vendor's company into BANK — re-resolves it into the Loan Info Lender,
        // so the same lender always shows on both tabs.
        if (lqKey === 'BANK' && String(lqData[lqRow].APPROVED).toLowerCase() === 'yes') {
            this.setLenderFromApprovedQuote(lqData[lqRow]);
        }

        // Likewise its contact: a new one on the approved quote shows on Loan
        // Info in place of the saved contact, and the Lender landing back on the
        // saved contact's bank no longer brings that contact back.
        if (lqKey === 'BANK_CONTACT' && String(lqData[lqRow].APPROVED).toLowerCase() === 'yes') {
            this.bankEditBase = null;
            this.setState((prev) => ({ data: { ...prev.data, LENDER_CONTACT_ID: null } }));
        }

        if (lqKey === 'IS_PRINTABLE') {
            this.toggleLoanQuoteColumn(lqData[lqRow], !!value);
        } else {
            recalculateLoanQuote(lqData[lqRow], [lqKey]);
        }

        if (lqKey === 'AMORTIZATION' && String(lqData[lqRow].APPROVED).toLowerCase() === 'yes') {
            this.applyApprovedLoanQuoteAmortization(lqData[lqRow]);
        }

        lqData[lqRow].LOAN_QUOTES_MODIFIED = true;
        this.setState({
            loanQuotesData: lqData
        });
    }

    /**
     * The checkbox at the top of a column says whether the quote prints.
     * Ticking a blank column also fills it in from the property and the
     * starting terms; unticking only takes it off the printout, the quote stays.
     */
    toggleLoanQuoteColumn(quote, checked) {
        if (this.isTabLocked('LOAN QUOTES')) return;
        quote.IS_PRINTABLE = checked;

        if (checked) {
            fillLoanQuoteFromProperty(quote, this.state.data || {});
        }
    }

    /**
     * Select All / Deselect All: the same as ticking or unticking each column.
     * A padding column that stays blank is not flagged, so the save does not
     * insert it as an empty quote.
     */
    toggleAllLoanQuoteColumns(checked) {
        if (this.isTabLocked('LOAN QUOTES')) return;
        const columns = (this.state.loanQuotesData || []).map((quote) => {
            if (!quote || !!quote.IS_PRINTABLE === checked) {
                return quote;
            }

            const updated = { ...quote };
            this.toggleLoanQuoteColumn(updated, checked);

            const hasContent = Object.keys(updated).some((key) => !lqIdentityKeys.includes(key) && !isBlankQuoteValue(updated[key]));
            if (updated.ARCIMEDES_ROW_ID || hasContent) {
                updated.LOAN_QUOTES_MODIFIED = true;
            }

            return updated;
        });

        this.setState({ loanQuotesData: columns });
    }

    /**
     * When a loan quote is marked Approved = Yes, mirror that quote's values into
     * the Loan Info tab (the property `data`). The plain-value fields copy
     * directly; Lender is resolved to a LENDERS record so the picker (and its
     * read-only Lender Contact) reflect it — see resolveLenderId for the match.
     */
    applyApprovedLoanQuoteToLoanInfo(quote) {
        const data = { ...this.state.data };

        const num = (v) => (typeof v === 'number' ? v : priceToNumber(v));

        const loanAmount = num(quote.LOAN_AMOUNT);
        data.LOAN_AMOUNT = loanAmount !== false ? Number(loanAmount).toLocaleString() : (quote.LOAN_AMOUNT == null ? "" : String(quote.LOAN_AMOUNT));

        const interestRate = typeof quote.INTEREST_RATE === 'number' ? quote.INTEREST_RATE : percentToNumber(quote.INTEREST_RATE);
        data.INTEREST_RATE = interestRate !== false ? String(interestRate) : (quote.INTEREST_RATE == null ? "" : String(quote.INTEREST_RATE));

        data.AMORTIZATION = quote.AMORTIZATION == null ? "" : String(quote.AMORTIZATION);
        data.TERM = quote.LOAN_TERM == null ? "" : String(quote.LOAN_TERM);
        data.MATURITY = quote.MATURITY == null ? "" : String(quote.MATURITY);
        data.PREPAYMENT_PENALTY = quote.PREPAYMENT_PENALTY == null ? "" : String(quote.PREPAYMENT_PENALTY);

        // Maturity Date = Loan Closing Date + Maturity (years).
        const maturityYears = parseInt(data.MATURITY, 10);
        const closing = data.LOAN_CLOSING_DATE && !isNaN(new Date(data.LOAN_CLOSING_DATE)) ? new Date(data.LOAN_CLOSING_DATE) : false;
        if (closing !== false && !isNaN(maturityYears)) {
            closing.setFullYear(closing.getFullYear() + maturityYears);
            data.MATURITY_DATE = dateToUsString(closing);
        }

        // These Loan Info fields normally auto-calculate; approving a quote pins
        // them to that quote's figures instead.
        Object.assign(data, approvedQuotePaymentFigures(quote));

        const qPrice = num(quote.PURCHASE_PRICE);
        data.LTV = loanAmount !== false && qPrice !== false && qPrice ? (loanAmount / qPrice * 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '';

        // A quote naming its own contact replaces the saved one, which would
        // otherwise hide it. Set aside, as un-approving does, so approving a
        // quote of this bank with no contact brings it back.
        if (String(quote.BANK_CONTACT || '').trim()) {
            this.bankEditBase = { ...this.approvedQuoteBase(), wroteLender: String(data.LENDER_ID || ''), wroteContact: null };
            data.LENDER_CONTACT_ID = null;
        }

        this.setState({ data });

        // Lender is an entity reference; resolve the free-text BANK to a LENDERS row.
        this.setLenderFromApprovedQuote(quote);
    }

    /**
     * Amortization edited on the approved quote shows on Loan Info too, with
     * the payment rows that follow from it, as approving the quote put them there.
     */
    applyApprovedLoanQuoteAmortization(quote) {
        if (this.isTabLocked('LOAN INFO')) return;
        const figures = approvedQuotePaymentFigures(quote);
        this.setState((prev) => ({
            data: {
                ...prev.data,
                AMORTIZATION: quote.AMORTIZATION == null ? '' : String(quote.AMORTIZATION),
                ...figures,
            },
        }));
    }

    setLenderFromApprovedQuote(quote) {
        this.resolveLenderId(quote.BANK).then((lenderId) => {
            if (lenderId != null) this.moveLenderWithApprovedQuote(lenderId, quote);
        });
    }

    /**
     * The approved quote moves the Loan Info Lender: its Lender typed a letter
     * at a time (the letters on the way match other lenders), or the quote
     * un-approved and approved again. The contact saved before is set aside and
     * comes back once the Lender lands on its bank again, unless the quote names
     * a contact of its own. Any other change of the Lender or contact, a new
     * edit, or another property ends that (bankEditBase = null).
     */
    moveLenderWithApprovedQuote(lenderId, quote) {
        const base = this.approvedQuoteBase();
        const ownContact = !!String(quote.BANK_CONTACT || '').trim();
        const contact = !ownContact && String(lenderId) === base.lender ? base.contact : null;
        this.bankEditBase = { ...base, wroteLender: String(lenderId), wroteContact: contact };
        this.setState({ data: { ...this.state.data, LENDER_ID: lenderId, LENDER_CONTACT_ID: contact } });
    }

    /** The contact set aside, unless something else changed the Lender or contact since the quote last did. */
    approvedQuoteBase() {
        const { data } = this.state;
        const lender = String(data.LENDER_ID || '');
        const contact = data.LENDER_CONTACT_ID == null ? null : data.LENDER_CONTACT_ID;
        const base = this.bankEditBase;
        return base && base.wroteLender === lender && base.wroteContact === contact ? base : { lender, contact };
    }

    /**
     * Un-approving a quote (Yes -> No/blank) removes the values it pushed into the
     * Loan Info tab, so stale approved figures don't linger.
     */
    clearApprovedLoanInfo() {
        if (this.isTabLocked('LOAN INFO')) return;
        // Each letter typed into Approved un-approves it: approving it again on
        // the same bank brings the contact back.
        this.bankEditBase = { ...this.approvedQuoteBase(), wroteLender: '', wroteContact: null };
        this.setState((prev) => ({
            data: {
                ...prev.data,
                LENDER_ID: '',
                LENDER_CONTACT_ID: null,
                LOAN_AMOUNT: '',
                INTEREST_RATE: '',
                AMORTIZATION: '',
                TERM: '',
                PREPAYMENT_PENALTY: '',
                MATURITY: '',
                MATURITY_DATE: '',
                LTV: '',
                ANNUAL_LOAN_PAYMENT: '',
                CASH_FLOW: '',
                CASH_ON_CASH: '',
                DSCR: '',
            },
        }));
    }

    /**
     * Best-effort match of a loan-quote Lender text to a LENDERS record — see
     * matchLenderByName for the matching rules. Returns the row id or null.
     */
    async resolveLenderId(bankText) {
        if (!this._lendersCache) {
            this._lendersCache = await this.fetchAllLenders();
        }
        const match = matchLenderByName(this._lendersCache || [], bankText);
        return match ? match.ARCIMEDES_ROW_ID : null;
    }

    async fetchAllLenders() {
        const limit = 1000;
        const all = [];
        let offset = 0;
        while (true) {
            const res = await getData({
                tableCode: LENDERS,
                options: {
                    limit: { count: limit, offset: offset * limit },
                    column: ['ARCIMEDES_ROW_ID', 'NAME', 'CONTACT_NAME'],
                    filter: [
                        { code: 'NAME', text: '', type: 'notNull' },
                        { code: 'DELETED', text: '', type: 'null' },
                    ],
                    filterType: 'and',
                    order: [{ code: 'NAME', type: 'asc' }],
                },
            });
            const rows = res && res.data ? res.data : [];
            all.push(...rows);
            if (rows.length < limit) break;
            offset++;
        }
        return all;
    }

    async setData(key, value, isAgentPercent = false, addAdditionalData = false, additionalDataValue = null) {
        // Every field edit on the page comes through here, so this is where an
        // access level's locked fields are held (the server drops them too).
        const locks = this.getEditLocks();
        if (isFieldLocked(locks, key) || isValueBlocked(locks, key, value)) return;
        let data = { ...this.state.data };
        if (key === 'LISTING_AGENT_4' && value && addAdditionalData === 'LISTING_AGENT_4_FIRM' && (additionalDataValue == null || additionalDataValue === '')) {
            const res = await getData({
                tableCode: AGENTS,
                options: {
                    column: ['FIRM'],
                    limit: { count: 1 },
                    filter: [{ code: 'ARCIMEDES_ROW_ID', text: String(value), type: 'equal' }],
                    filterType: 'and',
                },
            });
            if (res && res.success && res.data && res.data[0] != null && res.data[0].FIRM != null && res.data[0].FIRM !== '') {
                additionalDataValue = res.data[0].FIRM;
            }
        }
        if (key === 'BUYER_AGENT_4' && value && addAdditionalData === 'BUYER_AGENT_4_FIRM' && (additionalDataValue == null || additionalDataValue === '')) {
            const res = await getData({
                tableCode: AGENTS,
                options: {
                    column: ['FIRM'],
                    limit: { count: 1 },
                    filter: [{ code: 'ARCIMEDES_ROW_ID', text: String(value), type: 'equal' }],
                    filterType: 'and',
                },
            });
            if (res && res.success && res.data && res.data[0] != null && res.data[0].FIRM != null && res.data[0].FIRM !== '') {
                additionalDataValue = res.data[0].FIRM;
            }
        }
        if (['REFERRING_LISTING_AGENT', 'REFERRING_BUYER_AGENT'].includes(key) && value && addAdditionalData === key + '_FIRM' && (additionalDataValue == null || additionalDataValue === '')) {
            const res = await getData({
                tableCode: AGENTS,
                options: {
                    column: ['FIRM'],
                    limit: { count: 1 },
                    filter: [{ code: 'ARCIMEDES_ROW_ID', text: String(value), type: 'equal' }],
                    filterType: 'and',
                },
            });
            if (res && res.success && res.data && res.data[0] != null && res.data[0].FIRM != null && res.data[0].FIRM !== '') {
                additionalDataValue = res.data[0].FIRM;
            }
        }

        const lqData = cloneDeep(this.state.loanQuotesData);
        let paymentsData = this.state.propertyPaymentsData;

        let closeNoiChanged = false, soldPriceChanged = false, hscPriceChanged = false, loanPaymentChanged = false,
            cashFlowChanged = false, downPaymentChanged = false, hscTotalFeeChanged = false;
        const exceededDecimalsLimit = CRUDProperty.verifyPercentDecimalsLimit({ value, isAgentPercent });

        if (!exceededDecimalsLimit) {
            data = { ...data, [key]: value };
        }
        // A SUMMIT record keeps its SOURCE under the Senior Agent access level:
        // every limit on it hangs on SOURCE (access-levels.js).
        if (editsOwnSummitDealsOnly(getCurrentAccess()) && !isFieldLocked(locks, 'SOURCE')) {
            if (key === 'STATUS' && (value === 'Active' || value === 'Closed')) {
                data.SOURCE = 'External';
            }
            else if (key === 'STATUS' && (value === 'Proposal' || value === 'Property Info')) {
                data.SOURCE = 'SUMMIT';
            }
            else if (key === 'STATUS' && !(value === 'Active' || value === 'Closed')) {
                data.SOURCE = '';
            }
        }
        if (key === 'TRANSACTION_TYPE' && value === 'Extra Payment') {
            data.SOURCE = 'SUMMIT';
            // Hot List / New Development are hidden for Extra Payment; clear them so
            // the save sync removes the property from those lists instead of leaving
            // it stuck on with no visible checkbox to uncheck.
            data.HOT_LIST = false;
            data.NEW_DEVELOPMENT = false;
        }
        if (key === 'STATUS' && value === 'Closed' && data.SOURCE === 'SUMMIT' && data.NAME && data.NAME.includes('Christian Brothers Automotive') && data.TYPE === 'STNL' && data.SALE_LEASE_BACK === 'Yes' && data.CLOSE_OF_ESCROW) {
            data.LEASE_COMMENCEMENT_DATE = dateISOtoUS(data.CLOSE_OF_ESCROW) || data.CLOSE_OF_ESCROW;
            const escrowDate = new Date(data.CLOSE_OF_ESCROW);
            const expirationYear = escrowDate.getFullYear() + 15;
            const expirationDate = new Date(expirationYear, escrowDate.getMonth() + 1, 0).getDate();
            data.LEASE_EXPIRATION_DATE = `${escrowDate.getMonth() + 1}/${expirationDate}/${expirationYear}`;
        }

        if (key === "SOURCE") {
            data.LISTING_AGENT_4_FIRM = value === "SUMMIT" ? summitFirmId : "";

            if (value === "SUMMIT")
                data.ESTIMATED_PRICE_TYPE = "Act"
        }

        if (key === 'TYPE' && value === 'STNL') {
            data.VACANCY = 100;
        }

        if (key === "SQFT" || key === "LIST_PRICE") {
            data.PRICE_PER_SQFT = pricePerFoot(data.LIST_PRICE, data.SQFT);
        }

        if (key === "SQFT" || key === "NEGOTIATION_PRICE") {
            data.NEGOTIATION_PRICE_PER_SQFT = pricePerFoot(data.NEGOTIATION_PRICE, data.SQFT);
        }

        if (key === "SQFT" || key === "BASE_RENT" || key === 'NET_OPERATING_INCOME' || key === "VACANCY") {
            const price = data.TYPE === 'MT' ? data.BASE_RENT : data.NET_OPERATING_INCOME;
            const occupancy = data.TYPE === 'MT' ? data.VACANCY : '100';
            data.RENT_PER_SQFT = rentPerFoot(price, data.SQFT, occupancy);
        }

        if (key === 'NET_OPERATING_INCOME') {
            data.BASE_RENT = data.NET_OPERATING_INCOME;
        }

        if ((key === 'NET_OPERATING_INCOME' || key === 'STATUS') && data.STATUS === 'Closed' || key === 'CLOSE_OF_ESCROW') {
            data.CLOSE_NOI = data.NET_OPERATING_INCOME;
            closeNoiChanged = true;
        }

        if ((key === 'NEGOTIATION_PRICE' || key === 'STATUS') && data.STATUS === 'Closed' || key === 'CLOSE_OF_ESCROW') {
            data.SOLD_PRICE = (data.SOURCE === 'HSC' || data.SOURCE === 'External') ? data.HSC_PRICE : data.NEGOTIATION_PRICE;
            soldPriceChanged = true;
        }

        if (key === 'CLOSE_OF_ESCROW') {
            // data.LOAN_CLOSING_DATE = data.CLOSE_OF_ESCROW;
            data.LOAN_CLOSING_DATE = data.LOAN_TYPE != "Refi" ? (dateISOtoUS(data.CLOSE_OF_ESCROW) || data.CLOSE_OF_ESCROW) : data.LOAN_CLOSING_DATE;
            value = viewDateTimeFormat(value);
            const date = value ? value.split('/').length === 3 : false;
            if (data.NAME && data.NAME.includes('Christian Brothers Automotive') && data.TYPE && data.TYPE === 'STNL' && data.SALE_LEASE_BACK && data.SALE_LEASE_BACK === 'Yes' && date) {
                data.LEASE_COMMENCEMENT_DATE = value;
                const escrowDate = new Date(value);
                const expirationYear = escrowDate.getFullYear() + 15;
                const expirationDate = new Date(expirationYear, escrowDate.getMonth() + 1, 0).getDate();
                data.LEASE_EXPIRATION_DATE = `${escrowDate.getMonth() + 1}/${expirationDate}/${expirationYear}`;
            }
        }

        if (key === "NEGOTIATION_PRICE" || key === "NET_OPERATING_INCOME") {
            const price = priceToNumber(data.NEGOTIATION_PRICE);
            const noi = priceToNumber(data.NET_OPERATING_INCOME);
            data.NEGOTIATION_CAP_RATE = noi !== false && price !== false ? price ? Math.round((noi / price) * 10000) / 100 : 0 : "";
        }

        if (key === "SOLD_PRICE" || key === "CLOSE_NOI" || closeNoiChanged || soldPriceChanged) {
            const price = priceToNumber(data.SOLD_PRICE);
            const noi = priceToNumber(data.CLOSE_NOI);
            data.CLOSE_CAP_RATE = noi !== false && price !== false ? price ? Math.round((noi / price) * 10000) / 100 : 0 : "";
        }

        if (key === 'SQFT' || key === 'SOLD_PRICE' || soldPriceChanged) {
            data.CLOSE_PRICE_PER_SQFT = pricePerFoot(data.SOLD_PRICE, data.SQFT);
        }

        if (["LISTING_AGENT_1", "LISTING_AGENT_2", "LISTING_AGENT_3", "LISTING_AGENT_4", "REFERRING_LISTING_AGENT"].indexOf(key) !== -1) {
            data = changeListingAgentsPercent(data);
        }

        if (["BUYER_AGENT_1", "BUYER_AGENT_2", "BUYER_AGENT_3", "BUYER_AGENT_4", "REFERRING_BUYER_AGENT"].indexOf(key) !== -1) {
            data = changeBuyingAgentsPercent(data);
        }

        if (["LIST_PRICE", "SELLER_FEE_PERCENTAGE"].indexOf(key) !== -1) {
            const price = priceToNumber(data.LIST_PRICE);
            const percent = percentToNumber(data.SELLER_FEE_PERCENTAGE);
            data.TOTAL_FEE = price !== false && percent !== false ? (price * (percent / 100)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2, }) : "";
        }

        if (soldPriceChanged ||
            ["SOLD_PRICE", "NEGOTIATION_PRICE", "SELLER_FEE_PERCENTAGE", "LISTING_AGENT_1", "LISTING_AGENT_2", "LISTING_AGENT_3", "LISTING_AGENT_4",
                "BUYER_AGENT_1", "BUYER_AGENT_2", "BUYER_AGENT_3", "BUYER_AGENT_4",
                "LISTING_AGENT_1_PERCENT", "LISTING_AGENT_2_PERCENT", "LISTING_AGENT_3_PERCENT", "LISTING_AGENT_4_PERCENT",
                "BUYER_AGENT_1_PERCENT", "BUYER_AGENT_2_PERCENT", "BUYER_AGENT_3_PERCENT", "BUYER_AGENT_4_PERCENT",].indexOf(key) !== -1) {
            const price = data.SOLD_PRICE ? priceToNumber(data.SOLD_PRICE) : priceToNumber(data.NEGOTIATION_PRICE);
            const feePercent = percentToNumber(data.SELLER_FEE_PERCENTAGE);
            const strivePercents = percentToNumber(data.LISTING_AGENT_1_PERCENT) + percentToNumber(data.LISTING_AGENT_2_PERCENT) + percentToNumber(data.LISTING_AGENT_3_PERCENT) + percentToNumber(data.BUYER_AGENT_1_PERCENT) + percentToNumber(data.BUYER_AGENT_2_PERCENT) + percentToNumber(data.BUYER_AGENT_3_PERCENT);
            data.POTENTIAL_FEE = price !== false && feePercent !== false && strivePercents ? (price * (feePercent / 100) * (strivePercents / 100)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2, }) : "";
        }

        if (soldPriceChanged ||
            ["SOLD_PRICE", "SELLER_FEE_PERCENTAGE", "LISTING_AGENT_1", "LISTING_AGENT_2", "LISTING_AGENT_3",
                "LISTING_AGENT_1_PERCENT", "LISTING_AGENT_2_PERCENT", "LISTING_AGENT_3_PERCENT", "LISTING_AGENT_4_PERCENT",
                "BUYER_AGENT_1", "BUYER_AGENT_2", "BUYER_AGENT_3", "BUYER_AGENT_4",].indexOf(key) !== -1) {
            const soldPrice = priceToNumber(data.SOLD_PRICE);
            const feePercent = percentToNumber(data.SELLER_FEE_PERCENTAGE);
            const listAgentsPercent = percentToNumber(data.LISTING_AGENT_1_PERCENT) + percentToNumber(data.LISTING_AGENT_2_PERCENT) + percentToNumber(data.LISTING_AGENT_3_PERCENT) + percentToNumber(data.LISTING_AGENT_4_PERCENT);
            data.LIST_FEE = soldPrice !== false && feePercent !== false && listAgentsPercent ? (soldPrice * (feePercent / 100) * (listAgentsPercent / 100)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2, }) : "";
        }

        if (soldPriceChanged ||
            ["SOLD_PRICE", "SELLER_FEE_PERCENTAGE", "BUYER_AGENT_1", "BUYER_AGENT_2", "BUYER_AGENT_3", "BUYER_AGENT_4",
                "BUYER_AGENT_1_PERCENT", "BUYER_AGENT_2_PERCENT", "BUYER_AGENT_3_PERCENT", "BUYER_AGENT_4_PERCENT",
                "LISTING_AGENT_1", "LISTING_AGENT_2", "LISTING_AGENT_3",].indexOf(key) !== -1) {
            const soldPrice = priceToNumber(data.SOLD_PRICE);
            const feePercent = percentToNumber(data.SELLER_FEE_PERCENTAGE);
            const buyingAgentsPercent = percentToNumber(data.BUYER_AGENT_1_PERCENT) + percentToNumber(data.BUYER_AGENT_2_PERCENT) + percentToNumber(data.BUYER_AGENT_3_PERCENT) + percentToNumber(data.BUYER_AGENT_4_PERCENT);
            data.BUYSIDE_FEE = soldPrice !== false && feePercent !== false && buyingAgentsPercent ? (soldPrice * (feePercent / 100) * (buyingAgentsPercent / 100)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2, }) : "";
        }

        if (["EXPIRATION_NO_OF_MONTHS", "LISTED_DATE"].indexOf(key) !== -1) {
            data.EXPIRATION_DATE = calculateExpirationDate({ noMonths: data.EXPIRATION_NO_OF_MONTHS, listedDate: data.LISTED_DATE });
        }

        if ('SOURCE' === key && value === 'HSC') {
            data.TRANSACTION_TYPE = 'Financing';
            data.HSC_EXPIRATION_NO_OF_MONTHS = '6';
        }

        if (["HSC_EXPIRATION_NO_OF_MONTHS", "HSC_LISTED_DATE"].indexOf(key) !== -1) {
            data.HSC_EXPIRATION_DATE = calculateExpirationDate({ noMonths: data.HSC_EXPIRATION_NO_OF_MONTHS, listedDate: data.HSC_LISTED_DATE });
        }

        if (key === "HSC_FINANCING") {
            data.HSC_FINANCING = value;
            data.OTHER_FINANCING = null;
            // Peak Financing is always a purchase loan, so default the Loan Info
            // Loan Type to Purchase when it's checked (leave it be when unchecked).
            if (value) data.LOAN_TYPE = 'Purchase';
        } else if (key === "OTHER_FINANCING") {
            data.OTHER_FINANCING = value;
            data.HSC_FINANCING = null;
        }

        if (data.HSC_FINANCING && (!data.HSC_PRICE || soldPriceChanged || ['SOLD_PRICE', 'NEGOTIATION_PRICE'].includes(key))) {
            data.HSC_PRICE = data.STATUS === 'Closed' ? data.SOLD_PRICE : data.NEGOTIATION_PRICE;
            hscPriceChanged = true;
        }

        if (["BUYER_AGENT_1", "BUYER_AGENT_2", "BUYER_AGENT_3"].includes(key)) {
            data.BUYER_AGENT_4_FIRM = summitFirmId;
        }

        if (key === "LISTING_AGENT_1" && value) {
            data.LISTING_AGENT_4_FIRM = summitFirmId;
        }

        if (data.SOURCE === 'HSC' && ['HSC_PRICE', 'NET_OPERATING_INCOME'].includes(key)) {
            const price = priceToNumber(data.HSC_PRICE);
            const noi = priceToNumber(data.NET_OPERATING_INCOME);
            data.CAPITALIZATION_RATE = price !== false && noi !== false ? (noi / price * 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '';
        }

        if (hscPriceChanged || ['HSC_PRICE', 'LOAN_AMOUNT'].includes(key)) {
            const price = priceToNumber(data.HSC_PRICE);
            const loanAmount = priceToNumber(data.LOAN_AMOUNT);
            data.LTV = price !== false && loanAmount !== false ? (loanAmount / price * 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '';
            data.DOWN_PAYMENT = price !== false && loanAmount !== false ? (price - loanAmount).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 }) : '';
            downPaymentChanged = true;
        }

        if ((data.SOURCE === 'HSC' || data.HSC_FINANCING) && ['HSC_PRICE', 'SQFT'].includes(key)) {
            data.PRICE_PER_SQFT = pricePerFoot(data.HSC_PRICE, data.SQFT);
        }

        if (['HSC_FEE_PERCENTAGE', 'LOAN_AMOUNT'].includes(key)) {
            const loanAmount = priceToNumber(data.LOAN_AMOUNT);
            const percent = percentToNumber(data.HSC_FEE_PERCENTAGE);
            data.HSC_TOTAL_FEE = loanAmount !== false && percent !== false ? (loanAmount * (percent / 100)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "";
            hscTotalFeeChanged = true;
        }

        if (hscTotalFeeChanged || ['REFERRAL', 'CREDITS_AT_CLOSING', 'BANK_BONUS'].includes(key)) {
            const hscTotalFee = priceToNumber(data.HSC_TOTAL_FEE);
            const referral = data.REFERRAL ? priceToNumber(data.REFERRAL) : 0;
            const credits = data.CREDITS_AT_CLOSING ? priceToNumber(data.CREDITS_AT_CLOSING) : 0;
            const bankBonus = data.BANK_BONUS ? priceToNumber(data.BANK_BONUS) : 0;
            data.HSC_LIST_FEE = hscTotalFee !== false && referral !== false && credits !== false && bankBonus !== false ? (hscTotalFee - referral - credits + bankBonus).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "";
        }

        // A percentage of a zero total stays empty: 0 ÷ 0 gives "NaN", and the column refuses the whole row.
        if (hscTotalFeeChanged || 'REFERRAL' === key) {
            const hscTotalFee = priceToNumber(data.HSC_TOTAL_FEE);
            const referral = priceToNumber(data.REFERRAL);
            data.REFERRAL_PERCENT = hscTotalFee && referral !== false ? (referral / hscTotalFee * 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '';
        }

        if (hscTotalFeeChanged || 'REFERRAL_PERCENT' === key) {
            const hscTotalFee = priceToNumber(data.HSC_TOTAL_FEE);
            const referralPercent = priceToNumber(data.REFERRAL_PERCENT);
            // With a zero fee there is no percentage to rebuild the amount from, so the amount stands.
            if (hscTotalFee !== 0 || referralPercent !== false) {
                data.REFERRAL = hscTotalFee !== false && referralPercent !== false ? (hscTotalFee / 100 * referralPercent).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '';
            }
        }

        if (hscTotalFeeChanged || 'BANK_BONUS' === key) {
            const loanPayment = priceToNumber(data.LOAN_AMOUNT);
            const bankBonus = priceToNumber(data.BANK_BONUS);
            data.BANK_BONUS_PERCENT = loanPayment && bankBonus !== false ? (bankBonus / loanPayment * 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '';
        }

        if ('BANK_BONUS_PERCENT' === key) {
            const loanPayment = priceToNumber(data.LOAN_AMOUNT);
            const bankBonusPercent = priceToNumber(data.BANK_BONUS_PERCENT);
            data.BANK_BONUS = loanPayment !== false && bankBonusPercent !== false ? (loanPayment / 100 * bankBonusPercent).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '';
        }

        if (hscTotalFeeChanged) {
            hscAgentsKeys.filter(key => data[key] != null).map((key) => {
                this.computeHscAgentFees(data, key);
            });
        }

        if (['INTEREST_RATE', 'AMORTIZATION', 'LOAN_AMOUNT'].includes(key)) {
            const interestRate = percentToNumber(data.INTEREST_RATE);
            const amortization = priceToNumber(data.AMORTIZATION);
            const loanAmount = priceToNumber(data.LOAN_AMOUNT);
            const interestOnly = isInterestOnly(data.AMORTIZATION) && interestRate !== false && loanAmount !== false;
            data.ANNUAL_LOAN_PAYMENT = interestOnly
                ? (loanAmount * interestRate / 100).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })
                : interestRate !== false && amortization !== false && loanAmount !== false ? (-pmtFunction(interestRate / 100 / 12, amortization * 11.8, loanAmount) * 12).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 }) : '';
            loanPaymentChanged = true;
        }

        if (loanPaymentChanged || 'NET_OPERATING_INCOME' === key) {
            const noi = priceToNumber(data.NET_OPERATING_INCOME);
            const loanPayment = priceToNumber(data.ANNUAL_LOAN_PAYMENT);
            data.CASH_FLOW = noi !== false && loanPayment !== false ? (noi - loanPayment).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 }) : '';
            data.DSCR = noi !== false && loanPayment !== false ? loanPayment ? (noi / loanPayment).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : 0 : '';
            cashFlowChanged = true;
        }

        if (cashFlowChanged || downPaymentChanged) {
            const cashFlow = priceToNumber(data.CASH_FLOW);
            const downPayment = priceToNumber(data.DOWN_PAYMENT);
            data.CASH_ON_CASH = cashFlow !== false && downPayment !== false ? downPayment ? (cashFlow / downPayment * 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : 0 : '';
        }

        if (data.OTHER_FINANCING) {
            // Other Financing: Maturity Date = Close of Escrow + Term (years). Many
            // older deals hold Term 0 beside a hand-entered Maturity Date, so only
            // write it once both are usable and never blank what is there.
            if (['CLOSE_OF_ESCROW', 'TERM', 'OTHER_FINANCING'].includes(key)) {
                const coe = dateISOtoUS(data.CLOSE_OF_ESCROW);
                const term = parseInt(data.TERM, 10);
                if (coe && term > 0) {
                    const maturityDate = new Date(coe);
                    maturityDate.setFullYear(maturityDate.getFullYear() + term);
                    data.MATURITY_DATE = dateToUsString(maturityDate);
                }
            }
        } else if (['LOAN_CLOSING_DATE', 'MATURITY'].includes(key)) {
            const loanClosingDate = data.LOAN_CLOSING_DATE && !isNaN(new Date(data.LOAN_CLOSING_DATE)) ? new Date(data.LOAN_CLOSING_DATE) : false;
            const maturity = data.MATURITY ? parseInt(data.MATURITY) : false;
            data.MATURITY_DATE = '';
            if (loanClosingDate !== false && maturity !== false) {
                loanClosingDate.setFullYear(loanClosingDate.getFullYear() + maturity);
                data.MATURITY_DATE = dateToUsString(loanClosingDate);
            }
        }

        if (key === "HSC_APPROVED") {
            if (value) {
                const date = new Date();
                const formattedDate = dateToTimestamp(date);

                const teamMember = hscTeamMembers.find(
                    (elem) => normalizePeakEmail(elem.EMAIL) === normalizePeakEmail(data.HSC_TEAM_MEMBER_1)
                );
                data.HSC_APPROVED_INITIALS = teamMember ? teamMember.INITIALS : null;
                data.HSC_APPROVED = value;
                data.HSC_APPROVED_TIMESTAMP = formattedDate;

                if (data.SOURCE === 'HSC' && data.HSC_STATUS !== 'Closed') {
                    data.HSC_STATUS = 'Closed';
                }
            } else {
                data.HSC_APPROVED = value;
            }
        }

        // Only a column holding a quote follows the property's figures; blank ones stay blank.
        if (key === 'NEGOTIATION_PRICE' && data.SOURCE === 'SUMMIT' || key === 'HSC_PRICE' && data.SOURCE === 'HSC') {
            lqData.filter(isLiveLoanQuote).forEach(element => {
                element.PURCHASE_PRICE = priceToString(data[key]);
                deriveLoanQuoteFigures(element);

                if (data.SOURCE === 'SUMMIT')
                    element.CAP_RATE = data.NEGOTIATION_CAP_RATE;
            });
        }

        if (key === 'NET_OPERATING_INCOME') {
            lqData.filter(isLiveLoanQuote).forEach(element => {
                element.NOI = Math.round(priceToNumber(data[key]));
                element.NOI_MULTIPLIED = element.NOI_PERCENTAGE ? Math.round(element.NOI * element.NOI_PERCENTAGE / 100) : Math.round(element.NOI * 0.9);

                if (element.LOAN_PAYMENT_ANNUALLY && element.NOI)
                    element.DSCR = (element.NOI / element.LOAN_PAYMENT_ANNUALLY).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                if (element.LOAN_AMOUNT && element.NOI)
                    element.DEBT_YIELD = element.NOI / element.LOAN_AMOUNT * 100;
            });
        }

        if (key === 'CAPITALIZATION_RATE' && data.SOURCE === 'HSC') {
            lqData.forEach(element => {
                element.CAP_RATE = percentToNumber(data[key]);
            });
        }

        if (key === 'NOI_PERCENT') {
            lqData.forEach((element) => {
                // element.NOI_MULTIPLIED = percentToNumber(data[key]) / 100 * element.NOI;
                element.DSCR = String((Number(element.NOI_MULTIPLIED) / Number(element.LOAN_PAYMENT_ANNUALLY)).toFixed(2));
            });
        }

        if (['TRANSACTION_TYPE', 'SOURCE'].includes(key) && data.TRANSACTION_TYPE === 'Referral' && data.SOURCE === 'SUMMIT' && data.CLOSE_OF_ESCROW) {
            const filledAgentsNr = paymentsData.filter(el => el.ARCIMEDES_ROW_ID).length;

            if (filledAgentsNr > minReferralMembers)
                paymentsData.length = filledAgentsNr;
            else
                paymentsData.length = minReferralMembers;
        }

        if (['TRANSACTION_TYPE', 'SOURCE', 'STATUS'].includes(key) && data.TRANSACTION_TYPE !== 'Referral' && data.SOURCE === 'SUMMIT' && data.STATUS === 'Closed') {
            const paymentsLength = paymentsData.length;
            const filledAgentsNr = paymentsData.filter(el => el.ARCIMEDES_ROW_ID).length;

            if (filledAgentsNr > minStriveMembers) {
                Array.from({ length: paymentsLength - filledAgentsNr }, () => ({ PROPERTY_ID: data.ARCIMEDES_ROW_ID })).map((elem) => {
                    paymentsData.push(elem);
                });
            } else if (paymentsLength < minStriveMembers) {
                Array.from({ length: minStriveMembers - paymentsLength }, () => ({ PROPERTY_ID: data.ARCIMEDES_ROW_ID })).map((elem) => {
                    paymentsData.push(elem);
                });
            }
        }
        if (key && key['isHotList']) {
            data.HOT_LIST = true;
        }
        if (key && key['isNewDevelopment']) {
            data.NEW_DEVELOPMENT = true;
        }

        if (addAdditionalData) {
            data[addAdditionalData] = additionalDataValue;
        }

        let displayedHSCAgents = this.state.displayedHSCAgents;
        if (key && ['HSC_TEAM_MEMBER'].includes(key)) {
            if (key === 'HSC_TEAM_MEMBER_1' || key === 'HSC_TEAM_MEMBER_2') {
                const otherTeamMemberKey = key === 'HSC_TEAM_MEMBER_1' ? 'HSC_TEAM_MEMBER_2' : 'HSC_TEAM_MEMBER_1';

                if (!value) {
                    data[key + '_PERCENT'] = null;
                    data[key + '_NET_FEE'] = null;
                    data[key + '_NET_PERCENT'] = null;
                    data[key + '_GROSS_FEE'] = null;
                    if (displayedHSCAgents > 1)
                        displayedHSCAgents--;
                    if (data[otherTeamMemberKey]) {
                        data[otherTeamMemberKey + '_PERCENT'] = '100';

                        this.computeHscAgentFees(data, otherTeamMemberKey);
                    }
                } else {
                    if (!data[key + '_PERCENT']) {
                        const agentPercentage = data[otherTeamMemberKey] ? '50' : '100';
                        data[key + '_PERCENT'] = agentPercentage;
                        data[otherTeamMemberKey + '_PERCENT'] = agentPercentage === '50' ? '50' : null;

                        if (data[otherTeamMemberKey + '_PERCENT'])
                            this.computeHscAgentFees(data, otherTeamMemberKey);
                    }
                    await this.getHscAgentGrossCumulative(data, value);
                    this.computeHscAgentFees(data, key);
                }
            }
            if (key.includes('_PERCENT')) {
                this.computeHscAgentFees(data, key.split('_PERCENT')[0]);
            }
        }
        if (['BUYER_POOL', 'CHALLENGES', 'QUALIFICATIONS', 'RECOMMENDATIONS', 'STRENGTHS'].includes(key)) {
            this.state.proposalData = { ...this.state.proposalData, [key]: value, UPDATED: new Date().toISOString() }
        }
        const proposalData = { ...this.state.proposalData };
        const statusDataCopy = cloneDeep(this.state.historyData)
        if (Array.isArray(statusDataCopy) && statusDataCopy.length && Object.keys(statusDataCopy[0]).length) {
            if (value === "SUMMIT") {
                statusDataCopy[0].STATUS = "Refi"
            }
            else {
                statusDataCopy[0].STATUS = null
            }
        }
        const referringAgentData = { ...this.state.referringAgentData, [key]: data[key] };
        if (referringAgentData) {
            const referringKeys = [
                'REFERRING_LISTING_AGENT',
                'REFERRING_LISTING_AGENT_PERCENT',
                'REFERRING_LISTING_AGENT_FIRM',
                'REFERRING_BUYER_AGENT',
                'REFERRING_BUYER_AGENT_PERCENT',
                'REFERRING_BUYER_AGENT_FIRM',
            ];
            referringKeys.forEach((refKey) => {
                data[refKey] = data[refKey] || referringAgentData[refKey] || '';
            });
        }
        this.setState({
            data,
            proposalData,
            loanQuotesData: lqData,
            propertyPaymentsData: paymentsData,
            displayedHSCAgents,
            historyData: statusDataCopy,
            referringAgentData: referringAgentData
        }, () => {
            if (key === 'HSC_APPROVED' && this.isCurrentUserPeakTeamMember1(data)) {
                this.setState({ viewMode: true, isBusy: true }, () =>
                    this.checkCoordinatesAndSave(data, this.state.original)
                );
            }
        });
    }

    handlePropsalInputChange(key, value, e) {
        if (['STRENGTHS', 'CHALLENGES', 'BUYER_POOL', 'QUALIFICATIONS', 'RECOMMENDATIONS'].includes(key)) {
            let proposalData = this.state.proposalData;
            proposalData = proposalData.map(item => {
                if (item.ARCIMEDES_ROW_ID === e.target.id) {
                    item = { ...item, [key]: value }
                }
                return item;
            });
            this.setState({ proposalData });
        }
    }

    addHscMember() {
        let displayedHSCAgents = this.state.displayedHSCAgents;
        if (displayedHSCAgents < maxHscMembers)
            displayedHSCAgents++;
        this.setState({ displayedHSCAgents })
    }

    handleAddMember() {
        if (this.isTabLocked('PAYMENT')) return;
        const data = this.state.propertyPaymentsData;
        const propertyData = this.state.data;

        if (data.length + 1 <= maxSummitMembers)
            data.push({
                PROPERTY_ID: propertyData.ARCIMEDES_ROW_ID
            });

        this.setState({
            propertyPaymentsData: data,
        });
    }

    async handleChangeFile(key, value) {
        // A parcel waiting to be added has to go in through the map's create,
        // which is the only path that attaches its owner. The silent insert
        // below would file it without one and then look like an existing
        // property to the Save that follows.
        if (this.parcelHandoff) {
            this.setState({ error: 'Add the property first — files can be attached once it is saved.', success: null });

            return;
        }

        // For a new unsaved property, silently create it first to get an ID.
        // This ensures the subsequent form Save will UPDATE the same row rather than INSERT a duplicate.
        if (!this.state.data.ARCIMEDES_ROW_ID && !this.state.newPropertyId) {
            this.setState({ isBusy: true });
            const rowData = { ...this.state.data, [key]: value };
            const res = await request(arc.path.api, {
                service: "arcimedes",
                action: "open.datasource.table.Data.updateByTableCode",
                params: [PROPERTIES, { value: [rowData] }],
            });
            if (res && res.success && Array.isArray(res.data) && res.data.length) {
                const newId = res.data[0].ARCIMEDES_ROW_ID;
                this.setState(prevState => ({
                    isBusy: null,
                    newPropertyId: newId,
                    data: { ...prevState.data, [key]: value, ARCIMEDES_ROW_ID: newId },
                }));
            } else {
                this.setState({ isBusy: null });
            }
            return;
        }
        // For an existing property (or one already pre-created), run the normal save.
        // An upload saves straight away, so a held-back List Price goes back first.
        await this.revertHeldBackFields();
        let data = this.state.data;
        data[key] = value;
        this.saveData(data, false);
    }
    async getHotListPropertiesByEmail() {
        let hotlistProperties = [];
        const res = await executeQuery({
            queryName: HOTLIST_PROPERTIES_BY_EMAIL,
            params: {
                EMAIL_ID: this.props.userData.email
            }
        });
        if (res && res.success && res.data) {
            hotlistProperties = res;
        }
        else {
            this.setState({
                error: res && res.message ? res.message : "Unspecified error",
            });
        }

        return hotlistProperties;
    }
    async getNewDevelopmentPropertiesByEmail() {
        let newDevProperties = [];
        const res = await getData({
            tableCode: NEW_DEVELOPMENT_HISTORY,
            columns: [
                'ARCIMEDES_ROW_ID',
                'ID',
                'NAME',
                'EMAIL_ID',
                'NEW_DEVELOPMENT_PROPERTIES'
            ],
            options: {
                filterType: 'and',
                filter: [
                    { code: 'EMAIL_ID', text: this.props.userData.email, type: 'equal' }
                ],
            },
        });
        if (res && res.success && res.data) {
            newDevProperties = res;
        } else {
            this.setState({
                error: res && res.message ? res.message : "Unspecified error",
            });
        }
        return newDevProperties;
    }
    async recomputePayments(data, paymentsData) {
        this.setState({
            recomputePayments: true
        });

        await this.getAgentsGrossCumulativeProcured(data, paymentsData);
        // get the payment data for all properties closed after the current property
        const res = await executeQuery({
            queryName: GET_PAYMENT_PROPERTIES,
            params: {
                COE: data.CLOSE_OF_ESCROW,
                PROPERTY_ID: data.ARCIMEDES_ROW_ID
            }
        });
        const propertyPaymentsData = cloneDeep(paymentsData);
        if (res && res.success && res.data) {
            const dataToSave = [];
            const agentsGrossCumulativeProcured = { ...this.state.agentsGrossCumulativeProcured };
            const isReferral = data.TRANSACTION_TYPE === 'Referral';
            const paymentMembersId = Object.keys(paymentsData).map(key => paymentsData[key].STRIVE_TEAM_MEMBER_ID);
            [...paymentsData, ...res.data].forEach(elem => {
                // compute the Net only for the agents that have a new cumulative
                if (elem.STRIVE_TEAM_MEMBER_ID && paymentMembersId.includes(elem.STRIVE_TEAM_MEMBER_ID)) {
                    const index = paymentMembersId.findIndex(paymentMemberId => paymentMemberId === elem.STRIVE_TEAM_MEMBER_ID);
                    const params = {
                        grossFeePaid: elem.STRIVE_TEAM_MEMBER_GROSS_FEE ? parseFloat(elem.STRIVE_TEAM_MEMBER_GROSS_FEE) : 0,
                    }
                    if (elem.LISTING_GROSS_COMMISSION) {
                        params.grossFeeProcured = elem.LISTING_GROSS_COMMISSION ? parseFloat(elem.LISTING_GROSS_COMMISSION) : 0;
                        params.grossFeeProcured += elem.BUYING_GROSS_COMMISSION ? parseFloat(elem.BUYING_GROSS_COMMISSION) : 0;
                    } else {
                        const percentProcured = CRUDProperty.getAgentProcuredPercent({ agentId: elem.STRIVE_TEAM_MEMBER_ID, data });
                        const fee = isReferral ? data.REFERRAL_FEE : data.POTENTIAL_FEE;
                        params.grossFeeProcured = priceToNumber(fee) * percentProcured / 100;
                    }
                    agentsGrossCumulativeProcured[`GROSS_CUMULATIVE_${index + 1}`] += params.grossFeeProcured;
                    params.grossCumulativeProcured = agentsGrossCumulativeProcured[`GROSS_CUMULATIVE_${index + 1}`];
                    let { net, netPercentage } = CRUDProperty.computeFees(params);
                    if (net && net !== elem.STRIVE_TEAM_MEMBER_NET_FEE) {
                        propertyPaymentsData[index].STRIVE_TEAM_MEMBER_NET_FEE = net;
                        propertyPaymentsData[index].STRIVE_TEAM_MEMBER_NET_PERCENT = netPercentage;
                        dataToSave.push({
                            STRIVE_TEAM_MEMBER_NET_FEE: net,
                            STRIVE_TEAM_MEMBER_NET_PERCENT: netPercentage,
                        });
                        if (elem.ARCIMEDES_ROW_ID)
                            dataToSave[dataToSave.length - 1].ARCIMEDES_ROW_ID = elem.ARCIMEDES_ROW_ID;
                    }
                }
            });

            if (dataToSave.length) {
                const res = await manageData({ tableCode: PROPERTY_PAYMENT_TEAM, data: dataToSave });
                if (res && res.success)
                    this.setState({ recomputePayments: false });
                else
                    this.setState({
                        error: res && res.message ? res.message : "Unspecified error",
                    });
            } else
                this.setState({ recomputePayments: false });
        } else {
            this.setState({
                error: res && res.message ? res.message : "Unspecified error",
            });
        }

        return propertyPaymentsData;
    }

    async handleInputBlur(key) {
        let data = this.state.data;
        if ((key === 'LOAN_CLOSING_DATE' || key === 'CLOSE_OF_ESCROW') && (data.SOURCE === 'HSC' || data.HSC_FINANCING)) {
            await this.getHscAgentsGrossCumulative(data);

            hscAgentsKeys.filter(key => data[key] != null).map(key => {
                this.computeHscAgentFees(data, key);
            });
        }
    }

    fetchTerritoryByZip(zip) {
        this.zipLookup = zip;
        this.setState({ zipLoading: true });
        const marketToState = {
            'Arkansas': 'AR',
            'California - Central': 'CA',
            'California - Northern': 'CA',
            'California - Southern': 'CA',
            'Louisiana': 'LA',
            'Oklahoma': 'OK',
            'Austin': 'TX',
            'Central Texas': 'TX',
            'DFW': 'TX',
            'East Texas': 'TX',
            'Houston': 'TX',
            'San Antonio': 'TX',
            'Valley': 'TX',
            'West Texas': 'TX',
        };

        const applyTerritory = (territory, marketCode) => {
            const data = { ...this.state.data };
            if (territory.CITY) {
                data.CITY = zipLookupCity(territory.CITY);
            }
            if (!territory.MARKET_ID) {
                data.MARKET = 'Other';
            } else if (marketCode) {
                const stateAbbr = marketToState[marketCode];
                if (stateAbbr) {
                    data.MARKET = marketCode;
                    data.MARKET_CODE = marketCode;
                    data.STATE = stateAbbr;
                } else {
                    data.MARKET = 'Other';
                }
            } else {
                data.MARKET = 'Other';
            }
            if (territory.COUNTY) {
                data.COUNTY = territory.COUNTY;
            }
            this.setState({ data, zipLoading: false });
        };

        getData({
            tableCode: TERRITORY_CITIES_V2,
            options: {
                filterType: 'and',
                filter: [
                    { code: 'ZIP', text: zip, type: 'equal' },
                ],
            },
        }).then(res => {
            if (this.zipAnswerIsStale(zip)) return;
            if (res && res.success && res.data && res.data.length > 0) {
                const marketIds = Array.from(new Set(res.data.map(r => r.MARKET_ID).filter(Boolean)));

                const buildAndShow = (marketMap) => {
                    const seen = new Set();
                    const uniqueOptions = [];
                    res.data.forEach(row => {
                        const code = row.MARKET_ID ? (marketMap[row.MARKET_ID] || 'Other') : 'Other';
                        const key = `${row.CITY || ''}|${code}`;
                        if (!seen.has(key)) {
                            seen.add(key);
                            uniqueOptions.push({ ...row, MARKET_CODE: code });
                        }
                    });

                    if (uniqueOptions.length === 1) {
                        applyTerritory(uniqueOptions[0], uniqueOptions[0].MARKET_CODE);
                    } else {
                        this.setState({
                            zipLoading: false,
                            showTerritoryModal: true,
                            territoryOptions: uniqueOptions,
                        });
                    }
                };

                if (marketIds.length === 0) {
                    buildAndShow({});
                    return;
                }

                getData({
                    tableCode: MARKETS,
                    options: {
                        column: ['ARCIMEDES_ROW_ID', 'CODE'],
                        filter: marketIds.map(id => ({ code: 'ARCIMEDES_ROW_ID', text: String(id), type: 'equal' })),
                        filterType: 'or',
                    },
                }).then(marketRes => {
                    if (this.zipAnswerIsStale(zip)) return;
                    const marketMap = {};
                    if (marketRes && marketRes.success && marketRes.data) {
                        marketRes.data.forEach(m => {
                            marketMap[m.ARCIMEDES_ROW_ID] = m.CODE;
                        });
                    }
                    buildAndShow(marketMap);
                });
            } else {
                this.fetchZipFromExternalApi(zip);
            }
        });
    }

    /** An answer for a ZIP no longer in the field is dropped; the last lookup asked still ends "Loading...". */
    zipAnswerIsStale(zip) {
        if (this.state.data.ZIP === zip) {
            return false;
        }
        if (this.zipLookup === zip) {
            this.setState({ zipLoading: false });
        }
        return true;
    }

    selectTerritoryOption(option) {
        const marketToState = {
            'Arkansas': 'AR',
            'California - Central': 'CA',
            'California - Northern': 'CA',
            'California - Southern': 'CA',
            'Louisiana': 'LA',
            'Oklahoma': 'OK',
            'Austin': 'TX',
            'Central Texas': 'TX',
            'DFW': 'TX',
            'East Texas': 'TX',
            'Houston': 'TX',
            'San Antonio': 'TX',
            'Valley': 'TX',
            'West Texas': 'TX',
        };
        const data = { ...this.state.data };
        if (option.CITY) {
            data.CITY = zipLookupCity(option.CITY);
        }
        if (!option.MARKET_ID) {
            data.MARKET = 'Other';
        } else if (option.MARKET_CODE) {
            const stateAbbr = marketToState[option.MARKET_CODE];
            if (stateAbbr) {
                data.MARKET = option.MARKET_CODE;
                data.MARKET_CODE = option.MARKET_CODE;
                data.STATE = stateAbbr;
            } else {
                data.MARKET = 'Other';
            }
        } else {
            data.MARKET = 'Other';
        }
        if (option.COUNTY) {
            data.COUNTY = option.COUNTY;
        }
        this.setState({ data, showTerritoryModal: false, territoryOptions: [] });
    }

    async fetchZipFromExternalApi(zip) {
        // Market and County are left blank so the user can select them manually
        await this.setData('COUNTY', null);
        await this.setData('MARKET', null);

        try {
            if (zipCodeCache[zip]) {
                const cached = zipCodeCache[zip];
                this.setData('CITY', cached.city);
                this.setData('STATE', cached.state);
                return;
            }

            const res = await axios.get(`https://api.zippopotam.us/us/${zip}`);
            if (this.zipAnswerIsStale(zip)) return;
            if (res.data && res.data.places && res.data.places.length > 0) {
                const place = res.data.places[0];
                const city = zipLookupCity(place['place name'] || '');
                const state = place['state abbreviation'] || '';
                if (city || state) {
                    zipCodeCache[zip] = { city, state };
                }
                if (city) this.setData('CITY', city);
                if (state) this.setData('STATE', state);
            }
        } catch (err) {
            console.error('ZIP code lookup failed:', err);
        } finally {
            if (!this.zipAnswerIsStale(zip)) this.setState({ zipLoading: false });
        }
    }

    async handleChangeInput(key, value) {
        if (value === undefined) {
            await this.setData(key, !this.state.data[key]);
        } else if (key == 'ACCOUNT') {
            this.setState((prevState) => ({ ...prevState, account: { ...prevState.account, value } }))
        } else {
            const isAgentPercent = agentKeyPercents.includes(key);
            await this.setData(key, value, isAgentPercent);

            if (key === 'ZIP' && value && value.length === 5 && /^\d{5}$/.test(value)) {
                this.fetchTerritoryByZip(value);
            }

            if (key === 'LEASE_COMMENCEMENT_DATE') {
                const transformedDate = new Date(value);
                const ledYear = new Date(this.state.data['LEASE_EXPIRATION_DATE']).getFullYear();
                const lcdYear = new Date(this.state.data['LEASE_COMMENCEMENT_DATE']).getFullYear();
                let year = ledYear || lcdYear;
                if (ledYear < lcdYear) {
                    year = lcdYear;
                }
                let month = transformedDate.getMonth();
                var lastDay = new Date(year, transformedDate.getMonth(), 0).getDate();
                if (transformedDate.getDate() > 14) {
                    month = month + 2;
                    if (month == 13) {
                        month = 1;
                        year = year + 1;
                    }

                    lastDay = new Date(year, transformedDate.getMonth() + 2, 0).getDate();
                } else {
                    if (month < 1) {
                        month = 12;
                        year = year - 1;
                    }
                }
                const _value = month + "/" + lastDay + "/" + year;
                this.setData("LEASE_EXPIRATION_DATE", _value);
            }
        }

    }

    handleLeadLinksChange(leadLinks) {
        this.setData('lead_links', leadLinks);
    }

    handleHscPaymentsChangeDropdown({ data, key, index }) {
        if (key === 'HSC_TEAM_MEMBER_ID') {
            const teamMemberKey = `HSC_TEAM_MEMBER_${index + 1}`;

            this.setData(teamMemberKey, data.HSC_TEAM_MEMBER_ID);
        }
    }

    handleHscPaymentsChangeInput({ index, key, value }) {
        const newKey = 'HSC_TEAM_MEMBER_' + (index + 1) + key.split('HSC_TEAM_MEMBER')[1];
        this.setData(newKey, value);
    }

    handlePaymentsChangeDropdown({ data, key, index }) {
        this.setPaymentsData({ key, value: data[key], index });
    }

    handleLoanQuotesChangeInput(key, value) {
        this.setLoanQuotesData(key, value);
    }

    handleLoanQuotesChangeDropdown(query, queryType, x, key) {
        // Extract the value from the query object - it could be query[key] or just query
        const value = query && typeof query === 'object' && query[key] !== undefined ? query[key] : query;
        this.setLoanQuotesData(key, value);
    }

    handlePrintPagesDropDown(key, value) {
        this.setLoanQuotesData(value, key);
    }

    handleChangeSeller() {
        const data = this.state.data;
        data.SELLER_ID = null;
        this.setState({
            data: data
        });
    }

    handleChangeDropdown(query, queryType, x, key, key2) {
        if (key === 'LENDER_ID' || key === 'LENDER_CONTACT_ID') this.bankEditBase = null;
        const isAgentPercent = agentKeyPercents.includes(key);
        if (["LISTING_AGENT_4", "BUYER_AGENT_4", "REFERRING_LISTING_AGENT", "REFERRING_BUYER_AGENT"].includes(key))
            this.setData(key, query[key], isAgentPercent, key + "_FIRM", query[key + "_FIRM"]);
        else if (key === "SELLER_ID") {
            this.setState({ sellerSelected: true }, () =>
                this.setData(key, query[key], isAgentPercent)
            );
        } else this.setData(key, query[key], isAgentPercent, key2, query[key2]);
    }

    handleSellerChangeInput(key, value) {
        this.setState({ seller: { ...this.state.seller, [key]: value } });
    }

    handleSellerChangeDropdown(query, queryType, x, key) {
        if (key === "SELLER_ID") {
            this.setState({ sellerSelected: true }, () =>
                this.setData(key, query[key])
            );
        } else this.setState({ seller: { ...this.state.seller, [key]: query[key] } });
    }

    getTenantsForTags(tenantIds) {
        if (!tenantIds) {
            return [];
        }

        let formattedQueryValues = tenantIds.split(",");
        let response = [];

        // Display only first 5 tenants by sqft
        const tenantsBySQFT = this.state.tenantsBySQFT;
        const allTenantsById = this.state.allTenantsById;
        response = formattedQueryValues ? formattedQueryValues
            .filter((x) => {
                if (allTenantsById[x] && allTenantsById[x].NAME.toLowerCase() !== "vacant") {
                    return x;
                }
            })
            .map((x) => {
                const tenant = find(tenantsBySQFT, { TENANT_ID: x });
                const sqft = tenant && tenant.RR_SQFT ? parseInt(tenant.RR_SQFT) : 0;
                return {
                    ARCIMEDES_ROW_ID: x,
                    NAME: allTenantsById[x] ? allTenantsById[x].NAME : "",
                    SQFT: sqft,
                };
            })
            : [];
        response.sort((a, b) => (a.SQFT > b.SQFT ? -1 : 1));
        response.splice(defaultVisibleTenants, response.length - defaultVisibleTenants);
        response.forEach((el) => {
            delete el.SQFT;
        });
        return response;
    }

    setValue(updates) {
        this.setState({ data: { ...this.state.data, ...updates } });
    }

    async syncPropertyFieldsToUnderwriting(propertyId) {
        if (!propertyId) return;;

        const currentData = this.state.data;
        const isMT = currentData.TYPE === 'MT';
        const tableCode = isMT ? UNDERWRITING_MULTI_TENANT : UNDERWRITING_SINGLE_TENANT;

        try {
            const uwRes = await getData({
                tableCode,
                options: {
                    filterType: 'and',
                    filter: [
                        { text: String(propertyId), code: 'PROPERTY_ID', type: 'exact' },
                        { text: '', code: 'DELETED', type: 'null' },
                    ],
                },
            });

            const hasExisting = uwRes && uwRes.success && uwRes.data && uwRes.data.length;
            const mergedRow = hasExisting ? mergePropertySingletonRows(uwRes.data) : null;
            const updates = mergedRow && mergedRow.ARCIMEDES_ROW_ID
                ? { ARCIMEDES_ROW_ID: mergedRow.ARCIMEDES_ROW_ID }
                : { PROPERTY_ID: Number(propertyId) };

            updates[isMT ? 'CAD_LINK_1' : 'CAD_LINK'] = currentData.CAD_SITE || '';
            updates.LOT_SIZE = currentData.ACRES ? parseFloat(currentData.ACRES) : '';

            if (isMT) {
                const rawValue = currentData.ASSESSED_VALUE
                    ? parseFloat(String(currentData.ASSESSED_VALUE).replace(/,/g, ''))
                    : '';
                updates.CURRENT_TAX_APPRAISED_VALUE = rawValue;
            }

            await manageData({ tableCode, data: [updates] });
        } catch (err) {
            console.error('Error syncing property fields to underwriting:', err);
        }
    }

    setDataFromFinancials({ newData, savedTenants, newTenants }) {
        if (newData) newData = this.withLockedFieldsKept(newData);
        const state = {};
        if (newData)
            state.data = newData;
        if (newTenants && newTenants.length) {
            let tenants = this.state.allTenants || [];
            let tenantsById = this.state.allTenantsById || [];
            tenants = tenants.concat(newTenants);
            tenantsById = tenantsById.concat(newTenants);
            state.allTenants = tenants;
            state.allTenantsById = tenantsById;
        }
        if (newData || newTenants && newTenants.length) {
            this.setState(state);
            if (newData)
                this.checkCoordinatesAndSave(newData, this.state.original, savedTenants);
        }
    }

    async calculateGrossAmount() {
        this.setState({ recomputePayments: false });
        const data = this.state.data;
        const date = new Date(data && data.CLOSE_OF_ESCROW);
        const selectedYear = date.getFullYear();

        if (data.NET_FEE && selectedYear != 1970 && data.LISTING_AGENT_1) {
            let q = {
                AGENT_ID: data.LISTING_AGENT_1,
                YEAR: selectedYear,
                order: 'CLOSE_OF_ESCROW.asc'
            }

            const options = filter(q, 'agent-commission');

            Promise.all([
                executeQuery({ queryName: AGENT_COMMISSION_PROCURED, options }),
                executeQuery({ queryName: AGENT_COMMISSION_PAID, options })
            ]).then(res => {
                if (res && res[0] && res[0].success && Array.isArray(res[0].data) &&
                    res[1] && res[1].success && Array.isArray(res[1].data)) {
                    let grossCumulative = 0;
                    let netProcured = 0;
                    let prevProcuredCumulative = 0;
                    let netPaid = 0;
                    let currentTrenche = 0;
                    let insertionIndex = 0;
                    let paidData = removeDuplicateObjects(res[1].data.filter(property => property.MEMBER_ID === data.LISTING_AGENT_1));
                    let map = new Map();
                    res[0].data.forEach(item => {
                        map.set(item.ARCIMEDES_ROW_ID, item)
                    });
                    paidData.forEach(item => {
                        if (map.has(item.ARCIMEDES_ROW_ID)) {
                            let TEAM_MEMBER_GROSS_FEE = item.TEAM_MEMBER_GROSS_FEE;
                            map.set(item.ARCIMEDES_ROW_ID, { ...map.get(item.ARCIMEDES_ROW_ID), TEAM_MEMBER_GROSS_FEE });
                        } else {
                            map.set(item.ARCIMEDES_ROW_ID, item);
                        }
                    });
                    const mergedArray = Array.from(map.values());
                    mergedArray.sort(compareDates);

                    const newCloseDate = new Date(data.CLOSE_OF_ESCROW);
                    const index = mergedArray.findIndex(item => new Date(item.CLOSE_OF_ESCROW) > newCloseDate);
                    if (index === -1) {
                        insertionIndex = mergedArray.length - 1;
                    } else {
                        insertionIndex = index - 1;
                    }

                    mergedArray.forEach((agentObj, index) => {
                        const listingProcuredGrossFee = agentObj.LISTING_GROSS_COMMISSION ? parseFloat(agentObj.LISTING_GROSS_COMMISSION) : 0;
                        const buyingProcuredGrossFee = agentObj.BUYING_GROSS_COMMISSION ? parseFloat(agentObj.BUYING_GROSS_COMMISSION) : 0;
                        const totalProcuredGrossFee = listingProcuredGrossFee + buyingProcuredGrossFee;
                        let teamMemberGrossFee = agentObj.TEAM_MEMBER_GROSS_FEE ? parseFloat(agentObj.TEAM_MEMBER_GROSS_FEE) : 0;
                        grossCumulative += totalProcuredGrossFee;

                        if (grossCumulative <= 200000) {
                            netProcured += totalProcuredGrossFee * 0.5;
                            netPaid += teamMemberGrossFee * 0.5;
                        } else if (grossCumulative > 200000 && grossCumulative <= 400000) {
                            if (prevProcuredCumulative < 200000) {
                                if (teamMemberGrossFee >= (200000 - prevProcuredCumulative)) {
                                    netProcured += (200000 - prevProcuredCumulative) * 0.5 + (grossCumulative - 200000) * 0.55;
                                    netPaid += (200000 - prevProcuredCumulative) * 0.5 + (teamMemberGrossFee - (200000 - prevProcuredCumulative)) * 0.55;
                                } else {
                                    netProcured += (200000 - prevProcuredCumulative) * 0.5 + (grossCumulative - 200000) * 0.55;
                                    netPaid += (teamMemberGrossFee - (grossCumulative - 200000)) * 0.5 + (grossCumulative - 200000) * 0.55;
                                }
                            } else {
                                netProcured += totalProcuredGrossFee * 0.55;
                                netPaid += teamMemberGrossFee * 0.55;
                            }
                        } else if (grossCumulative > 400000 && grossCumulative <= 600000) {
                            if (prevProcuredCumulative < 400000) {
                                if (teamMemberGrossFee >= (400000 - prevProcuredCumulative)) {
                                    netProcured += (400000 - prevProcuredCumulative) * 0.55 + (grossCumulative - 400000) * 0.6;
                                    netPaid += (400000 - prevProcuredCumulative) * 0.55 + (teamMemberGrossFee - (400000 - prevProcuredCumulative)) * 0.6;
                                } else {
                                    netProcured += (400000 - prevProcuredCumulative) * 0.55 + (grossCumulative - 400000) * 0.6;
                                    netPaid += (teamMemberGrossFee - (grossCumulative - 400000)) * 0.55 + (grossCumulative - 400000) * 0.6;
                                }
                            } else {
                                netProcured += totalProcuredGrossFee * 0.6;
                                netPaid += teamMemberGrossFee * 0.6;
                            }
                        } else if (grossCumulative > 600000 && grossCumulative <= 800000) {
                            if (prevProcuredCumulative < 600000) {
                                if (teamMemberGrossFee >= (600000 - prevProcuredCumulative)) {
                                    netProcured += (600000 - prevProcuredCumulative) * 0.6 + (grossCumulative - 600000) * 0.65;
                                    netPaid += (600000 - prevProcuredCumulative) * 0.6 + (teamMemberGrossFee - (600000 - prevProcuredCumulative)) * 0.65;
                                } else {
                                    netProcured += (600000 - prevProcuredCumulative) * 0.6 + (grossCumulative - 600000) * 0.65;
                                    netPaid += (teamMemberGrossFee - (grossCumulative - 600000)) * 0.6 + (grossCumulative - 600000) * 0.65;
                                }
                            } else {
                                netProcured += totalProcuredGrossFee * 0.65;
                                netPaid += teamMemberGrossFee * 0.65;
                            }
                        } else if (grossCumulative > 800000) {
                            if (prevProcuredCumulative < 800000) {
                                if (teamMemberGrossFee >= (800000 - prevProcuredCumulative)) {
                                    netProcured += (800000 - prevProcuredCumulative) * 0.65 + (grossCumulative - 800000) * 0.7;
                                    netPaid += (800000 - prevProcuredCumulative) * 0.65 + (teamMemberGrossFee - (800000 - prevProcuredCumulative)) * 0.7;
                                } else {
                                    netProcured += (800000 - prevProcuredCumulative) * 0.65 + (grossCumulative - 800000) * 0.7;
                                    netPaid += (teamMemberGrossFee - (grossCumulative - 800000)) * 0.65 + (grossCumulative - 800000) * 0.7;
                                }
                            } else {
                                netProcured += totalProcuredGrossFee * 0.7;
                                netPaid += teamMemberGrossFee * 0.7;
                            }
                        }
                        prevProcuredCumulative = grossCumulative;
                        if (insertionIndex === index) {
                            currentTrenche = getCurrentTrancheOnGrossAmount(grossCumulative)
                            return 0;
                        }
                    });

                    // NET_FEE can be undefined on a blank Extra Payment property; guard
                    // so .replace() can't throw and hang the save.
                    const netFeeNum = parseFloat(String(data.NET_FEE == null ? '' : data.NET_FEE).replace(/,/g, '')) || 0;
                    data['TRANCHE'] = (currentTrenche * 100).toString();
                    data['REFERRAL_FEE'] = (netFeeNum / currentTrenche).toFixed(2);
                    this.setData('REFERRAL_FEE', (netFeeNum / currentTrenche).toFixed(2));
                    this.setState({
                        netFee: (netFeeNum).toFixed(2),
                        tranche: (currentTrenche * 100).toString(),
                        data: convertDataToForm(data)
                    });


                }

            });
        }


    }
    openFinancialsSpreadsheet() {
        // create new empty property and the fetch the id to pass it to the underwriting
        if (!this.state.data.ARCIMEDES_ROW_ID) {
            this.setState({ isBusy: true });
            const data = this.state.data;
            delete data.REFERRING_LISTING_AGENT;
            delete data.REFERRING_LISTING_AGENT_FIRM;
            delete data.REFERRING_LISTING_AGENT_PERCENT;
            delete data.REFERRING_BUYER_AGENT;
            delete data.REFERRING_BUYER_AGENT_FIRM;
            delete data.REFERRING_BUYER_AGENT_PERCENT;

            request(arc.path.api, {
                service: "arcimedes",
                action: "open.datasource.table.Data.updateByTableCode",
                params: [PROPERTIES, {
                    value: [data],
                },],
            }).then((res) => {
                if (res && res.success && Array.isArray(res.data) && res.data.length) {
                    const newData = this.state.data;
                    newData.ARCIMEDES_ROW_ID = res.data[0].ARCIMEDES_ROW_ID;
                    this.setState({
                        newPropertyId: res.data[0].ARCIMEDES_ROW_ID,
                        data: newData,
                        isBusy: null,
                        financialsSpreadsheetInView: true,
                    });
                } else {
                    this.setState({
                        isBusy: null,
                        error: res && res.message ? res.message : "Unspecified error",
                    });
                }
            });
        } else {
            this.setState({
                financialsSpreadsheetInView: true,
            });
        }
    }

    closeFinancialsSpreadsheet(notSaved, error) {
        this.setState({ financialsSpreadsheetInView: false });

        // delete the new empty property in case nothing was saved
        if (notSaved && this.state.newPropertyId) {
            this.setState({ isBusy: true });
            const data = this.state.data;
            data.ARCIMEDES_ROW_ID = this.state.newPropertyId;
            data.DELETED = "1";
            request(arc.path.api, {
                service: "arcimedes",
                action: "open.datasource.table.Data.updateByTableCode",
                params: [PROPERTIES, {
                    value: [data],
                },],
            }).then((res) => {
                if (res && res.success && Array.isArray(res.data) && res.data.length) {
                    data.DELETED = null;
                    this.setState({
                        data: data,
                        newPropertyId: null,
                        isBusy: null,
                    });
                } else {
                    this.setState({
                        isBusy: null,
                        error: res && res.message ? res.message : "Unspecified error",
                    });
                }
            });
        }
    }

    toggleDrawer() {
        this.setState((prevState) => ({ showDrawer: !prevState.showDrawer, resetDrawer: false }));
    }

    showHistoryDeleteModal(rowId) {
        this.setState({ showModal: true, historyDeleteRowId: rowId });
    }

    handleDeleteHistory(rowId) {
        const rowToUpdate = [{
            ARCIMEDES_ROW_ID: rowId,
            DELETED: 1
        }];
        this.setState({ showModal: false }, () => {
            manageData({ tableCode: PROPERTY_HISTORY, data: rowToUpdate }).then(res => {
                if (!res || !res.success) {
                    this.setState({
                        error: res && res.message ? res.message : "Unspecified error",
                    });
                } else {
                    let historyData = this.state.historyData;
                    let rowIndex;
                    historyData.forEach((el, index) => {
                        if (el.ARCIMEDES_ROW_ID === rowId)
                            rowIndex = index;
                    });
                    delete historyData[rowIndex];
                    this.setState({
                        historyData,
                        isBusy: null,
                        success: "History row deleted successfully",
                    });
                }
            });
        });
    }

    addNewItem(addNewItemType) {
        this.setState({ addNewItemType }, this.toggleDrawer);
    }

    savedNewItem(newData, newFirm) {
        // select the new item id & close drawer
        const key = this.state.addNewItemType;
        const state = {
            data: { ...this.state.data, [key]: newData.ARCIMEDES_ROW_ID },
        };
        switch (key) {
            case "SELLER_ID": {
                state.newSeller = newData;
                state.seller = {};

                if (state.newSeller.STATUS === 'Off-Market')
                    state.data.STATUS = 'Off Market';
                sellerKeys.forEach(key => {
                    state.seller[key] = newData[key];
                });
                break;
            }
            case "BUYER_ID":
                state.newBuyer = newData;
                break;
            case "LISTING_AGENT_4":
                state.newAgent = newData;
                if (newFirm) {
                    state.newFirm = newFirm;
                    state.data["LISTING_AGENT_4_FIRM"] = newData.FIRM;
                } else {
                    state.data["LISTING_AGENT_4_FIRM"] = newData.FIRM;
                }
                break;
            case "BUYER_AGENT_4":
                state.newAgent = newData;
                if (newFirm) {
                    state.newFirm = newFirm;
                    state.data["BUYER_AGENT_4_FIRM"] = newData.FIRM;
                } else {
                    state.data["BUYER_AGENT_4_FIRM"] = newData.FIRM;
                }
                break;
            case "REFERRED_BY_ID":
                state.newAgent = newData;
                state.data["REFERRED_BY_TYPE"] = 'oa';
                break;
            case "LISTING_AGENT_4_FIRM":
                state.newFirm = newData;
                break;
            case "BUYER_AGENT_4_FIRM":
                state.newFirm = newData;
                break;
            case "LENDER_ID":
                state.newLender = newData;
                // The new lender's own contact shows, not one picked for another bank.
                state.data.LENDER_CONTACT_ID = null;
                this.bankEditBase = null;
                break;
            case "REFERRING_LISTING_AGENT":
                state.newAgent = newData;
                if (newFirm) {
                    state.newFirm = newFirm;
                    state.data["REFERRING_LISTING_AGENT_FIRM"] = newData.FIRM;
                } else {
                    state.data["REFERRING_LISTING_AGENT_FIRM"] = newData.FIRM;
                }
                break;
            case "REFERRING_LISTING_AGENT_FIRM":
                state.newFirm = newData;
                break;
            case "REFERRING_BUYER_AGENT":
                state.newAgent = newData;
                if (newFirm) {
                    state.newFirm = newFirm;
                    state.data["REFERRING_BUYER_AGENT_FIRM"] = newData.FIRM;
                } else {
                    state.data["REFERRING_BUYER_AGENT_FIRM"] = newData.FIRM;
                }
                break;
            case "REFERRING_BUYER_AGENT_FIRM":
                state.newFirm = newData;
                break;
        }
        this.setState(state, () => this.toggleDrawer());
    }

    addNewOwner() {
        // browserHistory.push(`${arc.path.base}investor`);
        const CREATE_INVESTOR_URL = 'https://accounts.kore.co/crm/lead/new';
        window.open(CREATE_INVESTOR_URL, '_blank');
    }

    handleOwnersChange() {
        this.setState({ ownershipManuallyChanged: true });
    }

    syncInvestorProductTypes(propertyId, propertyCategory, propertyType) {
        if (!propertyId || !propertyCategory) {
            return Promise.resolve();
        }

        return axios.post('/api/crm/sync-investor-product-types', {
            propertyId,
            propertyCategory,
            propertyType: propertyType || null,
        }, { withCredentials: true }).catch((err) => {
            console.error('CRM investor product type sync failed on save', err && err.response ? err.response.data : err);
        });
    }

    addNewColumn(e) {
        if (this.isTabLocked('LOAN QUOTES')) return;
        let newColumn = {
            "AMORTIZATION": null,
            "BANK": null,
            "BANK_CONTACT": null,
            "CAP_RATE": null,
            "CASH_FLOW_ANNUALLY": null,
            "CASH_FLOW_MONTHLY": null,
            "CASH_ON_CASH": null,
            "DEBT_YIELD": null,
            "DELETED": null,
            "DOWN_PAYMENT": null,
            "DOWN_PAYMENT_PERCENT": null,
            "DSCR": null,
            "INTEREST_RATE": null,
            "LOAN_AMOUNT": null,
            "LOAN_PAYMENT_ANNUALLY": null,
            "LOAN_PAYMENT_MONTHLY": null,
            "LOAN_STRUCTURE": null,
            "LOAN_TERM": null,
            "MATURITY": null,
            "NOI": null,
            "NOI_MULTIPLIED": null,
            "NOI_PERCENTAGE": null,
            "NOTES": null,
            "PREPAYMENT_PENALTY": null,
            "PROPERTY_ID": this.state.data.ARCIMEDES_ROW_ID,
            "PURCHASE_PRICE": null,
            "RECOURSE": null,
            "TOTAL_ORIGINATION_FEE": null,
            "ARCIMEDES_MODIFIED_BY": this.props.userData.id,
            "PRINT_PAGE_NUMBER": "1",
            "IS_PRINTABLE": false,
            "AUTOPOPULATE": 0,
        }
        this.setState({
            loanQuotesData: [...this.state.loanQuotesData, newColumn]
        })
    }
    updateColumns(updatedColumns) {
        this.setState({ loanQuotesData: updatedColumns });
    };

    /**
     * Copy one loan quote — the copy button on the tab.
     *
     * Most quotes on a property differ by a row or two, so the copy lands
     * directly to the right of the quote it came from carrying every value,
     * ready for those edits. It is a new row, not a second view of the old one:
     * no ARCIMEDES_ROW_ID, so the save inserts it. Approved does not come
     * across — a property has at most one approved quote.
     */
    duplicateLoanQuoteColumn(columnIndex) {
        if (this.isTabLocked('LOAN QUOTES')) return;
        const columns = [...(this.state.loanQuotesData || [])];
        const source = columns[columnIndex];

        if (!source) {
            return;
        }

        const copy = { ...source, LOAN_QUOTES_MODIFIED: true, APPROVED: null };

        // The copy is its own row, and the save stamps its own audit trail.
        delete copy.ARCIMEDES_ROW_ID;
        delete copy.ARCIMEDES_CREATED;
        delete copy.ARCIMEDES_CREATED_BY;
        delete copy.ARCIMEDES_MODIFIED;
        delete copy.ARCIMEDES_MODIFIED_BY;
        delete copy.DELETED;

        copy.PROPERTY_ID = source.PROPERTY_ID
            || (this.state.data && this.state.data.ARCIMEDES_ROW_ID)
            || this.props.params.id;

        columns.splice(columnIndex + 1, 0, copy);

        this.setState({ loanQuotesData: reorderLoanQuotes(columns) });
    }

    /**
     * Delete one loan quote — the trash button on the tab, behind a confirm.
     *
     * The column goes right away; a saved quote's row is soft-deleted with the
     * rest of the save (it goes out with DELETED = 1), so leaving edit mode
     * without saving still leaves the quote where it was. The quotes after it
     * close the gap, so the stored LOAN_QUOTES_ORDER keeps matching the tab.
     */
    deleteLoanQuoteColumn(columnIndex) {
        if (this.isTabLocked('LOAN QUOTES')) return;
        const columns = [...(this.state.loanQuotesData || [])];

        if (columnIndex < 0 || columnIndex >= columns.length) {
            return;
        }

        const [removed] = columns.splice(columnIndex, 1);
        const reshuffled = reorderLoanQuotes(columns);

        const deletedLoanQuotesData = [...(this.state.deletedLoanQuotesData || [])];

        if (removed && removed.ARCIMEDES_ROW_ID) {
            deletedLoanQuotesData.push({
                ARCIMEDES_ROW_ID: removed.ARCIMEDES_ROW_ID,
                DELETED: '1',
            });
        }

        this.setState({ loanQuotesData: reshuffled, deletedLoanQuotesData });

        // Loan Info mirrors the approved quote; deleting that quote leaves
        // nothing to mirror, same as un-approving it.
        if (removed && String(removed.APPROVED).toLowerCase() === 'yes') {
            this.clearApprovedLoanInfo();
        }
    }

    /**
     * Cancelling the edit puts the deleted columns back on the tab (CRUD restores
     * loanQuotesData from originalLoanQuotesData), so the deletes waiting on a
     * save have to go with them — otherwise the next save would delete a quote
     * the user had just restored.
     */
    discardPendingLoanQuoteDeletes() {
        if (this.state.deletedLoanQuotesData && this.state.deletedLoanQuotesData.length) {
            this.setState({ deletedLoanQuotesData: [] });
        }
    }

    handleAddLoanNote(newNote) {
        const updatedNotes = [...this.state.loanNotesData, newNote];
        this.setState({ loanNotesData: updatedNotes });
    }

    handleDeleteLoanNote(noteId) {
        const updatedNotes = this.state.loanNotesData.map(note => {
            if (note.ARCIMEDES_ROW_ID === noteId) {
                return { ...note, DELETED: '1' };
            }
            return note;
        });
        this.setState({ loanNotesData: updatedNotes });
    }

    handleEditLoanNote(updatedNote, index) {
        const updatedNotes = this.state.loanNotesData.map((note, i) => {
            if (note.ARCIMEDES_ROW_ID && note.ARCIMEDES_ROW_ID === updatedNote.ARCIMEDES_ROW_ID) {
                return { ...updatedNote, MODIFIED: true };
            } else if (!note.ARCIMEDES_ROW_ID && i === index) {
                return { ...updatedNote, MODIFIED: true };
            }
            return note;
        });
        this.setState({ loanNotesData: updatedNotes });
    }



    getDrawerComponent() {
        const component = this.state.addNewItemType;
        const resetDrawer = this.state.resetDrawer;
        switch (component) {
            case "SELLER_ID":
                return (
                    <SellerDrawer
                        savedNewItem={this.savedNewItem}
                        closeDrawer={this.closeDrawer}
                        resetDrawer={resetDrawer}
                    />
                );
            case "BUYER_ID":
                return (
                    <BuyerDrawer
                        savedNewItem={this.savedNewItem}
                        closeDrawer={this.closeDrawer}
                        resetDrawer={resetDrawer}
                    />
                );
            case "LISTING_AGENT_4":
            case "BUYER_AGENT_4":
            case "REFERRING_LISTING_AGENT":
            case "REFERRING_BUYER_AGENT":
            case "REFERRED_BY_ID":
                return (
                    <AgentDrawer
                        savedNewItem={this.savedNewItem}
                        closeDrawer={this.closeDrawer}
                        resetDrawer={resetDrawer}
                    />
                );
            case "LISTING_AGENT_4_FIRM":
            case "BUYER_AGENT_4_FIRM":
                return (
                    <FirmDrawer
                        savedNewItem={this.savedNewItem}
                        closeDrawer={this.closeDrawer}
                        resetDrawer={resetDrawer}
                    />
                );
            case "REFERRING_LISTING_AGENT_FIRM":
                return (
                    <FirmDrawer
                        savedNewItem={this.savedNewItem}
                        closeDrawer={this.closeDrawer}
                        resetDrawer={resetDrawer}
                    />
                );
            case "REFERRING_BUYER_AGENT_FIRM":
                return (
                    <FirmDrawer
                        savedNewItem={this.savedNewItem}
                        closeDrawer={this.closeDrawer}
                        resetDrawer={resetDrawer}
                    />
                );
            case "LENDER_ID":
                return (
                    <LenderDrawer
                        savedNewItem={this.savedNewItem}
                        closeDrawer={this.closeDrawer}
                        resetDrawer={resetDrawer}
                    />
                );
        }
    }

    redirectToEscrowTracking() {
        const id = this.state.data.ARCIMEDES_ROW_ID;
        browserHistory.push({
            pathname: `${arc.path.base}escrow-tracking/${id}`,
            state: id
        });
    }

    redirectToHscTracking() {
        const id = this.state.data.ARCIMEDES_ROW_ID;
        browserHistory.push({
            pathname: `${arc.path.base}tracking/${id}`,
            state: id
        });
    }

    handleConfirmEscrow() {
        this.setState({ openEscrowDialog: false });
        this.setState({ viewMode: false })
    }

    handleEscrowDateError() {
        this.setState({ openEscrowDateError: false });
        this.setState({ viewMode: false })
    }

    isCurrentUserPeakTeamMember1(propertyData = this.state.data) {
        return isPeakTeamMember1(
            this.props.userData && this.props.userData.email,
            propertyData && propertyData.HSC_TEAM_MEMBER_1
        );
    }

    /**
     * What the signed-in member's access level keeps them from changing on
     * this record (access-levels.js). Worked out from the record as loaded, so
     * an edit to STATUS cannot lift a limit that depends on it.
     */
    getEditLocks() {
        return getPropertyEditLocks(getCurrentAccess(), this.props.edit ? this.state.original : null);
    }

    /** True when a whole tab (or the record) is closed to the signed-in member. */
    isTabLocked(tabName) {
        const locks = this.getEditLocks();
        return locks.readOnly || !!locks.readOnlyTabs[tabName];
    }

    /**
     * A member limited to their own SUMMIT deals (editsOwnSummitDealsOnly) may
     * edit a SUMMIT record they are a listing or buyer agent on, within the
     * field limits; the generic rule in CRUD.js only opens Proposal and
     * Property Info records to them.
     */
    canSeniorAgentEdit() {
        const locks = this.getEditLocks();
        return editsOwnSummitDealsOnly(getCurrentAccess()) && !!this.props.edit && !locks.readOnly
            && isAgentOnProperty(this.props.userData && this.props.userData.id, this.state.original);
    }

    getTabs({ data, loanQuotesData, seller, edit, isReferral, isFinancing, isStriveFinancing, isStriveClosed, isOtherFinancing, ownDealsOnly, isExtraPayment }) {
        // Loan Info's Lender Contact shows the approved loan quote's contact when
        // present; otherwise it falls back to the lender record's contact name.
        const approvedLoanQuote = (loanQuotesData || []).find(
            (q) => q && String(q.APPROVED).toLowerCase() === 'yes'
        );
        const lenderContactOverride = approvedLoanQuote ? approvedLoanQuote.BANK_CONTACT : '';

        let tabs = [{

            name: "PROPERTY",
            renderedComponent: (
                <PropertyInfo
                    showLoanBids
                    data={data}
                    account={this.state.account.value}
                    handleChangeDropdown={this.handleChangeDropdown}
                    handleChangeInput={this.handleChangeInput}
                    handleChangeFile={this.handleChangeFile}
                    getTenantsForTags={this.getTenantsForTags}
                    viewMode={this.state.viewMode}
                    deleted={data && data.DELETED === "1"}
                    isReferral={isReferral}
                    isFinancing={isFinancing}
                    isStriveFinancing={isStriveFinancing}
                    redirectToHscTracking={this.redirectToHscTracking}
                    ownDealsOnly={ownDealsOnly}
                    isExtraPayment={isExtraPayment}
                    onShowNotes={() => this.setState({ propertyNotesModalOpen: true })}
                    notes={[...this.state.pendingNotes, ...this.state.notes]}
                    zipLoading={this.state.zipLoading}
                />
            ),
        }];

        // Extra Payment records have no investors/ownership — hide the tab.
        if (!isExtraPayment) {
            tabs.push({
                name: "INVESTORS",
                // A parcel still waiting to be added has no ownership rows to
                // read or write, so the real tab would be blank and inert.
                renderedComponent: this.parcelHandoff ? (
                    <PendingOwnerNotice owner={this.parcelHandoff.owner} token={this.parcelHandoffToken} />
                ) : (
                    <OwnershipInfo
                        data={data}
                        propertyId={data && data.ARCIMEDES_ROW_ID}
                        handleOwnersChange={this.handleOwnersChange}
                        viewMode={this.state.viewMode}
                        deleted={data && data.DELETED === "1"}
                        addNewItem={this.addNewOwner}
                        isNeedOwner={this.state.isNeedOwner}
                        onNeedOwnerChange={(val) => this.setState({ isNeedOwner: val })}
                        isResearched={this.state.isResearched}
                        onResearchedChange={(val) => this.setState({ isResearched: val })}
                    />
                ),
            });
        }

        if (isFinancing) {
            tabs.push({
                name: "FINANCIALS",
                renderedComponent: (
                    <PropertyFinancials
                        data={data}
                        handleChangeInput={this.handleChangeInput}
                        openFinancialsSpreadsheet={this.openFinancialsSpreadsheet}
                        viewMode={this.state.viewMode}
                        deleted={data && data.DELETED === "1"}
                        isFinancing
                    />
                ),
            }, {
                name: "LOAN QUOTES",
                className: 'loan-quotes',
                renderedComponent: (
                    <LoanQuotes
                        printTitle={data && `${data.NAME} - ${data.CITY}, ${data.STATE}`}
                        data={loanQuotesData}
                        NOIPercent={data && data.NOI_PERCENT}
                        negotiationPrice={data && data.NEGOTIATION_PRICE}
                        handleChangeInput={this.handleLoanQuotesChangeInput}
                        handleChangeDropdown={this.handleLoanQuotesChangeDropdown}
                        handlePrintPagesDropDown={this.handlePrintPagesDropDown}
                        viewMode={this.state.viewMode}
                        deleted={data && data.DELETED === "1"}
                        hscTeamMemberIds={!!data ? hscTeamMembers.find((e) => e.EMAIL === data['HSC_TEAM_MEMBER_1']) : { EMAIL: '' }}
                        addNewColumn={this.addNewColumn}
                        updateColumns={this.updateColumns}
                        toggleAllColumns={this.toggleAllLoanQuoteColumns}
                        duplicateColumn={this.duplicateLoanQuoteColumn}
                        deleteColumn={this.deleteLoanQuoteColumn}
                        LoanType={data && data.LOAN_TYPE}
                    />
                ),
            }, {
                name: "LOAN INFO",
                renderedComponent: (
                    <Loan
                        isTeamMember={this.isCurrentUserPeakTeamMember1(data)}
                        data={data}
                        handleChangeDropdown={this.handleChangeDropdown}
                        handleChangeInput={this.handleChangeInput}
                        handleInputBlur={this.handleInputBlur}
                        handleChangeFile={this.handleChangeFile}
                        addNewItem={this.addNewItem}
                        openHscPayments={this.openHscPayments}
                        displayedAgentsNr={this.state.displayedHSCAgents}
                        addHscMember={this.addHscMember}
                        hscTeamMembers={hscAgentsKeys.map((key) => data[key])}
                        newLender={this.state.newLender}
                        newAgent={this.state.newAgent}
                        viewMode={this.state.viewMode}
                        deleted={data && data.DELETED === "1"}
                        loanNotes={this.state.loanNotesData}
                        currentUser={this.state.currentUser}
                        onAddLoanNote={this.handleAddLoanNote}
                        onDeleteLoanNote={this.handleDeleteLoanNote}
                        onEditLoanNote={this.handleEditLoanNote}
                        lenderContactOverride={lenderContactOverride}
                        loanQuotes={loanQuotesData}
                    />
                ),
            }, {
                name: "SALE INFO",
                renderedComponent: (
                    <SaleInformation
                        data={data}
                        handleChangeInput={this.handleChangeInput}
                        handleInputBlur={this.handleInputBlur}
                        handleChangeDropdown={this.handleChangeDropdown}
                        handleChangeFile={this.handleChangeFile}
                        viewMode={this.state.viewMode}
                        deleted={data && data.DELETED === "1"}
                        isFinancing
                    />
                ),
            });
            if (!(data.LOAN_TYPE === "Refi" || data.LOAN_TYPE === "Construction")) {
                tabs.push({
                    name: "BUYSIDE AGENT",
                    renderedComponent: (
                        <BuysideAgent
                            data={data}
                            handleChangeDropdown={this.handleChangeDropdown}
                            handleChangeInput={this.handleChangeInput}
                            addNewItem={this.addNewItem}
                            newAgent={this.state.newAgent}
                            newBuyer={this.state.newBuyer}
                            newFirm={this.state.newFirm}
                            viewMode={this.state.viewMode}
                            deleted={data && data.DELETED === "1"}
                            isFinancing
                        />
                    ),
                }, {
                    name: "LISTING AGENT",
                    renderedComponent: (
                        <ListingAgent
                            data={data}
                            handleChangeDropdown={this.handleChangeDropdown}
                            handleChangeInput={this.handleChangeInput}
                            addNewItem={this.addNewItem}
                            newAgent={this.state.newAgent}
                            newFirm={this.state.newFirm}
                            viewMode={this.state.viewMode}
                            deleted={data && data.DELETED === "1"}
                            userData={this.props.userData}
                        />
                    ),
                })
            }
        } else if (isReferral) {
            tabs.push({
                name: "SALE INFO",
                renderedComponent: (
                    <SaleInformation
                        data={data}
                        handleChangeInput={this.handleChangeInput}
                        handleInputBlur={this.handleInputBlur}
                        handleChangeDropdown={this.handleChangeDropdown}
                        handleChangeFile={this.handleChangeFile}
                        viewMode={this.state.viewMode}
                        deleted={data && data.DELETED === "1"}
                        isReferral
                    />
                ),
            })
            if (data.ARCIMEDES_ROW_ID && data.CLOSE_OF_ESCROW)
                tabs.push({
                    name: "PAYMENT",
                    renderedComponent: (
                        <PropertyPayments
                            paymentsData={this.state.propertyPaymentsData}
                            propertyData={data}
                            handleAddMember={this.handleAddMember}
                            handleChangeDropdown={this.handlePaymentsChangeDropdown}
                            handleChangeInput={this.setPaymentsData}
                            viewMode={this.state.viewMode}
                            deleted={data && data.DELETED === "1"}
                            isReferral
                        />
                    ),
                });

        } else if (isExtraPayment) {
            tabs.push({
                name: "SALE INFO",
                renderedComponent: (
                    <SaleInformation
                        data={data}
                        handleChangeInput={this.handleChangeInput}
                        handleInputBlur={this.handleInputBlur}
                        handleChangeDropdown={this.handleChangeDropdown}
                        handleChangeFile={this.handleChangeFile}
                        viewMode={this.state.viewMode}
                        deleted={data && data.DELETED === "1"}
                        isExtraPayment
                        calculateGrossAmount={this.calculateGrossAmount}
                    />
                ),
            })
        } else {
            tabs.push({
                name: "LISTING AGENT",
                renderedComponent: (
                    <ListingAgent
                        setParentState={this.setState.bind(this)}
                        data={data}
                        handleChangeDropdown={this.handleChangeDropdown}
                        handleChangeInput={this.handleChangeInput}
                        addNewItem={this.addNewItem}
                        newAgent={this.state.newAgent}
                        newFirm={this.state.newFirm}
                        viewMode={this.state.viewMode}
                        deleted={data && data.DELETED === "1"}
                        userData={this.props.userData}
                    />
                ),
            },
                {
                    name: "PROPOSAL",
                    renderedComponent: (
                        <Proposal
                            data={this.state.proposalData}
                            handleChangeInput={this.handleChangeInput}
                            viewMode={this.state.viewMode}
                            deleted={data && data.DELETED === "1"}
                            onRefreshDefaults={this.handleRefreshProposalDefaults}
                            canRefreshDefaults={!!this.state.standardTextConfig}
                        />
                    ),
                },
                {
                    name: "REP AGREEMENT",
                    renderedComponent: (
                        <RepresentationAgreement
                            data={data}
                            handleChangeInput={this.handleChangeInput}
                            handleChangeFile={this.handleChangeFile}
                            viewMode={this.state.viewMode}
                            deleted={data && data.DELETED === "1"}
                        />
                    ),
                }, {
                name: "FINANCIALS",
                renderedComponent: (
                    <PropertyFinancials
                        data={data}
                        handleChangeInput={this.handleChangeInput}
                        openFinancialsSpreadsheet={this.openFinancialsSpreadsheet}
                        viewMode={this.state.viewMode}
                        deleted={data && data.DELETED === "1"}
                    />
                ),
            }, {
                name: "IN NEG/UNDER CONTRACT",
                renderedComponent: (
                    <InNegotiationUnderContract
                        showLoanBids
                        data={data}
                        agentList={this.state.agentList}
                        handleChangeInput={this.handleChangeInput}
                        handleChangeDropdown={this.handleChangeDropdown}
                        handleChangeFile={this.handleChangeFile}
                        redirectToEscrowTracking={this.redirectToEscrowTracking}
                        viewMode={this.state.viewMode}
                        deleted={data && data.DELETED === "1"}
                        isStriveFinancing={isStriveFinancing}
                    />
                ),
            }, {
                name: "BUYSIDE AGENT",
                renderedComponent: (
                    <BuysideAgent
                        data={data}
                        handleChangeDropdown={this.handleChangeDropdown}
                        handleChangeInput={this.handleChangeInput}
                        addNewItem={this.addNewItem}
                        newAgent={this.state.newAgent}
                        newBuyer={this.state.newBuyer}
                        newFirm={this.state.newFirm}
                        viewMode={this.state.viewMode}
                        deleted={data && data.DELETED === "1"}
                    />
                ),
            }, {
                name: "SALE INFO",
                renderedComponent: (
                    <SaleInformation
                        ownDealsOnly={ownDealsOnly}
                        data={data}
                        handleChangeInput={this.handleChangeInput}
                        handleInputBlur={this.handleInputBlur}
                        handleChangeDropdown={this.handleChangeDropdown}
                        handleChangeFile={this.handleChangeFile}
                        viewMode={this.state.viewMode}
                        deleted={data && data.DELETED === "1"}
                        isStriveFinancing={isStriveFinancing}
                    />
                ),
            });

            if (isStriveFinancing)
                tabs.push(
                    {
                        name: "LOAN QUOTES",
                        className: 'loan-quotes',
                        renderedComponent: (
                            <LoanQuotes
                                printTitle={data && `${data.NAME} - ${data.CITY}, ${data.STATE}`}
                                data={loanQuotesData}
                                NOIPercent={data && data.NOI_PERCENT}
                                LoanType={data && data.LOAN_TYPE}
                                negotiationPrice={data && data.NEGOTIATION_PRICE}
                                handleChangeInput={this.handleLoanQuotesChangeInput}
                                handleChangeDropdown={this.handleLoanQuotesChangeDropdown}
                                handlePrintPagesDropDown={this.handlePrintPagesDropDown}
                                viewMode={this.state.viewMode}
                                deleted={data && data.DELETED === "1"}
                                hscTeamMemberIds={hscAgentsKeys.map(key => data[key])}
                                addNewColumn={this.addNewColumn}
                                updateColumns={this.updateColumns}
                                toggleAllColumns={this.toggleAllLoanQuoteColumns}
                                duplicateColumn={this.duplicateLoanQuoteColumn}
                                deleteColumn={this.deleteLoanQuoteColumn}
                            />
                        ),
                    }, {
                    name: "LOAN INFO",
                    renderedComponent: (
                        <Loan
                            isTeamMember={this.isCurrentUserPeakTeamMember1(data)}
                            data={data}
                            handleChangeDropdown={this.handleChangeDropdown}
                            handleChangeInput={this.handleChangeInput}
                            handleInputBlur={this.handleInputBlur}
                            handleChangeFile={this.handleChangeFile}
                            displayedAgentsNr={this.state.displayedHSCAgents}
                            addHscMember={this.addHscMember}
                            addNewItem={this.addNewItem}
                            openHscPayments={this.openHscPayments}
                            hscTeamMembers={hscAgentsKeys.map(key => data[key])}
                            newLender={this.state.newLender}
                            newAgent={this.state.newAgent}
                            viewMode={this.state.viewMode}
                            deleted={data && data.DELETED === "1"}
                            loanNotes={this.state.loanNotesData}
                            currentUser={this.state.currentUser}
                            onAddLoanNote={this.handleAddLoanNote}
                            onDeleteLoanNote={this.handleDeleteLoanNote}
                            onEditLoanNote={this.handleEditLoanNote}
                            lenderContactOverride={lenderContactOverride}
                            loanQuotes={loanQuotesData}
                        />
                    ),
                });

            if (isOtherFinancing)
                tabs.push({
                    name: "LOAN INFO",
                    renderedComponent: (
                        <Loan
                            isTeamMember={this.isCurrentUserPeakTeamMember1(data)}
                            data={data}
                            handleChangeDropdown={this.handleChangeDropdown}
                            handleChangeInput={this.handleChangeInput}
                            handleInputBlur={this.handleInputBlur}
                            handleChangeFile={this.handleChangeFile}
                            displayedAgentsNr={this.state.displayedHSCAgents}
                            addHscMember={this.addHscMember}
                            addNewItem={this.addNewItem}
                            openHscPayments={this.openHscPayments}
                            hscTeamMembers={hscAgentsKeys.map(key => data[key])}
                            newLender={this.state.newLender}
                            newAgent={this.state.newAgent}
                            viewMode={this.state.viewMode}
                            deleted={data && data.DELETED === "1"}
                            loanNotes={this.state.loanNotesData}
                            currentUser={this.state.currentUser}
                            onAddLoanNote={this.handleAddLoanNote}
                            onDeleteLoanNote={this.handleDeleteLoanNote}
                            onEditLoanNote={this.handleEditLoanNote}
                            lenderContactOverride={lenderContactOverride}
                            loanQuotes={loanQuotesData}
                        />
                    ),
                });
            if (!isFinancing) {
                tabs.push({
                    name: "HISTORY",
                    className: 'property-history',
                    renderedComponent: (
                        <PropertyHistory
                            query={this.props.location.query}
                            data={this.state.historyData}
                            deleted={data && data.DELETED === "1"}
                            handleDeleteHistory={this.showHistoryDeleteModal}
                            handleShowHistoryTab={this.openHistoryTabView}
                            viewMode={this.state.viewMode}
                        />
                    )
                })
            }

            tabs.push({
                name: "WEBSITE",
                renderedComponent: (
                    <Website
                        data={data}
                        handleChangeInput={this.handleChangeInput}
                        handleChangeFile={this.handleChangeFile}
                        viewMode={this.state.viewMode}
                        deleted={data && data.DELETED === "1"}
                    />
                ),
            });

            if ((isStriveClosed || (data && data.BUYER_AGENT_4_FIRM == buyer_agent4_firmvalue && data.SOURCE == "External" && data.STATUS == "Closed")) && data.ARCIMEDES_ROW_ID)
                tabs.push({
                    name: "PAYMENT",
                    renderedComponent: (
                        <PropertyPayments
                            paymentsData={this.state.propertyPaymentsData}
                            propertyData={data}
                            handleAddMember={this.handleAddMember}
                            handleChangeDropdown={this.handlePaymentsChangeDropdown}
                            handleChangeInput={this.setPaymentsData}
                            viewMode={this.state.viewMode}
                            deleted={data && data.DELETED === "1"}
                        />
                    ),
                });
        }
        const locks = this.getEditLocks();
        if (ownDealsOnly && (data && data.SOURCE == "External")) {
            const _tabs = ["PROPERTY", "FINANCIALS", "SALE INFO", "PROPOSAL", "LISTING AGENT", "BUYSIDE AGENT"];
            tabs = tabs.filter((e) => _tabs.indexOf(e.name) >= 0);
        }
        else if (ownDealsOnly && (data && data.SOURCE == "SUMMIT")) {
            // The Senior Agent access level also sees Rep Agreement, In Neg/Under
            // Contract and Website, with the fields it may not change locked.
            const _tabs = ["PROPERTY", "FINANCIALS", "SALE INFO", "PROPOSAL", "LISTING AGENT", "BUYSIDE AGENT", "PAYMENT"].concat(locks.extraTabs)
            tabs = tabs.filter((e) => _tabs.indexOf(e.name) >= 0);
        }
        else if (ownDealsOnly) {
            const _tabs = ["PROPERTY", "FINANCIALS", "SALE INFO", "PROPOSAL"]
            tabs = tabs.filter((e) => _tabs.indexOf(e.name) >= 0);
        }
        // A property's Proposal tab is Proposals (spec §10.2): hidden without
        // them, read-only when the level only views them.
        if (!can('proposals', 'view')) {
            tabs = tabs.filter((tab) => tab.name !== 'PROPOSAL');
        }
        const proposalReadOnly = !can('proposals', 'edit');

        // Every tab learns which of its fields are locked; a tab closed to the
        // member as a whole is shown in view mode.
        return tabs.map((tab) => {
            if (!tab.renderedComponent) return tab;
            const extraProps = { locks };
            if (locks.readOnlyTabs[tab.name]) extraProps.viewMode = true;
            if (tab.name === 'PROPOSAL' && proposalReadOnly) extraProps.viewMode = true;
            return { ...tab, renderedComponent: React.cloneElement(tab.renderedComponent, extraProps) };
        });
    }

    onConfirm() {
        this.setState({ isDialogueOpen: false });
        if (this.state.data.STATUS === 'Active' && this.state.original.STATUS !== 'Active') {
            this.clearBuysideAgentFieldsAndUnderContratPrice();
        }
        if (this.state.original.STATUS === 'Closed' && !['Closed', 'Removed', 'Off Market', 'Property Info'].includes(this.state.data.STATUS)) {
            this.clearSaleInfoFields();
            this.clearBuysideAgentFields();
        }
        const data = this.state.data;
        const original = this.state.original;
        this.setState({ viewMode: true, isBusy: true }, () =>
            this.checkCoordinatesAndSave(data, original)
        );
    }
    onCancel() {
        this.setState({ isDialogueOpen: false, isBusy: false });
    }

    render() {
        const { data, seller, loanQuotesData, recomputePayments, viewMode } = this.state;
        const everySummit = editsEverySummitRecord(getCurrentAccess());
        const ownDealsOnly = editsOwnSummitDealsOnly(getCurrentAccess());
        const email = this.props.userData ? this.props.userData.email : "";
        const { edit } = this.props;
        const isReferral = data && data.TRANSACTION_TYPE === 'Referral';
        const isFinancing = data && data.SOURCE === 'HSC';
        const isStriveFinancing = data && data.HSC_FINANCING;
        const isStriveClosed = data && data.SOURCE === 'SUMMIT' && data.STATUS === 'Closed';
        const isOtherFinancing = data && data.OTHER_FINANCING;
        const isExtraPayment = data && data.TRANSACTION_TYPE === 'Extra Payment';
        const locks = this.getEditLocks();

        return (
            <React.Fragment>
                <PopupDialog
                    title={'Do you have an Amendment to the Rep Agreement to change the price?'}
                    isOpen={this.state.isDialogueOpen}
                    onConfirm={() => { this.onConfirm() }}
                    onCancel={() => { this.onCancel() }}
                />
                <Modal show={this.state.showModal} onClose={() => this.setState({ showModal: false, historyDeleteRowId: null })}>
                    <div className="modal-content">
                        <span className='modal-title'> Are you sure you want to delete this data </span>
                        <div className="modal-buttons">
                            <button className='button-new positive' onClick={() => this.handleDeleteHistory(this.state.historyDeleteRowId)}>Yes, Delete</button>
                            <button className='button-new negative' onClick={() => this.setState({ showModal: false, historyDeleteRowId: null })}>Cancel</button>
                        </div>
                    </div>
                </Modal>
                <Modal className='territory-select-modal' show={this.state.showTerritoryModal} onClose={() => this.setState({ showTerritoryModal: false, territoryOptions: [] })}>
                    <div className="modal-content" style={{ padding: '24px', width: '100%', boxSizing: 'border-box' }}>
                        <div style={{ fontSize: '16px', fontWeight: 600, color: '#2c3e50', marginBottom: '6px', textAlign: 'left' }}>
                            Select Territory
                        </div>
                        <div style={{ fontSize: '13px', color: '#7f8c8d', marginBottom: '18px', textAlign: 'left' }}>
                            Multiple matches found for this ZIP. Choose one:
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '18px', width: '100%' }}>
                            {this.state.territoryOptions.map((opt, i) => (
                                <div
                                    key={i}
                                    onClick={() => this.selectTerritoryOption(opt)}
                                    style={{
                                        padding: '12px 14px',
                                        border: '1px solid #dfe4ea',
                                        borderRadius: '6px',
                                        cursor: 'pointer',
                                        background: '#fff',
                                        transition: 'all 0.15s ease',
                                        width: '100%',
                                        boxSizing: 'border-box',
                                        textAlign: 'left',
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.borderColor = '#3498db';
                                        e.currentTarget.style.background = '#f5fafd';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.borderColor = '#dfe4ea';
                                        e.currentTarget.style.background = '#fff';
                                    }}
                                >
                                    <div style={{ fontSize: '14px', fontWeight: 600, color: '#2c3e50' }}>
                                        {opt.CITY || '-'}, {opt.MARKET_CODE || 'Other'}
                                    </div>
                                    {opt.COUNTY && (
                                        <div style={{ fontSize: '12px', color: '#95a5a6', marginTop: '2px' }}>
                                            {opt.COUNTY}
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                        <div style={{ textAlign: 'right', width: '100%' }}>
                            <button
                                style={{
                                    padding: '6px 16px',
                                    background: '#fff',
                                    border: '1px solid #cfd8dc',
                                    borderRadius: '4px',
                                    color: '#546e7a',
                                    fontSize: '13px',
                                    cursor: 'pointer',
                                }}
                                onClick={() => this.setState({ showTerritoryModal: false, territoryOptions: [] })}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </Modal>
                <Modal className='hsc-payments' show={this.state.showHscModal} onClose={() => this.setState({ showHscModal: false })}>
                    <div className='hsc-modal'>
                        <span className='green-title'> PEAK Payments </span>
                        <div className='close-button' onClick={() => this.setState({ showHscModal: false })} />
                    </div>
                    <div className='hsc-modal-content'>
                        <PropertyPayments
                            propertyData={data}
                            handleChangeDropdown={this.handleHscPaymentsChangeDropdown}
                            handleChangeInput={this.handleHscPaymentsChangeInput}
                            deleted={data && data.DELETED === "1"}
                            viewMode={viewMode || locks.readOnly || locks.peakPaymentsReadOnly}
                            isHsc
                        />
                    </div>
                </Modal>
                <PropertyNotesModal
                    show={this.state.propertyNotesModalOpen}
                    onClose={() => this.setState({ propertyNotesModalOpen: false })}
                    propertyId={data && data.ARCIMEDES_ROW_ID}
                    currentUser={this.state.currentUser}
                    notes={[...this.state.pendingNotes, ...this.state.notes]}
                    fetchNotes={this.fetchNotes}
                    onAddPendingNote={this.handleAddPendingNote}
                    onEditPendingNote={this.handleEditPendingNote}
                    onDeletePendingNote={this.handleDeletePendingNote}
                />
                <Dialog
                    open={this.state.openEscrowDialog}
                    onClose={this.handleCloseOfEscrow}
                    fullWidth
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle>
                        Please, Enter a Close of Escrow Date in Sale Info Tab !!!
                    </DialogTitle>
                    <DialogActions>
                        <Button onClick={this.handleConfirmEscrow.bind(this)} color="primary" autoFocus>
                            Ok
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={this.state.openEscrowDateError}
                    fullWidth
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >

                    <DialogTitle>
                        Invalid Close of Escrow date format. Please use MM/DD/YYYY.
                    </DialogTitle>
                    <DialogActions>
                        <Button onClick={this.handleEscrowDateError.bind(this)} color="primary" autoFocus>
                            Ok
                        </Button>
                    </DialogActions>
                </Dialog>
                {this.state.openReminderDialog && <ReminderPropertyDialog handleReminderClose={() => {
                    this.setState({ openReminderDialog: false })
                }}
                    handleReminderAccept={(event) => {
                        this.setState({ openReminderDialog: false });
                        this.handleSubmit(event);
                    }}
                />}
                <CRUD
                    userData={this.props.userData}
                    ownDealsOnly={ownDealsOnly}
                    originalData={data}
                    tabsData={this.getTabs({ data, loanQuotesData, seller, edit, isReferral, isFinancing, isStriveFinancing, isStriveClosed, isOtherFinancing, ownDealsOnly, isExtraPayment })}
                    currentPageRef={this.currentPageRef}
                    drawer={
                        <Drawer
                            isOpen={this.state.showDrawer}
                            shouldDisplayChildDrawer={true}
                            reff={this.drawerComponentRef}
                            closeDrawer={this.closeDrawer}
                        >
                            {this.getDrawerComponent()}
                        </Drawer>
                    }
                    backLink={this.propertiesList()}
                    onBack={this.cameFromParcelMap() ? () => browserHistory.push(this.propertiesList()) : null}
                    edit={edit}
                    state={this.state}
                    setState={this.setState.bind(this)}
                    handleSubmit={this.isPropertyExists}
                    saveData={this.saveData}
                    extraHeaderInfo={
                        <div className="CRUD_content_header-meta">
                            {
                                !isReferral && !isExtraPayment && (
                                    isFinancing ?
                                        <Dropdown
                                            className="CRUD_content_status"
                                            viewClassName="CRUD_content_status_view"
                                            data={data}
                                            isFromProperty
                                            optionsType='status-financing'
                                            value={data && data.HSC_STATUS}
                                            valueKey="HSC_STATUS"
                                            disabled={isFieldLocked(locks, 'HSC_STATUS')}
                                            handleParentChange={this.handleChangeDropdown}
                                            viewMode={this.state.viewMode}
                                            deleted={this.state.deleted}
                                        />
                                        :
                                        <Dropdown
                                            className="CRUD_content_status"
                                            viewClassName="CRUD_content_status_view"
                                            optionKey='code'
                                            optionLabelKey='code'
                                            data={data}
                                            isFromProperty
                                            optionsType='status'
                                            value={data && data.STATUS}
                                            valueKey="STATUS"
                                            disabled={isFieldLocked(locks, 'STATUS')}
                                            handleParentChange={this.handleChangeDropdown}
                                            viewMode={this.state.viewMode}
                                            deleted={this.state.deleted}
                                        />
                                )
                            }
                            {
                                recomputePayments && <span className="CRUD_content_label">Recomputing Payment</span>
                            }
                        </div>
                    }
                    extraInfo={
                        edit && data ? (
                            <div className="CRUD_content_info">
                                <div>
                                    Date created: <span>{data.DATE_CREATED}</span>
                                </div>
                                <div>
                                    Created by: <span>{data.CREATED_BY}</span>
                                </div>
                                {data.STATUS == "Proposal" ?
                                    <div>
                                        Proposal Date: <span>{data.PROPOSAL_DATE}</span>
                                    </div> : null}
                                <div>
                                    Last modified: <span>{data.LAST_MODIFIED_DATE}</span>
                                </div>
                                <div>
                                    Modified by: <span>{data.LAST_MODIFIED_BY}</span>
                                </div>
                            </div>
                        ) : null
                    }
                    type="property"
                    backName="PROPERTIES"
                    title={data && `${data.NAME} - ${data.CITY ? data.CITY : ''}, ${data.STATE ? data.STATE : ''}`}
                    hideActions={locks.readOnly}
                    hideDelete={isFieldLocked(locks, 'DELETED')}
                    readOnlyNotice={edit ? locks.readOnlyReason : null}
                    forceActions={everySummit || this.canSeniorAgentEdit()}
                    formattedOriginalData={convertDataToForm(this.state.original)}
                    onCancel={this.discardPendingLoanQuoteDeletes}
                    formattedLoanQuotesOriginalData={{ name: 'loanQuotesData', data: cloneDeep(this.state.originalLoanQuotesData) }}
                    formattedPaymentsOriginalData={{ name: 'propertyPaymentsData', data: cloneDeep(this.state.originalPaymentsData) }}
                    formattedProposalOriginalData={cloneDeep(this.state.proposalDataOriginal)}
                >
                    {this.state.financialsSpreadsheetInView ? (
                        <Financials
                            location={this.props.location}
                            data={data}
                            propsalData={this.state.proposalData}
                            newPropertyId={this.state.newPropertyId}
                            allTenantsById={this.state.allTenantsById}
                            parentSetData={this.setDataFromFinancials}
                            email={email}
                            close={this.closeFinancialsSpreadsheet}
                            readOnlySnapshot={locks.financialsReadOnly}
                        />
                    ) : null}
                    {this.state.historyFinancialsInView ? (
                        <Financials
                            location={this.props.location}
                            data={this.state.historyFinancialsData}
                            propsalData={this.state.proposalData}
                            newPropertyId={null}
                            allTenantsById={this.state.allTenantsById}
                            parentSetData={() => null}
                            email={email}
                            close={this.closeHistoryFinancialsSpreadsheet}
                            historySnapshot={this.state.historyFinancialsSnapshot}
                            readOnlySnapshot
                        />
                    ) : null}
                    {this.renderHistoryTabModal()}
                    <Modal show={!!this.state.historyPartialModalOpen} onClose={this.closeHistoryPartialModal} className="history-partial-modal">
                        {this.state.historyPartialData && (() => {
                            const d = this.state.historyPartialData;
                            return (
                                <div className="history-partial-financials">
                                    <div className="history-partial-financials__header">
                                        <h3>Historical Financials Summary</h3>
                                        <p className="history-partial-financials__note">This record was created before detailed financial snapshots were available. Only summary data is shown.</p>
                                    </div>
                                    <div className="history-partial-financials__grid">
                                        {d.STATUS && <div className="history-partial-financials__item"><span className="history-partial-financials__label">Status</span><span className="history-partial-financials__value">{d.STATUS}</span></div>}
                                        {d.DATE && <div className="history-partial-financials__item"><span className="history-partial-financials__label">Date</span><span className="history-partial-financials__value">{d.DATE}</span></div>}
                                        {d.PRICE && <div className="history-partial-financials__item"><span className="history-partial-financials__label">Price</span><span className="history-partial-financials__value">{dollars(d.PRICE)}</span></div>}
                                        {d.CAP_RATE && <div className="history-partial-financials__item"><span className="history-partial-financials__label">Cap Rate</span><span className="history-partial-financials__value">{percent(d.CAP_RATE, 2)}</span></div>}
                                        {d.NET_OPERATING_INCOME && <div className="history-partial-financials__item"><span className="history-partial-financials__label">NOI</span><span className="history-partial-financials__value">{dollars(d.NET_OPERATING_INCOME)}</span></div>}
                                        {d.PRICE_PER_SQFT && <div className="history-partial-financials__item"><span className="history-partial-financials__label">Price/Sq Ft</span><span className="history-partial-financials__value">{dollars(d.PRICE_PER_SQFT, true)}</span></div>}
                                        {d.BASE_RENT && <div className="history-partial-financials__item"><span className="history-partial-financials__label">Base Rent</span><span className="history-partial-financials__value">{dollars(d.BASE_RENT)}</span></div>}
                                        {d.RENT_PER_SQFT && <div className="history-partial-financials__item"><span className="history-partial-financials__label">Rent/Sq Ft</span><span className="history-partial-financials__value">{dollars(d.RENT_PER_SQFT, true)}</span></div>}
                                        {d.VACANCY && <div className="history-partial-financials__item"><span className="history-partial-financials__label">Occupancy</span><span className="history-partial-financials__value">{percent(d.VACANCY, 2)}</span></div>}
                                    </div>
                                    <div className="history-partial-financials__footer">
                                        <button type="button" className="button-new" onClick={this.closeHistoryPartialModal}>Close</button>
                                    </div>
                                </div>
                            );
                        })()}
                    </Modal>
                </CRUD>
            </React.Fragment>
        );
    }
}
